export const es = {
  Enums: {
    ProcessType: {
      MassCommand: 'Comando Masivo',
      MassMeterRegistration: 'Importación Masiva de Medidores',
      MassMeterEdit: 'Edición Masiva de Medidores',
      ExportBillings: 'Facturación de Lecturas',
      ScheduleRecoverMassMemorySmc: 'Recuperación Programada de Memoria Masiva SMC',
      ScheduledCommand: 'Comando Programado',
      MassLicenseRemoval: 'Remoción de Puntos de la Licencia',
    },
    maxPhaseUnbalanceCurve: 'Curva de Desbalance de Fase Máximo',
    AccountStatus: {
      DISABLED: 'Desactivado',
      ACTIVATED: 'Activado',
      NO_RELE: 'Sin Relé',
      NO_INFORMATION: 'Sin Información',
      maxPhaseUnbalanceCurve: 'Curva de Desbalance de Fase Máximo',
      ALL: 'Todo',
    },
    MeterPhase: {
      Monofasico: 'Monofásico',
      Bifasico: 'Bifásico',
      Trifasico: 'Trifásico',
    },
    TicketStatus: {
      Cancelled: 'Cancelado',
      CommandTimeOutReached: 'Tiempo de Ejecución Excedido',
      Executing: 'Ejecutando',
      Failed: 'Falló',
      FailedToContinue: 'Error durante el procesamiento',
      FailedToStart: 'Falla al inicializar',
      Finished: 'Ejecutado con Éxito',
      Success: 'Ejecutado con Éxito',
      Interupted: 'Interrumpido',
      MiddleWareOffline: 'MiddleWare Offline o No Disponible',
      MiddlewareNotResponding: 'Sin respuesta del MiddleWare',
      PartiallyFinished: 'Finalizado Parcialmente',
      Waiting: 'Esperando',
      WaitingScheduleDateTime: 'Esperando fecha y hora programada',
      SystemTimeout: 'Tiempo del sistema Excedido',
      Timeout: 'Tiempo de Solicitud Excedido',
      OutsideAllowedTime: 'Período no permitido',
      SemLicenca: 'Medidor sin licencia',
    },
    StatusCommand: {
      DATA_BLOCK_UNAVAILABLE: 'Bloque de datos no disponible',
      DAT_BLOCK_NUMBER_INVALID: '¡Número de bloque inválido!',
      HARDWARE_FAULT: 'Falla de Hardware',
      INCOMPLETE: 'Incompleto',
      INCORRECT_KEYS: 'Claves Incorrectas',
      INTERRUPTED_BY_COMMISSIONING: 'Interrumpido por comisionamiento',
      INVALID_ITEM: 'Ítem inválido',
      LONG_GET_ABORTED: 'Get Long Abortado',
      LONG_SET_ABORTED: 'Set Long Abortado',
      METERS_NOT_MATCH_WITH_RECEIVED: 'Lista de medidores inválida',
      NO_LONG_GET_IN_PROGRESS: 'Ningún Get Long en progreso',
      NO_LONG_SET_IN_PROGRESS: 'Ningún Set Long en progreso',
      OBJECT_CLASS_INCONSISTENT: 'Clase del Objeto Inconsistente',
      OBJECT_UNAVAILABLE: 'Objeto no disponible',
      OBJECT_UNDEFINED: 'Objeto Indefinido',
      OPEN_DOOR: 'Puerta Abierta',
      OTHER_REASON: 'Otras Razones',
      READ_WRITE_DENIED: 'Lectura o Escritura Denegada',
      SCOPE_OF_ACCESS_VIOLATED: 'Violación del Alcance de Acceso',
      SET_INTERVAL_OF_LONG_OUT_VOLTAGE: 'Configuración del Intervalo de Captura de Long Out Event',
      SET_INTERVAL_OF_QEE: 'Configuración del Intervalo de Captura de DRP/DRC',
      SET_STANDARD_FROZEN_DATA: 'Configuración de la Plantilla de Energía estándar',
      SUCESS: 'Ejecutado con Éxito',
      TEMPORARY_FAILURE: 'Falla Temporal',
      TIMEOUT: 'Tiempo Máximo de Ejecución Alcanzado',
      SYSTEMTIMEOUT: 'Tiempo de Ejecución Excedido',
      TYPE_UNMATCHED: 'Tipo Inconsistente',
      WAITING: 'Esperando Respuesta',
      EXECUTING: 'Ejecutando',
      NO_COMISSIONED: 'Comisión no registrada',
      SCHEDULED: 'Programado',
      SENT: 'Enviado',
      FINISHED: 'Finalizado',
      CANCELLED: 'Cancelado',
      SUCCESS: 'Ejecutado con éxito',
      COMMUNICATIONERROR: 'Error de comunicación',
      EXECUTIONERROR: 'Error de ejecución',
      INTERNALERROR: 'Error interno',
      INVALID_METERS: 'Medidor(es) inválido(s)',
      ACKNOWLEDGMENT: 'Reconocimiento simple',
      INVALID_SCHEMA: 'Formato de solicitud inválido',
      DATA_UNAVAILABLE: 'Datos no disponibles',
      NOT_SUPPORTED: 'Funcionalidad no soportada',
      INVALIDMETER: 'Medidor inválido',
      CUT_AT_IMPROPER_TIME: 'Period not allowed',
    },
    CommandType: {
      DisableCollectiveCut: 'Autorizar Apertura de Puertas',
      EnableCollectiveCut: 'Desactivar Apertura de Puerta',
      GetQEEIndicator: 'Solicitar parámetros de calidad',
      GetVoltageOutLong: 'Obtener Alarma Voltage Out Long',
      GetVoltageOutShort: 'Obtener Alarma Voltage Out Short',
      ImportFrozenData: 'Importar Totalizadores de Energía',
      ImportMassMemory: 'Importar Memoria de Masa',
      ImportQEEIndicator: 'Importar Parámetros de Calidad',
      ImportVoltageOutAlarm: 'Importar Alarmas de Voltage Out',
      InstantMeasure: 'Solicitar Energía Instantánea',
      ListMetersSmcSerial: 'Solicitar Medidores del SMC',
      MarkAlarmAsRead: 'Marcar Alarma Como Leída',
      MeterAddedToSmc: 'Agregar medidor al smc (Sistema)',
      MeterRemovedFromSmc: 'Remover medidor del smc (Sistema)',
      NicReset: 'Reset de la NIC',
      RecoverEventQeeIndicator: 'Recuperar indicadores de calidad',
      RecoverFrozenData: 'Recuperar Totalizadores de Energía',
      RecoverGbtMessage: 'GBT',
      RecoverMassMemory: 'Recuperar Memoria de Masa',
      RelayOff: 'Desactivar el Relé',
      RelayOn: 'Activar el Relé',
      RelayOnAllMetersOfSmc: 'Reconectar Todos los Clientes',
      RelayStatus: 'Obtener estado del Relé',
      SmiInfoRequest: 'Obtener información del medidor',
      RequestDoorStatus: 'Obtener Estado del Corte Colectivo',
      RequestRelayStatusAllSmc: 'Solicitar Estado del Relé de Todos los Medidores',
      Rollback: 'Rollback',
      SendKeyAk: 'Envío de Claves de autenticación para los medidores',
      SendKeyEk: 'Envío de Claves de cifrado para los medidores',
      GetCellIDAndIP: 'Obtener Cell ID e IP',
      SetDatetime: 'Establecer Fecha y Hora del SMC',
      SetIntervalOLongOutEvent: 'Configuración del Intervalo de Captura de Long Out Event',
      SetIntervalOfQee: 'Configuración del Intervalo de Captura de DRP/DRC',
      SetStandardFrozenData: 'Configuración de la Plantilla de Energía estándar',
      Set_Current: 'Modificar corriente de corte',
      UpdateDateTime: 'Actualizar Fecha y Hora',
      ReadDateTime: 'Lectura Fecha y Hora',
      UplinkPeriod: 'Cambiar Período de Lectura de Uplink',
      DoorStatusAbsolute: 'Obtener estado de la puerta',
      SetSmiVoltage: 'Establecer tensión de referencia',
      SetDisplayConfiguration: 'Establecer Configuración de Display Auto',
      SetDisplayConfigurationManual: 'Establecer Configuración de Display Manual',
      SetDisplayConfigurationMicromax: 'Establecer Configuración de Display Auto MicroMax',
      SetDisplayConfigurationManualMicromax: 'Establecer Configuración de Display Manual MicroMax',
      GetSmiVoltage: 'Obtener tensión de referencia',
      MeterRecoverEventQeeIndicator: 'Recuperar Parámetros de Calidad',
      SetQualityMeasureParams: 'Recuperar Parámetros de Calidad',
      GetQeeBuffer: 'Obtener buffer Qee',
      GetEnergyTotalizer: 'Solicitar Energía Activa Directa',
      MassRegistration: 'Registro en Masa',
      MassEdit: 'Edición en Masa',
      ChangeNetworkType: 'Cambiar tipo de red',
      GetNetworkType: 'Obtener tipo de red',
      GetNetworkInfo: 'Obtener tipo de tecnología',
      GetHeartBeatCommand: 'Recuperar calidad de señal',
      AlterarTotalLicenca: 'Cambiar total de puntos de la licencia',
      RemoverPontoLicenca: 'Quitar punto de la licencia',
      RestaurarPontoLicenca: 'Restaurar punto de la licencia',
      AlterarAtivacaoLicenca: 'Activar o desactivar la licencia',
      ChangeNetworkTech: 'Cambiar tipo de tecnología',
      GetDaylightSavingsEnabled: 'Obtener estado horario de verano',
      GetDaylightSavingsEnd: 'Obtener final horario de verano',
      GetDaylightSavingsDeviation: 'Obtener alteración horario de verano',
      GetDaylightSavingsBegin: 'Obtener inicio horario de verano',
      GetSpecialDaysTable: 'Obtener días festivos',
      SetSpecialDaysTable: 'Agregar días festivos',
      DeleteSpecialDays: 'Eliminar días festivos',
      GetDmrcSwitch: 'Solicitar switch DMRC y UFER',
      SetDmrcSwitch: 'Establecer switch DMRC y UFER',
      SetDayPassiveActivityCalendar: 'Agregar día calendario pasivo',
      SetWeekPassiveActivityCalendar: 'Agregar semana calendario pasivo',
      ActivatePassiveTimeCalendarActivityCalendar: 'Agregar tiempo para activación',
      SetDayProfilePassiveCalendarActivityCalendar: 'Agregar día calendario pasivo DMRC',
      DrmcSetWeekProfilePassiveCalendarActivityCalendar: 'Agregar semana calendario pasivo DMRC',
      DrmcGetDayProfilePassiveActivityCalendar: 'Solicitar días del calendario pasivo DMRC',
      DrmcGetActivatePassiveTimeCalendarActivityCalendar:
        'Solicitar tiempo de activación calendario pasivo DMRC',
      GetActivatePassiveTimeCalendarActivityCalendar:
        'Solicitar tiempo de activación calendario pasivo',
      GetWeekProfilePassiveActivityCalendar: 'Solicitar semana del calendario pasivo',
      GetWeekProfileActiveActivityCalendar: 'Solicitar semana del calendario activo',
      GetDayProfileActiveActivityCalendar: 'Solicitar días del calendario activo',
      GetDayProfilePassiveActivityCalendar: 'Solicitar días del calendario pasivo',
      DrmcGetWeekProfileActiveActivityCalendar: 'Solicitar semana del calendario activo DMRC',
      DrmcGetWeekProfilePassiveActivityCalendar: 'Solicitar semana del calendario pasivo DMRC',
      DrmcGetDayProfileActiveActivityCalendar: 'Solicitar días del calendario activo DMRC',
      DrmcActivatePassiveTimeCalendarActivityCalendar: 'Agregar tiempo para activación DMRC',
      SetActivatePassiveCalendarActivityCalendar: 'Definir estado de perfil DMRC',
      ActivatePassiveCalendarActivityCalendar: 'Definir estado de perfil',
      SetDaylightSavingsEnabled: 'Definir estado horario de verano',
      SetDaylightSavingsDeviation: 'Definir alteración horario de verano',
      SetDaylightSavingsBegin: 'Definir inicio horario de verano',
      SetDaylightSavingsEnd: 'Definir final horario de verano',
      GetTaxPage: 'Recuperar Página Fiscal',
      GetDemandRegisters: 'Recuperar registradores',
      GetGeneralReadingValues: 'Recuperar lecturas',
      DeactivateMeter: 'Desactivar medidor',
      AddMeterToGateway: 'Agregar Medidor al Gateway',
      RemoveMeterFromGateway: 'Remover Medidor del Gateway',
      ListMetersFromGateway: 'Listar Medidores del Gateway',
      ReadDisplayConfiguration: 'Solicitar Configuración de Display',
      ReadDatetime: 'Lectura de Fecha y Hora',
      GetDailyBilling: 'Obtener Facturación Diaria',
      GetLoadProfile: 'Obtener Perfil de Carga',
      GetFiscalPage: 'Obtener Página Fiscal',
      ReprocessBilling: 'Reprocesar Facturación',
      ReprocessCutRelay: 'Reprocesar Corte/Reconexion',
      ReprocessDetailUc: 'Reprocesar Detalles de la Unidad de Consumo',
      VoltageInterruptionMonthly: 'Obtener Interrupción de Tensión Mensual',
      DrpDrcMonthly: 'Obtener DRP/DRC Mensual',
      DrpDrcCycle: 'Obtener DRP/DRC Semanal',
      SetTariffConfiguration: 'Definir Tipo de Tarifa',
      DeviceReset: 'Reinicio de dispositivo',
      RecoverMonitoring: 'Perfil de Carga (Energía + Memoria de Masa)',
      InfoRequest: 'Solicitar información general',
      RequestConfiguration: 'Solicitar configuración',
      GetBlockSize: 'Obtener Tamaño del Bloque',
      ImageTransferInitiate: 'Iniciar Transferencia de Imagen',
      ImageTransferData: 'Datos de Transferencia de Imagen',
      GetFirstBlockNotTransferred: 'Obtener Primer Bloque No Transferido',
      ImageTransferVerify: 'Verificar Transferencia de Imagen',
      ImageTransferActivate: 'Activar Transferencia de Imagen',
      UpdateFirmware: 'Actualizar Firmware',
      UploadFirmware: 'Cargar Firmware',
      GetHardwareInfo: 'Obtener Información de Hardware',
      ReadNicInfo: 'Leer Información del NIC',
      ReadNicSetup: 'Leer Configuración del NIC',
      ReadRelay: 'Leer Relé',
      ReadTimestamp: 'Leer Timestamp',
      ReadNicData: 'Leer Datos del NIC',
      NicSetup: 'Configuración del NIC',
      ReadLdrUpper: 'Leer LDR Superior',
      ReadLdrBottom: 'Leer LDR Inferior',
      ReadLdrMin: 'Leer LDR Mínimo',
      SetLdrUpper: 'Definir LDR Superior',
      SetLdrBottom: 'Definir LDR Inferior',
      SetLdrMin: 'Definir LDR Mínimo',
      ReadNicSerial: 'Leer Serial del NIC',
      ReadRelayWithLastSwitchOn: 'Leer Relé con Último Encendido',
      ReadRelayWithLastSwitchOnAndOff: 'Leer Relé con Último Encendido y Apagado',
      SetBlockSize: 'Definir Tamaño del Bloque',
      MulticastGroupSetup: 'Configuración de Grupo Multicast',
      MulticastClassCSession: 'Sesión Multicast Clase C',
      MulticastSetupConfirmation: 'Confirmación de Configuración Multicast',
      ImageTransferStatus: 'Estado de la Transferencia de Imagen',
      GetFirmwareVersion: 'Obtener Versión del Firmware',
      ReadAlarmFakeOnOff: 'Leer Alarma Falsa On/Off',
      ConfigureApplicationGroup: 'Configurar Grupo de Aplicación',
      ReadALarmLastGasp: 'Leer Alarma de Último Suspiro',
      SetLastGaspVoltageLevel: 'Definir Nivel de Tensión de Último Suspiro',
      ReadAlarmVoltageMonitor: 'Leer Monitor de Tensión de Alarma',
      SetVoltageMinimalInterval: 'Definir Intervalo Mínimo de Tensión',
      SetAlarmFakeOnOffThreshold: 'Definir Umbral de Alarma Falsa On/Off',
      ReadTemperatureValue: 'Leer Valor de Temperatura',
      ReadRelayWithDelay: 'Leer Relé con Retraso',
      DeviceCreated: 'Dispositivo creado',
      DeviceUpdated: 'Dispositivo actualizado',
      ScheduleCreated: 'Programación creada',
      scheduleUpdated: 'Programación actualizada',
      groupCreated: 'Grupo creado',
      groupUpdated: 'Grupo actualizado',
      setAlarmFakeOnOff: 'Alarma On/Off',
      scheduleCanceled: 'Programación cancelada',
      scheduleDeleted: 'Programación eliminada',
      deviceDeleted: 'Dispositivo eliminado',
      groupDeleted: 'Grupo eliminado',
      checkScheduleStatus: 'Verificar estado de la programación',
      activateSchedule: 'Activar programación',
      deactivateSchedule: 'Desactivar programación',
      checkScheduleExist: 'Verificar si existe la programación',
      readDeviceType: 'Leer tipo de dispositivo',
      writeDeviceRole: 'Asignar tipo de dispositivo',
      fullScheduleCommand: 'Comando de programación completo',
      scheduleCreatedOnSystem: 'Programación creada (Sistema)',
      activateScheduleOnSystem: 'Activar programación (Sistema)',
      checkScheduleStatusOnSystem: 'Verificar estado de la programación (Sistema)',
      writeDeviceRoleOnSystem: 'Asignar tipos de dispositivo (Sistema)',
      deactivateScheduleOnSystem: 'Desactivar programación (Sistema)',
      checkScheduleExistOnSystem: 'Verificar si existe la programación (Sistema)',
      readDeviceTypeOnSystem: 'Leer tipo de dispositivo (Sistema)',
      setDatetimeOnSystem: 'Actualizar Fecha y Hora (Sistema)',
      periodicConfiguration: 'Configuración de Periodicidad',
      decommissioning: 'Desmantelamiento',
      openSession: 'Abrir Sesión con Medidor',
      readMeterSerial: 'Leer Serial del Medidor',
      importMassMeters: 'Importar medidores en masa',
      saveConfig: 'Guardar configuración',
      readConfig: 'Leer configuración',
      saveTime: 'Guardar fecha y hora',
      timeCorrection: 'Corrección de hora',
      storage: 'Almacenamiento',
      fuotaPause: 'Pausa de actualización de firmware',
      deleteSpecialDays: 'Eliminar días festivos',
      getTotalizers: 'Leer totalizadores',
      getRelayStatusControl: 'Leer Estado de Control del Relé',
      setRelayStatusControl: 'Cambiar Estado de Control del Relé',
      getIntegrationInstantaneousReadings: 'Leer valores instantáneos',
      getVoltageOutLongShort: 'Obtener Alarma de Voltage Out Larga y corta',
      relayStatusOrca: 'Recuperar estado del relé orca',
      getQeeOnDemand: 'Solicitar parámetros de calidad por demanda',
      getQeeHistoricalData:
        'Solicitar el historial de lectura de datos de los parámetros de calidad',
      getLoadProfile: 'Leer datos de Memoria de masa',
      getDailyBilling: 'Leer datos de Energía',
      recoverFragmentedPacket: 'Recuperar datos fragmentados',
      drpDrcEventLog: 'Registro de eventos DRP y DRC',
      readTariffPeriods: 'Obtener Lectura de Tarifa',
      smartFuseAlarmAck: 'Alarma Ack',
      ImportAlarms: 'Importar Alarmas',
    },
    ServiceTypeEquatorial: {
      TurnOnPower: 'Reconectar',
      TurnOffPower: 'Corte',
      RequestRead: 'Solicitud de Lectura',
      RequestNoteLq: 'Solicitud de QEE',
    },
    RequestStatusEquatorial: {
      Waiting: 'Esperando',
      Processing: 'Procesando',
      Running: 'En Ejecución',
      CommunicationWithMDCFailed: 'Falla en la Comunicación con MDC',
      InternalFailure: 'Falla Interna',
      MDCTicketFinalized: 'Ticket MDC Finalizado',
      MDCTicketFailed: 'Ticket MDC Falló',
      FinishedWithSuccess: 'Finalizado con Éxito',
      FinishedWithFailure: 'Finalizado con Falla',
      Cancelled: 'Cancelado',
    },
    CommandStatus: {
      CHANGING_COLLECTIVE_CUT_ALARM: 'Cambiando el estado de corte Colectivo',
      CHANGING_RELAY_STATUS: 'Cambiando Estado del Relé',
      GBT: 'GBT',
      GET_QEE_INDICATORS: 'Solicitando parámetros de calidad',
      INSTANT_MEASURE: 'Solicitando medida Instantánea',
      MARK_ALARM_AS_READ: 'Marcando Alarma Como Leída',
      NIC_RESET: 'Reset de la NIC',
      RECOVER_EVENT_QEE_INDICATOR: 'Recuperando parámetros de calidad',
      RECOVER_FROZEN_DATA: 'Recuperando Totalizadores de Energía',
      RECOVER_MASS_MEMORY: 'Recuperando Memoria de Masa',
      REGISTERING_DATETIME: 'Registrando Fecha y Hora',
      REGISTERING_KEYS: 'Registrando Claves',
      RELAY_ON_ALL_METERS_SMC: 'Reconectando todos los clientes',
      REQUESTING_DATE: 'Solicitando Fecha',
      REQUESTING_RELAY_STATUS: 'Solicitando Estado del Relé',
      REQUESTING_RELAY_STATUS_ALL_SMC: 'Solicitando estado de los relés',
      REQUESTING_SERIAL: 'Solicitando Serial',
      REQUEST_DOOR_STATUS: 'Obteniendo Estado del corte colectivo',
      ROLLBACK: '¡Ejecutando RollBack!',
      SET_CURRENT: 'Modificando corriente de corte',
      SET_INTERVAL_OF_LONG_OUT_VOLTAGE: 'Configurando Intervalo de Captura de Long Out',
      SET_INTERVAL_OF_QEE: 'Configurando Intervalo de Captura de DRP/DRC',
      SET_STANDARD_FROZEN_DATA: 'Configurando Plantilla de Energía estándar',
      UPLINK_PERIOD: 'Cambiando Período de Uplink de lectura',
      WAITING_COMMAND: 'Esperando Comando',
      SET_SMI_VOLTAGE: 'Configurando tensión de referencia',
      GET_VOLTAGE: 'Solicitando tensión de referencia',
      DOOR_STATUS_ABSOLUTE: 'Obteniendo estado de la puerta',
      SET_DISPLAY_CONFIGURATION: 'Configurando display auto',
      SET_DISPLAY_CONFIGURATION_MANUAL: 'Configurando display manual',
      METER_SET_QUALITY_MEASURE_PARAMS: 'Recuperando Parámetros de Calidad',
      METER_RECONVER_EVENT_QEE_INDICATOR: 'Recuperando Parámetros de Calidad',
      GET_QEE_BUFFER: 'Obteniendo tamaño del Buffer Qee',
      GET_ENERGY_TOTALIZER: 'Obteniendo Energía Activa Directa',
      CHANGING_NETWORK_TYPE: 'Cambiando tipo de Red',
      GETTING_NETWORK_TYPE: 'Obteniendo tipo de Red',
    },
    ComunicationStatus: {
      BUSY: 'Ocupado',
      COMMUNICATION_FAILED: 'Falla de Comunicación',
      NO_INFORMATION: 'Sin Información',
      SUCCESS: 'Éxito',
    },
    tariffsType: {
      tariff: 'Tarifa',
      IRRIGANTE: 'Irrigante',
      TARIFA_BRANCA: 'Tarifa Blanca',
      GD: 'Generación Distribuida',
      IRRIGANTE_GD: 'Irrigante Generación Distribuida',
      TARIFA_BRANCA_GD: 'Tarifa Blanca Generación Distribuida',
      CONVENCIONAL: 'Convencional',
      CONVENCIONAL_GD: 'Convencional Generación Distribuida',
      MMGD: 'MMGD',
      REN871: 'REN871',
      GRUPO_B_IRRIGANTE: 'Grupo B Irrigante',
      GRUPO_A: 'Grupo A',
      CLIENTE_LIVRE: 'Cliente Libre',
      TARIFA_BRANCA_MMGD: 'Tarifa Blanca + MMGD',
      TARIFA_BRANCA_MMGD_IRRIGANTE: 'Tarifa Blanca + MMGD + Irrigante',
      GRUPO_A_IRRIGANTE: 'Grupo A Irrigante',
    },
    MeterTypes: {
      Integration: 'Integración',
      IntegrationDcu: 'Integración Wasion DCU',
      Nepen: 'Integración MDX',
      IntegrationWirepas: 'Integración Wirepas',
    },
    CceeIntegrationMethod: {
      placeholder: 'Seleccione el método de integración CCEE',
      None: 'Ninguno',
      Soap: 'SOAP',
      Rest: 'REST',
    },
    AlarmDescription: {
      POWER_RESTORE: 'Energía restaurada',
      TERMINAL_COVER_REMOVED_START: 'Inicio de remoción de tapa de terminales',
      TERMINAL_COVER_REMOVED_END: 'Fin de remoción de tapa de terminales',
      CURRENT_REVERSAL_L1_START: 'Inicio de inversión de corriente L1',
      CURRENT_REVERSAL_L1_END: 'Fin de inversión de corriente L1',
      MAGNETIC_FIELD_DETECTION_START: 'Inicio de detección de campo magnético',
      MAGNETIC_FIELD_DETECTION_END: 'Fin de detección de campo magnético',
      METER_COVER_OPEN: 'Tapa del medidor abierta',
      METER_COVER_CLOSE: 'Tapa del medidor cerrada',
      METER_AUTHENTICATION_FAILS: 'Falla de autenticación del medidor',
      PRESENCE_OF_VOLTAGE_AT_LOAD_SIDE_START:
        'Inicio de presencia de tensión en el lado de la carga',
      PRESENCE_OF_VOLTAGE_AT_LOAD_SIDE_END: 'Fin de presencia de tensión en el lado de la carga',
      FIRMWARE_UPGRADE: 'Actualización de firmware',
      DISCONNECT: 'Desconexión',
      CONNECT: 'Conexión',
      CURRENT_REVERSAL_L2_START: 'Inicio de inversión de corriente L2',
      CURRENT_REVERSAL_L2_END: 'Fin de inversión de corriente L2',
      CURRENT_REVERSAL_L3_START: 'Inicio de inversión de corriente L3',
      CURRENT_REVERSAL_L3_END: 'Fin de inversión de corriente L3',
      MISSING_VOLTAGE_L1_START: 'Inicio de ausencia de tensión L1',
      MISSING_VOLTAGE_L1_END: 'Fin de ausencia de tensión L1',
      MISSING_VOLTAGE_L2_START: 'Inicio de ausencia de tensión L2',
      MISSING_VOLTAGE_L2_END: 'Fin de ausencia de tensión L2',
      MISSING_VOLTAGE_L3_START: 'Inicio de ausencia de tensión L3',
      MISSING_VOLTAGE_L3_END: 'Fin de ausencia de tensión L3',
      UNDER_VOLTAGE_L1_START: 'Inicio de subtensión L1',
      UNDER_VOLTAGE_L1_END: 'Fin de subtensión L1',
      UNDER_VOLTAGE_L2_START: 'Inicio de subtensión L2',
      UNDER_VOLTAGE_L2_END: 'Fin de subtensión L2',
      UNDER_VOLTAGE_L3_START: 'Inicio de subtensión L3',
      UNDER_VOLTAGE_L3_END: 'Fin de subtensión L3',
      OVER_VOLTAGE_L1_START: 'Inicio de sobretensión L1',
      OVER_VOLTAGE_L1_END: 'Fin de sobretensión L1',
      OVER_VOLTAGE_L2_START: 'Inicio de sobretensión L2',
      OVER_VOLTAGE_L2_END: 'Fin de sobretensión L2',
      OVER_VOLTAGE_L3_START: 'Inicio de sobretensión L3',
      OVER_VOLTAGE_L3_END: 'Fin de sobretensión L3',
    },
  },
  NetworkManagement: {
    tables: {
      signalQualityTitle: 'Historial de Calidad de Señal',
      commandsPacketsTitle: 'Historial de Paquetes de Comando',
      status: 'Estado del Comando',
      commandType: 'Tipo de Comando',
      lastUpdate: 'Última Actualización',
      serial: 'Serial',
      commandsPackagesHistory: 'Historial de Paquetes de Comando',
      executeNetworkCommands: 'Ejecutar Comandos de Red',
    },
    map: {
      tooltip: 'Leyenda de Señal',
      noSignal: 'Sin Señal',
      poorSignal: 'Muy Débil',
      fairSignal: 'Débil',
      regularSignal: 'Regular',
      goodSignal: 'Bueno',
      excellentSignal: 'Excelente',
    },
    errors: {
      fetchCommandsPackagesHistoryError: 'Error al obtener historial de paquetes de comando',
      fetchSignalQualityHistoryError: 'Error al obtener historial de calidad de señal',
      fetchMetersError: 'Error al obtener medidores',
    },
    general: {
      NoSentPackages: 'Ningún Paquete Enviado para este Comando',
      NoReceivedPackages: 'Ningún Paquete Recibido para este Comando',
      NetworkDetails: 'Detalles de la Red de Medidores',
      DailySignalQualityHistory: 'Calidad de Señal',
      SignalQualityHistory: 'Historial de Señal',
      RssiQualityHistory: 'Historial de RSSI',
      commandsPackagesHistory: 'Historial de Comandos de Red',
    },
  },
  ReadingsTable: {
    serial: 'Serial',
    dateTime: 'Fecha y Hora',
    totalEnergy_Wh: 'Totalizador General (kWh)',
    totalActiveEnergy_Wh: 'Energía Activa Total (kWh)',
    totalDirectActiveEnergy_Wh: 'Energía Activa Directa Total (kWh)',
    borderTotalizer_Wh: 'Totalizador de Punta (kWh)',
    reservedTotalizer_Wh: 'Totalizador de Fora de Punta (kWh)',
    offBorderTotalizer_Wh: 'Totalizador de Reservado (kWh)',
    totalIntermediary_Wh: 'Total Intermedio (kWh)',
    apparentPowerA: 'Potencia Aparente A',
    apparentPowerB: 'Potencia Aparente B',
    apparentPowerC: 'Potencia Aparente C',
    reactivePowerA: 'Potencia Reactiva A',
    reactivePowerB: 'Potencia Reactiva B',
    reactivePowerC: 'Potencia Reactiva C',
    generatedEnergyTotal_Wh: 'Energía Generada - Total (kWh)',
    totalReverseActiveEnergy_Wh: 'Energía Activa Reversa Total (kWh)',
    generatedOffBorderEnergyTotal_Wh: 'Energía Generada Fora de Punta (kWh)',
    generatedIntermediaryEnergyTotal_Wh: 'Energía Generada Intermedio (kWh)',
    generatedBorderEnergyTotal_Wh: 'Energía Generada Punta (kWh)',
    generatedReservedEnergyTotal_Wh: 'Energía Generada Reservada (kWh)',
    q1ReactiveEnergy_VarH: 'Energía Reactiva Q1 (kVarH)',
    q2ReactiveEnergy_VarH: 'Energía Reactiva Q2 (kVarH)',
    q3ReactiveEnergy_VarH: 'Energía Reactiva Q3 (kVarH)',
    q4ReactiveEnergy_VarH: 'Energía Reactiva Q4 (kVarH)',
    reactiveEnergyImportQiRi_VarH: 'Energía Reactiva Import QI (+Ri) (kVarH)',
    reactiveEnergyImportQivRc_VarH: 'Energía Reactiva Import QIV (–Rc) (kVarH)',
    phaseAVoltageAverage_V: 'Tensión Media Fase A (V)',
    phaseBVoltageAverage_V: 'Tensión Media Fase B (V)',
    phaseCVoltageAverage_V: 'Tensión Media Fase C (V)',
    lastAverageVoltageL1_V: 'Media de Tensión L1 (V)',
    lastAverageVoltageL2_V: 'Media de Tensión L2 (V)',
    lastAverageVoltageL3_V: 'Media de Tensión L3 (V)',
    phaseACurrentAverage_A: 'Corriente Media Fase A (A)',
    phaseBCurrentAverage_A: 'Corriente Media Fase B (A)',
    phaseCCurrentAverage_A: 'Corriente Media Fase C (A)',
    lastAverageCurrentL1_A: 'Media de Corriente L1 (A)',
    lastAverageCurrentL2_A: 'Media de Corriente L2 (A)',
    lastAverageCurrentL3_A: 'Media de Corriente L3 (A)',
    totalPowerFactor_NoUnit: 'Factor de Potencia Total',
    phaseAVoltageThd_NoUnit: 'THD Tensión Fase A',
    phaseBVoltageThd_NoUnit: 'THD Tensión Fase B',
    phaseCVoltageThd_NoUnit: 'THD Tensión Fase C',
    phaseACurrentThd_NoUnit: 'THD Corrente Fase A',
    phaseBCurrentThd_NoUnit: 'THD Corrente Fase B',
    phaseCCurrentThd_NoUnit: 'THD Corrente Fase C',
    activePowerThd_NoUnit: 'THD Energia Ativa',
    group0DirectEnergy_Wh: 'Grupo 0 Energía Directa (kWh)',
    group0InductiveReactiveDirectEnergy_VArhPlus: 'Grupo 0 Energía Directa (kVArh+)',
    group0CapacitiveReactiveDirectEnergy_VArhMinus: 'Grupo 0 Energía Directa (kVArh–)',
    group1ReverseEnergy_Wh: 'Grupo 1 Energía Reversa (kWh)',
    group1InductiveReactiveReverseEnergy_VArhPlus: 'Grupo 1 Energía Reversa (kVArh+)',
    group1CapacitiveReactiveReverseEnergy_VArhMinus: 'Grupo 1 Energía Reversa (kVArh–)',
    group2VoltageVaH_V: 'Grupo 2 Tensión Va (V)',
    group2VoltageVbH_V: 'Grupo 2 Tensión Vb (V)',
    group2VoltageVcH_V: 'Grupo 2 Tensión Vc (V)',
    group3CurrentIaH_A: 'Grupo 3 Corrente Ia (A)',
    group3CurrentIbH_A: 'Grupo 3 Corrente Ib (A)',
    group3CurrentIcH_A: 'Grupo 3 Corrente Ic (A)',
    group4ThdVoltageVaH_NoUnit: 'Grupo 4 THD Tensión Va',
    group4ThdVoltageVbH_NoUnit: 'Grupo 4 THD Tensión Vb',
    group4AngleUiA_deg: 'Grupo 4 Ángulo Ui A (º)',
    group4AngleUiB_deg: 'Grupo 4 Ángulo Ui B (º)',
    group4AngleUiC_deg: 'Grupo 4 Ángulo Ui C (º)',
    group4ThdVoltageVcH_NoUnit: 'Grupo 4 THD Tensión Vc',
    group5ThdCurrentIaH_NoUnit: 'Grupo 5 THD Corrente Ia',
    group5ThdCurrentIbH_NoUnit: 'Grupo 5 THD Corrente Ib',
    group5ThdCurrentIcH_NoUnit: 'Grupo 5 THD Corrente Ic',
    totalEnergyIncremental_Wh: 'Totalizador General Incremental (kWh)',
    q1ReactiveEnergyIncremental_VarH: 'Energía Reactiva Q1 Incremental (kVarH)',
    q4ReactiveEnergyIncremental_VarH: 'Energía Reactiva Q4 Incremental (kVarH)',
    voltageA: 'Tensión A (V)',
    voltageB: 'Tensión B (V)',
    voltageC: 'Tensión C (V)',
    currentA: 'Corriente A (A)',
    currentB: 'Corriente B (A)',
    currentC: 'Corriente C (A)',
    activePowerA: 'Potencia Activa A (W)',
    activePowerB: 'Potencia Activa B (W)',
    activePowerC: 'Potencia Activa C (W)',
    maximumVoltageA_V: 'Tensión Máxima A (V)',
    maximumVoltageB_V: 'Tensión Máxima B (V)',
    maximumVoltageC_V: 'Tensión Máxima C (V)',
    minimumVoltageA_V: 'Tensión Mínima A (V)',
    minimumVoltageB_V: 'Tensión Mínima B (V)',
    minimumVoltageC_V: 'Tensión Mínima C (V)',
    maximumCurrentA_A: 'Corriente Máxima A (A)',
    minimumVoltageL1_V: 'Tensión Mínima L1 (V)',
    minimumVoltageL2_V: 'Tensión Mínima L2 (V)',
    minimumVoltageL3_V: 'Tensión Mínima L3 (V)',
    totalInductiveReactiveEnergy_VarH: 'Energía Reactiva Inductiva Total (kVarH)',
    totalCapacitiveReactiveEnergy_VarH: 'Energía Reactiva Capacitiva Total (kVarH)',
    reactiveEnergyImportQiiiRi_VarH: 'Energía Reactiva Import QIII (-Ri) (kVarH)',
    reactiveEnergyImportQiiRc_VarH: 'Energía Reactiva Import QII (+Rc) (kVarH)',
    maximumVoltageL1_V: 'Tensión Máxima L1 (V)',
    maximumVoltageL2_V: 'Tensión Máxima L2 (V)',
    maximumVoltageL3_V: 'Tensión Máxima L3 (V)',
    maximumCurrentL1_A: 'Corrente Máxima L1 (A)',
    maximumCurrentL2_A: 'Corrente Máxima L2 (A)',
    maximumCurrentL3_A: 'Corrente Máxima L3 (A)',
    instantaneousVoltageL1_V: 'Tensión Instantánea L1 (V)',
    instantaneousVoltageL2_V: 'Tensión Instantánea L2 (V)',
    instantaneousVoltageL3_V: 'Tensión Instantánea L3 (V)',
    instantaneousCurrentL1_V: 'Corriente Instantánea L1 (A)',
    instantaneousCurrentL2_V: 'Corriente Instantánea L2 (A)',
    instantaneousCurrentL3_V: 'Corriente Instantánea L3 (A)',
    instantaneousActiveImportPowerAPlusL1: 'Potencia Activa Instantánea Import L1 (W)',
    instantaneousActiveExportPowerAMinusL1: 'Potencia Activa Instantánea Export L1 (W)',
    instantaneousReactiveImportPowerRPlusL1: 'Potencia Reactiva Instantánea Import L1 (VAr)',
    instantaneousReactiveExportPowerRMinusL1: 'Potencia Reactiva Instantánea Export L1 (VAr)',
    totalPowerFactorPhaseA_NoUnit: 'Factor de Potencia Fase A',
    totalPowerFactorPhaseB_NoUnit: 'Factor de Potencia Fase B',
    totalPowerFactorPhaseC_NoUnit: 'Factor de Potencia Fase C',
    inductiveDirectIncremental_VarH: 'Incremental Inductivo Directo (kVarH)',
    capacitiveDirectIncremental_VarH: 'Incremental Capacitivo Directo (kVarH)',
    inductiveReverseIncremental_VarH: 'Incremental Inductivo Reverso (kVarH)',
    capacitiveReverseIncremental_VarH: 'Incremental Capacitivo Reverso (kVarH)',
    directActiveEnergyIncremental_Wh: 'Energía Activa Directa Incremental (kWh)',
    reverseActiveEnergyIncremental_Wh: 'Energía Activa Reversa Incremental (kWh)',
    totalAccumulatedImportActiveEnergy: 'Energía Activa Acumulada Total Import (kWh)',
    totalAccumulatedExportActiveEnergy: 'Energía Activa Acumulada Total Export (kWh)',
    averageImportPowerFactorPhaseA: 'Factor de Potencia Medio Import Fase A',
    averageImportPowerFactorPhaseB: 'Factor de Potencia Medio Import Fase B',
    averageImportPowerFactorPhaseC: 'Factor de Potencia Medio Import Fase C',
    instantaneousActivePowerImportPhaseA: 'Potencia Activa Instantánea Import Fase A (kW)',
    instantaneousActivePowerImportPhaseB: 'Potencia Activa Instantánea Import Fase B (kW)',
    instantaneousActivePowerImportPhaseC: 'Potencia Activa Instantánea Import Fase C (kW)',
    instantaneousReactivePowerImportPhaseA: 'Potencia Reactiva Instantánea Import Fase A (kVAr)',
    instantaneousReactivePowerImportPhaseB: 'Potencia Reactiva Instantánea Import Fase B (kVAr)',
    instantaneousReactivePowerImportPhaseC: 'Potencia Reactiva Instantánea Import Fase C (kVAr)',
  },
  FrozenData: {
    serial: 'Serial',
    dateTime: 'Fecha y Hora',
    amrProfileStatus: 'Estado del Perfil AMR',
    borderTotalizer_Wh: 'Energía Activa de Pico (kWh)',
    totalEnergy: 'Energía Activa Total (kWh)',
    totalEnergy_Wh: 'Energía Activa Total (kWh)',
    forderTotalizer_Wh: 'Energía Activa Directa T1 (kWh)',
    reservedTotalizer_Wh: 'Energía Activa Reservada (kWh)',
    offBorderTotalizer_Wh: 'Energía Activa Fuera de Punta (kWh)',
    totalIntermediary_Wh: 'Energía Activa Intermedia (kWh)',
    generatedEnergyTotal_Wh: 'Energía Activa Generada (kWh)',
    totalReverseActiveEnergy_Wh: 'Energía Activa Reversa Total (kWh)',
    generatedOffBorderEnergyTotal_Wh: 'Energía Activa Generada Fuera de Punta (kWh)',
    generatedIntermediaryEnergyTotal_Wh: 'Energía Activa Generada Intermedia (kWh)',
    generatedBorderEnergyTotal_Wh: 'Energía Activa Generada de Pico (kWh)',
    generatedReservedEnergyTotal_Wh: 'Energía Activa Generada Reservada (kWh)',
    positiveReactiveEnergy_Wh: 'Energía Reactiva Positiva (kVArh)',
    negativeReactiveEnergy_Wh: 'Energía Reactiva Negativa (kVArh)',
    totalDirectEnergyTariffC_Wh: 'Totalizador de Energía Activa Directa en Tarifa C (kWh)',
    totalDirectEnergyTariffB_Wh: 'Totalizador de Energía Activa Directa en Tarifa B (kWh)',
    totalDirectEnergyTariffA_Wh: 'Totalizador de Energía Activa Directa en Tarifa A (kWh)',
    totalDirectEnergyTariffD_Wh: 'Totalizador de Energía Activa Directa en Tarifa D (kWh)',
    totalReverseEnergyTariffC_Wh: 'Totalizador de Energía Activa Reversa en Tarifa C (kWh)',
    totalReverseEnergyTariffB_Wh: 'Totalizador de Energía Activa Reversa en Tarifa B (kWh)',
    totalReverseEnergyTariffA_Wh: 'Totalizador de Energía Activa Reversa en Tarifa A (kWh)',
    totalReverseEnergyTariffD_Wh: 'Totalizador de Energía Activa Reversa en Tarifa D (kWh)',
    totalInductiveReactiveEnergy_VarH: 'Energía Reactiva Inductiva Total (kVArh)',
    totalCapacitiveReactiveEnergy_VarH: 'Energía Reactiva Capacitiva Total (kVArh)',
    totalInductiveReactiveEnergyTariffC_Wh:
      'Totalizador de Energía Reactiva Inductiva en Tarifa C (kVArh)',
    totalInductiveReactiveEnergyTariffB_Wh:
      'Totalizador de Energía Reactiva Inductiva en Tarifa B (kVArh)',
    totalInductiveReactiveEnergyTariffA_Wh:
      'Totalizador de Energía Reactiva Inductiva en Tarifa A (kVArh)',
    totalInductiveReactiveEnergyTariffD_Wh:
      'Totalizador de Energía Reactiva Inductiva en Tarifa D (kVArh)',
    generatedEnergyTotal: 'Energía Activa Generada Total (kWh)',
    generatedOffBorderEnergyTotal: 'Energía Activa Generada Fuera de Punta (kWh)',
    generatedIntermediaryEnergyTotal: 'Energía Activa Generada Intermedia (kWh)',
    generatedBorderEnergyTotal: 'Energía Activa Generada de Punta (kWh)',
    borderTotalizer: 'Totalizador de Pico',
    reservedTotalizer: 'Totalizador Reservado',
    offBorderTotalizer: 'Totalizador Fuera de Punta',
    totalIntermediary: 'Total Intermedio',
    totalReactiveInductiveEnergy: 'Energía Reactiva Inductiva Total',
    totalReactiveCapacitiveEnergy: 'Energía Reactiva Capacitiva Total',
    consumedMaximunDemand_W: 'Demanda Máxima Consumida (kW)',
    injectedMaximunDemand_W: 'Demanda Máxima Inyectada (kW)',
    reverseCapacitiveReactiveEnergy_VarH: 'Energía Reactiva Capacitiva Reversa (kVarH)',
    reverseInductiveReactiveEnergy_VarH: 'Energía Reactiva Indutiva Reverso (kVarH)',
    cumulativeMaximumDemandRegisterPlusA: 'Demanda Total Acumulada (kW)',
    cumulativeMaximumDemandRegisterMinusA: 'Demanda Total Acumulada Inversa (kW)',
  },
  app: {
    name: 'Sistema de Monitoreo Eléctrico',
    description: 'Panel de control para medición, control e informes de energía',
    language: 'Seleccionar idioma',
  },
  navigation: {
    home: 'Página de Inicio',
    dashboard: 'Dashboard',
    devices: 'Gestionar Dispositivos',
    reports: 'Informes Detallados',
    settings: 'Configuraciones del Sistema',
    logout: 'Salir del Sistema',
    meters: 'Medidores',
    scheduledCommands: {
      label: 'Comandos Programados',
      systemCommands: 'Comandos del Sistema',
      routineListing: 'Listado de Rutinas',
    },
    massCommands: {
      label: 'Comandos en Masa',
      readings: 'Lecturas',
      cutReconnect: 'Corte/Reconexión',
    },
    customReport: 'Informes',
    ccee: 'Mercado Libre',
    eventReports: 'Informes de Eventos',
    energyBalance: 'Balance Energético',
    smcs: 'SMCs',
    billing: 'Facturación',
    dataExtraction: 'Exportación de datos',
    downloadCenter: 'Centro de Descargas',
    transformers: 'Transformadores',
    areas: 'Áreas',
    regions: 'Regiones',
    serviceNotes: 'Notas de Servicio',
    photocell: 'Fotocélulas',
    mdxWater: 'MDX Agua',
    vee: {
      label: 'VEE',
      overview: 'Visión General VEE',
      groupsLegacy: 'Grupos VEE (Legado)',
      monitoring: 'Monitoreo',
      resume: 'Resumen',
      batchApproval: 'Aprobación en Lote',
      readingImport: 'Importación de Lecturas',
      manualEditBatchApproval: 'Aprobación de Edición en Lote',
      requestQueue: 'Cola de Solicitudes',
      zeroConsumption: 'Consumo Cero',
      limitDeviations: 'Desviaciones de Límites',
      executionMonitor: 'Monitor de Ejecución',
      manualBillingRelease: 'Desbloqueo Manual de Facturación',
      manualOccurrences: 'Ocurrencias Manuales',
      configuration: {
        label: 'Configuración VEE',
        groups: 'Grupos VEE',
        rules: 'Biblioteca de Reglas',
        thresholds: 'Thresholds por Regla',
        calendar: 'Calendario de Facturación',
        notifications: 'Notificaciones',
        hierarchy: 'Asociación por Jerarquía',
        customRule: 'Regla Personalizada',
      },
    },
    iagd: {
      label: 'IAGD',
      overview: 'Vista General',
      settings: 'Configuraciones',
      completeness: 'Completitud de Datos',
      ranking: 'Ranking de Sospecha',
    },
    management: {
      label: 'Gestión',
      firmware: 'Firmware',
      gateways: 'Gateways',
      users: 'Usuarios',
      keys: 'Claves',
      license: 'Licencia',
      tags: 'Etiquetas',
      groups: 'Grupos',
      clients: 'Clientes',
      models: 'Modelos',
      configuration: 'Configuraciones',
    },
  },
  views: {
    license: {
      activation: {
        on: 'Licencia activa',
        off: 'Licencia desactivada',
        tooltip: 'Solo para clientes con contrato por puntos',
        enable: 'Activar',
        disable: 'Desactivar',
        enableTitle: 'Activar la licencia',
        disableTitle: 'Desactivar la licencia',
        enableMessage:
          'Con la licencia activa, los medidores sin punto dejan de grabar datos y de recibir comandos. Hay {used} puntos en uso para un total de {total}. Verifique el total antes de activar.',
        disableMessage:
          'Con la licencia desactivada, ningún medidor es bloqueado, incluidos los de punto quitado. Los puntos se siguen contando.',
        enabled: 'Licencia activada.',
        disabled: 'Licencia desactivada.',
        error: 'Error al cambiar la activación de la licencia.',
      },
      title: 'Licencia',
      client: 'Cliente',
      usage: 'Uso de la licencia',
      usagePercent: '{percent}% de los puntos en uso',
      lastChange: 'Último cambio por {user} el {date}',
      history: 'Historial de acciones de la licencia',
      cards: {
        total: 'Puntos contratados',
        used: 'En uso',
        available: 'Disponibles',
        waiting: 'Esperando punto',
        removed: 'Quitados',
      },
      banner: {
        disabled:
          'La aplicación de la licencia está desactivada en este entorno: se muestran los puntos, pero no se bloquea ninguna grabación ni comando.',
        exceeded:
          'Licencia excedida: {used} puntos en uso para un total de {total}. Los medidores nuevos no graban datos ni reciben comandos.',
        limitReached:
          'Límite de puntos alcanzado. Los medidores nuevos no graban datos ni reciben comandos hasta que se amplíe el total o se quiten puntos.',
        nearLimit: 'La licencia tiene el {percent}% de los puntos en uso.',
        waiting:
          '{count} medidor(es) comisionado(s) sin punto: no están grabando datos ni recibiendo comandos por falta de saldo.',
      },
      alert: {
        exceeded: 'Licencia excedida: {used} puntos en uso para un total de {total}.',
        limitReached:
          'Límite de {total} puntos de la licencia alcanzado: los medidores nuevos no graban datos ni reciben comandos.',
        nearLimit: 'La licencia tiene el {percent}% de los puntos en uso.',
        seeLicense: 'Ver licencia',
      },
      actions: {
        editTotal: 'Cambiar total',
        removeOne: 'Quitar punto',
        removeByFile: 'Quitar por archivo',
        remove: 'Quitar',
        restore: 'Restaurar',
        save: 'Guardar',
        cancel: 'Cancelar',
      },
      filters: {
        all: 'Todos',
        active: 'Activos',
        removed: 'Quitados',
        waiting: 'Esperando punto',
      },
      status: {
        Ativo: 'Activo',
        Removido: 'Quitado',
        SemPonto: 'Sin punto',
      },
      table: {
        title: 'Puntos',
        serial: 'Serial',
        status: 'Situación',
        assignedAt: 'Asignado el',
        removedAt: 'Quitado el',
        removedBy: 'Quitado por',
      },
      dialogs: {
        totalTitle: 'Cambiar total de puntos',
        totalLabel: 'Total de puntos contratados',
        totalBelowUsage:
          'El nuevo total es menor que los {used} puntos en uso. Los medidores que ya tienen punto siguen grabando, pero ningún medidor nuevo recibirá punto.',
        removeTitle: 'Quitar punto',
        restoreTitle: 'Restaurar punto',
        serialLabel: 'Serial del medidor',
        removeMessage: '¿Quitar el punto del medidor {serial}?',
        restoreMessage:
          '¿Restaurar el punto del medidor {serial}? Vuelve a usar un punto, a grabar datos y a recibir comandos, si hay saldo.',
        removeWarning:
          'El medidor deja de grabar datos y de recibir comandos, y el punto vuelve al saldo. Solo vuelve a funcionar si se restaura. La acción queda registrada en un ticket.',
      },
      massRemove: {
        title: 'Quitar puntos por archivo',
        description:
          'Envíe una planilla con la columna serial. Cada medidor del archivo deja de grabar datos y de recibir comandos, y el punto vuelve al saldo. Se registra un ticket por medidor.',
        noFile: 'Seleccione un archivo.',
        noSerialColumn: 'El archivo no tiene la columna serial.',
        noSerials: 'No se encontró ningún serial en el archivo.',
        validated: '{count} serial(es) encontrado(s).',
        validatedWithDuplicates:
          '{count} serial(es) encontrado(s), {duplicates} duplicado(s). Los duplicados se registrarán como falla.',
        fileError: 'No fue posible leer el archivo.',
        submit: 'Quitar {count} punto(s)',
        cancel: 'Cancelar',
        processCreated: 'Proceso creado con {count} medidor(es). Siga el resultado en los tickets.',
        submitError: 'Error al enviar el archivo de remoción.',
      },
      success: {
        totalUpdated: 'Total de puntos actualizado.',
      },
      errors: {
        getSituation: 'Error al buscar la situación de la licencia.',
        getPoints: 'Error al buscar los puntos de la licencia.',
        updateTotal: 'Error al cambiar el total de puntos.',
        action: 'Error al ejecutar la acción en la licencia.',
      },
    },
    iagd: {
      overviewTitle: 'Vista General — IAGD',
      distributor: 'Distribuidora',
      analyzedUcs: 'UCS GD analizadas',
      kpi: {
        totalUcsGd: 'Total UCS GD',
        riskHigh: 'Riesgo Alto',
        riskMedium: 'Riesgo Medio',
        totalFlags: 'Total de Flags',
        metersInRanking: 'Medidores en el ranking',
        percentOfTotal: 'del total',
        accumulatedInPeriod: 'Acumuladas en el período',
      },
      charts: {
        riskDistribution: 'Distribución por Nivel de Riesgo',
        flagComposition: 'Composición de Flags por Tipo',
        scoreDistribution: 'Puntuación Normalizada — Distribución',
        topMeters: 'Top 10 Medidores por Puntuación',
        topMetersEmpty: 'Ningún medidor encontrado.',
      },
      flagTypes: {
        quedaBrusca: 'Caída Brusca',
        injForaDaJanela: 'Iny. Fuera de Ventana',
        consumoNoturno: 'Consumo Nocturno',
        tensaoIrregular: 'Tensión Irregular',
      },
      riskLevels: {
        alto: 'Alto',
        medio: 'Medio',
        baixo: 'Bajo',
      },
      ranking: {
        title: 'Ranking de Sospecha',
        ucsTag: 'UCs',
        riskLabel: 'Nivel de Riesgo',
        allRisks: 'Todos',
        searchLabel: 'Buscar medidor',
        searchPlaceholder: 'Ej: UC-000001',
        columns: {
          ucId: 'Medidor',
          score: 'Score',
          riskLevel: 'Riesgo',
          quedaBrusca: 'C. Brusca',
          injForaDaJanela: 'Iny. Fuera',
          consumoNoturno: 'C. Nocturno',
          tensaoIrregular: 'Tensión',
          cycle: 'Ciclo',
        },
      },
      rankingModal: {
        titleRisk: 'Nivel de Riesgo — Medidores',
        titleFlag: 'Tipo de Flag — Medidores',
        titleScore: 'Rango de Puntuación — Medidores',
        filterLabelFlag: 'Tipo de Flag',
        filterLabelScore: 'Rango de Puntuación',
      },
      completeness: {
        title: 'Completitud de Datos',
        datePlaceholder: 'Mes/Año',
        dateLabel: 'Período',
        searchLabel: 'Búsqueda por UC ID',
        searchPlaceholder: 'Ej: UC-000001',
        exportCsv: 'Exportar CSV',
        metersTag: 'medidores',
        excludedTag: 'excluidos del análisis',
        legendTitle: 'Leyenda',
        columns: {
          ucId: 'UC ID',
          completeness: 'Completitud',
          excludedReadings: 'Lecturas Ausentes',
          status: 'Estado',
        },
        status: {
          included: 'Incluido',
          attention: 'Atención',
          excluded: 'Excluido',
        },
        cluster: {
          high: 'Alta',
          medium: 'Media',
          low: 'Baja',
        },
        filterStatus: 'Estado',
        filterCluster: 'Rango de Completitud',
        filterAll: 'Todos',
      },
      ucDetail: {
        period: 'Período',
        periodTo: 'hasta',
        chartTitle: 'HISTÓRICO',
        readings: 'LECTURAS (15 MIN)',
        flaggedRegionsLegend: 'Las regiones sombreadas en rojo indican días con alertas activas.',
        anomalyIndicators: 'INDICADORES DE ANOMALÍA',
        flagHistory: 'HISTORIAL DE ALERTAS ACTIVAS',
        tabs: {
          energy: 'Energía (kWh)',
          voltage: 'Tensión (V)',
          current: 'Corriente (A)',
        },
        series: {
          clusterRef: 'Ref. clúster',
          energyDirect: 'Energía Directa',
          energyReverse: 'Energía Inversa',
          movingAverage: 'Media Móvil',
          voltage: 'Tensión',
          current: 'Corriente',
        },
        noData: 'No hay análisis IAGD disponible para esta unidad consumidora.',
      },
      settings: {
        title: 'Configuraciones',
        save: 'Guardar configuraciones',
        saving: 'Guardando...',
        saveSuccess: 'Configuraciones guardadas con éxito',
        saveError: 'Error al guardar configuraciones',
        solarWindow: {
          title: 'Ventana Solar',
          start: 'Inicio',
          end: 'Fin',
          startPlaceholder: 'Ej: 06:00',
          endPlaceholder: 'Ej: 20:00',
        },
        flagThresholds: {
          title: 'Umbrales de Flags',
          abruptDrop: 'Caída Brusca (%)',
          abruptDropHint: 'Caída respecto a la media móvil (default: 40%)',
          nightConsumption: 'Consumo Nocturno Z-score',
          nightConsumptionHint: 'Umbral de desviación estadística (default: 2.5)',
          irregularVoltage: 'Tensión Irregular Z-score',
          irregularVoltageHint: 'Umbral de desviación σ diaria (default: 2.5)',
        },
        pipelineParams: {
          title: 'Parámetros del Pipeline',
          completeness: 'Umbral de Completitud (%)',
          completenessHint: 'Medidores por debajo de este valor son excluidos (default: 70%)',
          clusters: 'Número de Clústeres (K)',
          clustersHint: 'Usado en K-Means de perfil de consumo',
          analysisWindow: 'Ventana de análisis (días)',
        },
        schedules: {
          title: 'Programaciones',
          scoring: 'Cron — Puntuación',
          scoringHint: 'Formato cron. Default: 0 2 * * * (diario, 02h UTC)',
          clustering: 'Cron — Clusterización',
          clusteringHint: 'Default: 0 3 * * 1 (semanal, lun. 03h UTC)',
        },
      },
    },
    downloads: {
      exportStarted: 'Exportación iniciada',
      exportStartedDefault:
        'El archivo estará disponible en la pestaña de descargas tan pronto como finalice el proceso.',
      exportPreparing: 'Preparando exportación',
      exportPreparingDetail: 'Preparando exportación, espere...',
      exportNoRecords: 'No hay registros para exportar',
      exportNoRecordsDetail:
        'No hay registros disponibles para exportar con los filtros seleccionados.',
      exportCompleted: 'Archivo disponible',
      exportCompletedDetail: 'El archivo ya está disponible en la Central de Descargas.',
      exportError: 'Error en la exportación',
      exportErrorDefault: 'No se pudo completar la exportación',
      exportDelayed: 'Exportación aún en proceso',
      exportDelayedDetail:
        'La exportación está tardando más de lo esperado. Puede seguir su progreso en la Central de Descargas.',
    },
    massCommands: {
      invalidModel: 'Modelo inválido',
      requiredSerialColumn: 'La columna obligatoria es: Serial',
      invalidDateColumnFormat:
        'La columna Fecha debe estar en el formato: año-mes-día, por ejemplo 2026-01-01.',
      billingProcessStarted:
        'El proceso de facturación se inició. Será redirigido para seguir el progreso.',
      billingProcessStartError: 'No fue posible iniciar el proceso de facturación.',
    },
    dashboard: {
      title: 'Dashboard',
      tabs: {
        general: 'General',
        commands: 'Comandos',
        alarms: 'Alarmas',
        averageVariation: 'Variación Promedio',
        abruptVariation: 'Variación Abrupta',
        effectivenessAndAvailability: 'Eficiencia y Disponibilidad',
        quality: 'Calidad',
        vee: 'VEE',
        serviceNotes: 'Notas',
        integration: 'Integración',
      },
      effectivenessDailyReport: {
        title: 'Informe diario',
        description:
          'Esta descarga genera el informe del día anterior y no utiliza los filtros aplicados abajo.',
        action: 'Descargar informe',
      },
      averageVariation: {
        titleConfigAverageVariation: 'Configuración de Variación Abrupta',
        dailyConsumption: 'Consumo Diario',
        weeklyConsumption: 'Consumo Semanal',
        monthlyConsumption: 'Consumo Mensual',
        events: 'Eventos',
        alarms: 'Alarmas',
        dailySettings: 'Configuraciones de Variación Diaria',
        weeklySettings: 'Configuraciones de Variación Semanal',
        monthlySettings: 'Configuraciones de Variación Mensual',
        weekDay: 'Día de la Semana',
        month: 'Mes',
        weekDays: {
          all: 'Todos',
          monday: 'Lunes',
          tuesday: 'Martes',
          wednesday: 'Miércoles',
          thursday: 'Jueves',
          friday: 'Viernes',
          saturday: 'Sábado',
          sunday: 'Domingo',
        },
        months: {
          all: 'Todos',
          january: 'Enero',
          february: 'Febrero',
          march: 'Marzo',
          april: 'Abril',
          may: 'Mayo',
          june: 'Junio',
          july: 'Julio',
          august: 'Agosto',
          september: 'Septiembre',
          october: 'Octubre',
          november: 'Noviembre',
          december: 'Diciembre',
        },
        placeholders: {
          selectWeekDay: 'Seleccione el día de la semana',
          selectMonth: 'Seleccione el mes',
          selectEventType: 'Seleccione el tipo de evento',
          loading: 'Cargando...',
          cancel: 'Cancelar',
          save: 'Guardar',
        },
        eventType: 'Tipo de Evento',
        eventTypes: {
          all: 'Todos',
          flow_inversion: 'Inversión de Flujo',
          incomplete_memory: 'Energia Incompleta',
          abrupt_consumption_variation_day: 'Variación Abrupta de Consumo (Día Anterior)',
          abrupt_consumption_variation_week: 'Variación Abrupta de Consumo (Semana Anterior)',
          abrupt_consumption_variation_month: 'Variación Abrupta de Consumo (Mes Anterior)',
          abrupt_generation_variation_day: 'Variación Abrupta de Generación (Día Anterior)',
          abrupt_generation_variation_week: 'Variación Abrupta de Generación (Semana Anterior)',
          abrupt_generation_variation_month: 'Variación Abrupta de Generación (Mes Anterior)',
          last_gasp: 'Last Gasp',
        },
        abruptVariation: 'Variación Abrupta',
        abruptVariationChart: 'Gráfico de Variación Abrupta',
        settings: {
          title: 'Configuración de Variación Abrupta',
          percentageValue: 'Valor de Referencia (%)',
          interval: 'Intervalo',
        },
        search: 'Buscar',
        tableHeaders: {
          startWeek: 'Inicio de la Semana',
          endWeek: 'Fin de la Semana',
          date: 'Fecha',
          weekDay: 'Día de la Semana',
          month: 'Mes',
          serial: 'Serial',
          instalation: 'Instalación',
          installation: 'Instalación',
          consumption: 'Consumo (kWh)',
          generation: 'Generación (kWh)',
          difference: 'Saldo (kWh)',
          startMonth: 'Inicio del Mes',
          endMonth: 'Fin del Mes',
          eventDateTime: 'Fecha/Hora del Evento',
          eventType: 'Tipo de Evento',
        },
      },
    },
    veeDashboard: {
      overviewTitle: 'Visión General VEE',
      filters: {
        title: 'Filtros',
        region: 'Región',
        tariffClass: 'Clase Tarifaria',
        technology: 'Tecnología',
        period: 'Período',
        group: 'Grupo VEE',
        selectRegion: 'Seleccione la región',
        noRegions: 'No se encontraron regiones',
        selectTariffClass: 'Seleccione la clase tarifaria',
        selectTechnology: 'Seleccione la tecnología',
        selectPeriod: 'Seleccione el período',
        selectGroup: 'Seleccione el grupo VEE',
        catm1: 'CATM1',
        nbIot: 'NB-IoT',
        apply: 'Aplicar',
        clear: 'Limpiar',
        periodInvalidTitle: 'Período inválido',
        periodError: {
          required: 'Informe la fecha inicial y la fecha final del período para buscar.',
          partial: 'Informe las dos fechas del período (inicial y final) para buscar.',
          invalid: 'La fecha informada es inválida.',
          reversed: 'La fecha final no puede ser anterior a la fecha inicial.',
          future: 'El período no puede contener fechas futuras.',
        },
      },
      errors: {
        title: 'No fue posible cargar el dashboard',
        loadOverview: 'Ocurrió un error al cargar los datos de la Visión General VEE.',
      },
      cards: {
        validatedReadings: 'Lecturas Validadas',
        validatedReadingsCaption: 'de las lecturas evaluadas en el período',
        validatedReadingsTarget: 'Meta',
        notAvailable: 'No disponible',
        validatedReadingsUnavailable:
          'El VEE aún no ha evaluado lecturas en el período y con los filtros seleccionados.',
        pendingExceptions: 'Excepciones Pendientes',
        estimatesToApprove: 'Estimaciones para Aprobar',
        dataGaps: 'Lagunas de Datos',
        communicationFailures: 'Fallas de Comunicación',
        confirmedInterruptions: 'Interrupciones Confirmadas',
        outageEvents: 'Eventos de Corte de Energía',
        tamperEvents: 'Eventos de Manipulación',
        batteryEvents: 'Eventos de Batería',
        nextBilling: 'Próxima Facturación',
        pendingSince: 'Pendiente desde hace {n} día | Pendiente desde hace {n} días',
        pendingSinceHours: 'Pendiente desde hace {n} hora | Pendiente desde hace {n} horas',
        agingMinutes: '{n} minuto | {n} minutos',
        agingHours: '{n} hora | {n} horas',
        agingDays: '{n} día | {n} días',
        days: 'días',
        meters: 'medidores',
        rowActions: 'Acción',
        retry: 'Intentar de nuevo',
        prolongedEstimation: 'Estimación Prolongada',
        prolongedEstimationEmpty: 'Ningún medidor en estimación prolongada',
        prolongedEstimationError: 'No fue posible cargar este indicador',
        prolongedEstimationBreakdown:
          'Inicial: {initial} · Intermedio: {intermediate} · Crítico: {critical}',
        notifications: 'Notificaciones',
        notificationsEmpty: 'Ninguna notificación activa',
        notificationsError: 'No fue posible cargar las notificaciones',
        notificationsViewAll: 'Ver la notificación activa | Ver las {n} notificaciones activas',
        notificationsViewCategory: 'Ver notificaciones de {category} ({n})',
        notificationsViewAllAction: 'Ver todas las notificaciones',
        notificationsTotalTooltip: 'Haga clic para consultar todas las notificaciones.',
        notificationsCategoryTooltip: 'Haga clic para consultar los registros de esta categoría.',
        approveInBulk: 'Aprobar en lote',
        approveInBulkDialog: {
          title: 'Aprobar estimaciones en lote',
          message: '¿Confirma la aprobación en lote de {count} estimación(es) pendiente(s)?',
          cancel: 'Cancelar',
          confirm: 'Aprobar',
          successSummary: 'Estimaciones aprobadas en lote con éxito.',
        },
      },
      notificationsDialog: {
        title: 'Notificaciones VEE',
        totalFoundLabel: 'notificación encontrada | notificaciones encontradas',
        groupScopeApplied: 'Filtrado por el grupo VEE seleccionado en el panel',
        empty: 'No se encontraron notificaciones para los filtros indicados',
        noMeter: 'Sin medidor asociado',
        openSource: 'Abrir origen',
        agingNoteTitle: 'Sobre el tiempo pendiente:',
        agingNote:
          'el plazo se cuenta desde la generación de la notificación, no desde la creación del registro de origen.',
        close: 'Cerrar',
        filters: {
          category: 'Categoría',
          severity: 'Criticidad',
          meter: 'Medidor',
          meterPlaceholder: 'Buscar por número de serie',
          all: 'Todas',
        },
        columns: {
          category: 'Categoría',
          record: 'Registro',
          meter: 'Medidor',
          group: 'Grupo VEE',
          severity: 'Criticidad',
          aging: 'Tiempo pendiente',
          actions: 'Acciones',
        },
        entityTypes: {
          VeeException: 'Excepción',
          VeeBillingReadinessEvent: 'Preparación para facturación',
          VeeEstimationProposal: 'Propuesta de estimación',
          VeeServiceRequest: 'Solicitud de servicio',
          VeeBillingCalendarEscalation: 'Escalamiento del calendario de facturación',
        },
      },
      trendChart: {
        title: 'Tendencia de Calidad de Datos',
        validated: 'Validado',
        exception: 'Excepción',
        empty: 'No se encontraron datos para los filtros seleccionados',
      },
      alerts: {
        title: 'Alertas Recientes',
        alert: 'Alerta',
        severity: 'Severidad',
        meter: 'Medidor',
        date: 'Fecha',
        viewDetails: 'Ver detalles',
        empty: 'Sin alertas recientes',
        searchPlaceholder: 'Buscar medidor',
        detailsDialog: {
          title: 'Detalles de la Alerta',
          close: 'Cerrar',
          resolve: 'Marcar como resuelta',
          resolveSuccess: 'Alerta marcada como resuelta con éxito.',
        },
      },
      groupsTable: {
        title: 'Grupos',
        group: 'Grupo',
        validatedPercent: '% Validado',
        exceptions: 'Excepciones',
        pendingEstimates: 'Estimaciones Pendientes',
        nextBilling: 'Próx. Facturación',
        empty: 'Ningún grupo encontrado',
        downloadSuccess: 'Descarga iniciada con éxito.',
        viewGroup: 'Ver dashboard del grupo',
      },
      serviceRequests: {
        title: 'Solicitudes de Servicio',
        meter: 'Medidor',
        issue: 'Problema',
        slaRemaining: 'SLA Restante',
        status: 'Estado',
        viewDetails: 'Ver detalles',
        empty: 'Sin solicitudes pendientes',
        searchPlaceholder: 'Buscar medidor',
        detailsDialog: {
          title: 'Detalles de la Solicitud',
          close: 'Cerrar',
          resolve: 'Marcar como resuelta',
          resolveSuccess: 'Solicitud marcada como resuelta con éxito.',
        },
      },
      refreshSuccess: 'Datos actualizados con éxito.',
    },
    veeGroupDashboard: {
      title: 'Dashboard del Grupo VEE',
      notFoundTitle: 'Grupo no encontrado',
      notFoundBadge: 'Sin registros',
      notFound: 'Grupo no encontrado o sin medidores asociados al tenant actual.',
      filters: {
        meterSearch: 'Buscar medidor',
        meterSearchPlaceholder: 'Ingrese el serial del medidor',
        status: 'Estado VEE',
        selectStatus: 'Seleccione el estado',
      },
      meters: {
        title: 'Medidores del Grupo',
        searchPlaceholder: 'Buscar medidor',
        meter: 'Medidor',
        status: 'Estado VEE',
        lastUpdatedAt: 'Última Actualización',
        action: 'Acción',
        empty: 'Ningún medidor encontrado en este grupo',
        viewMeter: 'Ver detalle del medidor',
        status_ok: 'OK',
        status_exception: 'Excepción',
        status_estimated: 'Estimado',
        status_communicationFailure: 'Sin Comunicación',
        status_blocked: 'Bloqueado',
        status_unavailable: 'No disponible',
      },
      refreshSuccess: 'Datos actualizados con éxito.',
    },
    customReport: {
      title: 'Informes',
      emptyState: 'Sin datos para mostrar.',
      readings: 'Lecturas',
      itemsFound: 'elementos encontrados',
      comingSoon: 'Próximamente.',
      transformers: 'Transformadores',
      warnings: {
        invalidPeriodSummary: 'Período inválido',
        invalidPeriodDetail:
          'En la pestaña Variación Abrupta, el período seleccionado debe contener fechas del mismo año. Seleccione fechas dentro del mismo año calendario.',
      },
      events: {
        charts: {
          overload: 'Transformadores en Sobrecarga',
          overvoltage: 'Transformadores en Sobretensión',
          undervoltage: 'Transformadores en Subtensión',
          unbalance: 'Desequilibrio de Tensión',
        },
        tables: {
          overload: 'Sobrecarga',
          overvoltage: 'Sobretensión',
          undervoltage: 'Subtensión',
          unbalance: 'Desequilibrio de Tensión',
        },
        columns: {
          overload: 'Sobrecarga (%)',
          overvoltage: 'Sobretensión (%)',
          undervoltage: 'Subtensión (%)',
          unbalance: 'Desequilibrio (%)',
        },
        viewMore: 'Ver más',
      },
      tabs: {
        general: 'Vista General',
        events: 'Eventos',
        alarms: 'Alarmas',
        loads: 'Cargas',
        abruptVariation: 'Variación Abrupta',
      },
      ccee: {
        dateRange: 'Seleccionar período',
        quickOptions: 'Opciones rápidas:',
        quickOptionsHint: 'período de como máximo 7 días, a partir del día anterior',
        lastDays: 'Últimos {count} días',
        failureKind: {
          cceeRejected: 'Rechazado por la CCEE',
          cceeNoResponse: 'Sin respuesta de la CCEE',
          iog: 'Falla en IoG',
        },
        zeroFill: {
          partial: 'Enviado con ceros en parte del día',
          full: 'Enviado con ceros todo el día',
        },
        kpi: {
          title: 'Indicadores',
          metersOnline: 'Medidores Online',
          readingsSent: 'Lecturas Enviadas (Hoy)',
          successRate: 'Tasa de Éxito CCEE',
          pendingTickets: 'Tickets Pendientes',
        },
        statusMap: {
          title: 'Mapa de Estado',
          accepted: 'Datos Aceptados',
          waiting: 'Esperando Confirmación CCEE',
          lacuna: 'Laguna',
          failed: 'Fallo en el envío',
          noSubmission: 'Sin envío',
          weekdays: {
            sunday: 'Domingo',
            monday: 'Lunes',
            tuesday: 'Martes',
            wednesday: 'Miércoles',
            thursday: 'Jueves',
            friday: 'Viernes',
            saturday: 'Sábado',
          },
        },
        alerts: {
          title: 'Alertas Destacadas',
          columns: {
            meter: 'Medidor',
            alert: 'Alerta',
            priority: 'Prioridad',
            date: 'Fecha',
          },
          priority: {
            low: 'Baja',
            medium: 'Media',
            high: 'Alta',
          },
          filters: {
            serial: 'Serial del Medidor',
            serialPlaceholder: 'Filtrar por serial',
            priority: 'Prioridad',
            allPriorities: 'Todas las prioridades',
            alertType: 'Tipo de alerta',
            allTypes: 'Todos los tipos',
          },
          actions: {
            viewRelatedMeters: 'Ver medidores relacionados',
            viewReadings: 'Ver lecturas',
          },
          types: {
            SubmissionFailed: 'Fallo de envío',
            SubmissionRejected: 'Medición rechazada',
            SubmissionExhausted: 'Intentos agotados',
            SemComunicacao: 'Sin comunicación',
            Lacuna: 'Lectura incompleta',
            JobCompleted: 'Rutina de envío completada',
            RecoveryFailed: 'Fallo en la recuperación de la laguna',
            RecoveryNotSupported: 'Recuperación no admitida',
            Unknown: 'Alerta desconocida',
          },
          messageWithSerial: '{label} — {serial}',
          message: '{label}',
          meterModal: {
            title: 'Medidores Relacionados',
          },
        },
        sendStatus: {
          title: 'Estado de Envío',
          columns: {
            meter: 'Medidor',
            datetime: 'Enviado el',
            referenceDate: 'Día de referencia',
            status: 'Estado',
            ticket: 'Ticket CCEE',
            failure: 'Motivo de la falla',
          },
          status: {
            accepted: 'Aceptado',
            pending: 'Enviado',
            rejected: 'Rechazado',
            gap: 'Laguna',
          },
          filters: {
            serial: 'Serial del Medidor',
            serialPlaceholder: 'Filtrar por serial',
            status: 'Estado',
            allStatuses: 'Todos los estados',
            recoveryStatus: 'Recuperación',
            allRecoveryStatuses: 'Todas las recuperaciones',
          },
          actions: {
            viewReadings: 'Ver lecturas del día',
          },
          recovery: {
            column: 'Recuperación',
            status: {
              none: 'No intentada',
              pending: 'En cola',
              requested: 'Esperando al medidor',
              recovered: 'Recuperada',
              failed: 'Falló',
              notSupported: 'No admitida',
              unknown: 'Estado desconocido',
            },
            reason: {
              unknown: 'Motivo desconocido',
              noSerial: 'Medidor sin serie',
              integrationMeter: 'Medidor de integración — no admitido',
              noModem: 'Medidor sin módem',
              belongsToSmc: 'El medidor pertenece a un SMC',
              commandNotImplemented: 'Comando no disponible para este fabricante o modelo',
            },
            attempts: 'Intentos: {count}',
          },
        },
        anomalies: {
          title: 'Anomalías Detectadas',
          noData: 'Ninguna ocurrencia del VEE en medidores CCEE en el período seleccionado',
          billingBlocked: 'Facturación bloqueada',
          billingBlockedApplied: 'Bloqueo de facturación aplicado a esta ocurrencia.',
          billingBlockedPending: 'Acción operativa de la regla: bloquear facturación.',
          actions: {
            viewMeterVee: 'Ver VEE del medidor',
          },
          columns: {
            meter: 'Medidor',
            anomaly: 'Anomalía',
            status: 'Estado',
            actionTaken: 'Acción tomada',
          },
          action: {
            secondaryValidation: 'Validación secundaria',
            justification: 'Justificación',
            kinds: {
              None: 'Sin acción',
              ManualOverride: 'Edición manual',
              EstimationApproved: 'Estimación aprobada',
              EstimationProposed: 'Estimación propuesta',
              EstimationRejected: 'Estimación rechazada',
              EstimationInvalid: 'Estimación inválida',
              EstimationCancelled: 'Estimación cancelada',
              Resolved: 'Resuelta',
              Ignored: 'Ignorada',
            },
          },
        },
        performance: {
          title: 'Rendimiento de los últimos 30 días',
          metrics: {
            metersOnline: 'Medidores Online',
            correctedGaps: 'Lagunas Corregidas',
            cceeAcceptance: 'Aceptación CCEE',
            sendRate: 'Tasa de Envío',
          },
        },
        availableReports: {
          title: 'Informes Disponibles',
          columns: {
            report: 'Informe',
            type: 'Tipo',
          },
        },
        generatedFiles: {
          title: 'Archivos Generados',
          columns: {
            report: 'Informe',
            period: 'Período',
            meters: 'Medidores',
            records: 'Registros',
            periodicity: 'Periodicidad',
          },
          periodRange: '{start} a {end}',
          noData: 'Ningún archivo generado en el período seleccionado',
          loadError: 'Error al cargar los archivos generados',
          periodicity: {
            daily: 'Diario',
            monthly: 'Mensual',
          },
          filters: {
            periodicity: 'Periodicidad',
            all: 'Todos',
          },
          downloadError: 'Error al iniciar la descarga del archivo',
          invalidPeriod: 'No fue posible identificar el período del archivo',
          customPeriod: {
            button: 'Generar archivo del período',
            title: 'Generar archivo del período',
            report: 'Informe',
            reports: {
              notIntegrated: 'No integrados',
              failures: 'Fallas',
            },
            period: 'Período',
            periodPlaceholder: 'Seleccione el período',
            hint:
              'El período seleccionado debe tener como máximo {max} días y la fecha final debe ser hasta el día anterior.',
            description:
              'El archivo se generará en CSV (separado por punto y coma). Debido al volumen de datos, estará disponible en la pestaña de descargas cuando esté listo.',
            errors: {
              incomplete: 'Seleccione la fecha inicial y la fecha final.',
              startAfterEnd: 'La fecha inicial debe ser anterior o igual a la fecha final.',
              endAfterYesterday: 'La fecha final debe ser como máximo ayer.',
              tooLong: 'El período debe tener como máximo {max} días.',
            },
            cancel: 'Cancelar',
            confirm: 'Generar',
            errorSummary: 'Error',
            errorDetail: 'No fue posible iniciar la generación del archivo.',
          },
        },
        collectionGrid: {
          title: 'Extracto de Recolección',
          monthPicker: 'Seleccione el mes',
          meter: 'Medidor',
          noData: 'No se encontraron datos para el período seleccionado',
          filters: {
            serial: 'Serial del Medidor',
            serialPlaceholder: 'Filtrar por serial',
            month: 'Mes',
          },
        },
        readingsModal: {
          title: 'Lecturas',
          filters: {
            period: 'Período',
            status: 'Estado',
            allStatuses: 'Todos los estados',
            ticket: 'Ticket CCEE',
            selectPeriodWarning: 'Por favor, seleccione un período.',
          },
          columns: {
            datetime: 'Fecha/Hora',
            status: 'Estado',
            ticket: 'Ticket CCEE',
            integrationMethod: 'Método',
            activeEnergyIn: 'Activa Entrada',
            activeEnergyOut: 'Activa Salida',
            reactiveEnergyIn: 'Reactiva Entrada',
            reactiveEnergyOut: 'Reactiva Salida',
            consumoKwh: 'Consumo',
            codigoErro: 'Código de Error',
            descricaoErro: 'Descripción del Error',
          },
          resend: {
            tooltip: 'Reenviar el día {date} a la CCEE',
            disabledTooltip: 'Disponible solo cuando las lecturas se abren para un único día',
            confirmHeader: 'Confirmar reenvío',
            confirmMessage:
              '¿Forzar el reenvío del medidor {serial} a la CCEE para el día {date}? El día se enviará aunque ya se haya enviado anteriormente.',
            confirm: 'Reenviar',
            cancel: 'Cancelar',
            successSummary: 'Reenvío completado',
            successDetail:
              'El día {date} del medidor {serial} fue reenviado a la CCEE. El estado de envío se actualizará en la próxima verificación del sistema, en hasta 5 minutos. Los resultados podrán seguirse en "{panel}" a medida que avance el procesamiento.',
            incompleteSummary: 'Día incompleto',
            incompleteDetail:
              'Solo {veeReadyCount} de {requiredCount} lecturas están listas en VEE. No se envió nada.',
            errorSummary: 'Error al reenviar',
            errorDetail: 'No fue posible reenviar el día a la CCEE.',
          },
        },
        resend: {
          button: 'Reenviar día',
          title: 'Reenviar día a la CCEE',
          description:
            'Reenvía a la CCEE el día seleccionado para todos los medidores de este cliente o solo para los medidores elegidos.',
          date: 'Día de referencia',
          onlyPastDays:
            'Solo el día anterior o fechas anteriores pueden ser reenviados para los medidores.',
          mode: 'Medidores',
          modeAll: 'Todos los medidores',
          modeBatch: 'En lote',
          forcedNotice:
            'Ambas opciones reenvían el día, incluso para los medidores que ya fueron enviados en esa fecha. El envío se realiza en segundo plano y los resultados se muestran en "{panel}" a medida que avanza el procesamiento.',
          allDescription:
            'Las lecturas del {count} medidor CCEE de este cliente serán reenviadas para el día {date}. | Las lecturas de los {count} medidores CCEE de este cliente serán reenviadas para el día {date}.',
          allDescriptionNoCount:
            'Las lecturas de todos los medidores CCEE de este cliente serán reenviadas para el día {date}.',
          meters: 'Medidores',
          filters: {
            serial: 'Buscar medidor',
            status: 'Estado en el día',
            allStatuses: 'Todos los estados',
          },
          columns: {
            serial: 'Medidor',
            dayStatus: 'Estado en el día',
            ticket: 'Ticket',
            lastSubmissionAt: 'Último envío',
          },
          dayStatus: {
            accepted: 'Aceptado',
            pending: 'Pendiente',
            rejected: 'Rechazado',
            notSent: 'No enviado',
          },
          selectedCount: 'Seleccionados: {count}',
          clearSelection: 'Limpiar selección',
          noCandidates: 'No se encontraron medidores CCEE.',
          candidatesError: 'No fue posible cargar los medidores.',
          cancel: 'Cancelar',
          confirm: 'Reenviar',
          successSummary: 'Reenvío solicitado',
          queuedDetail:
            'El reenvío del día {date} fue programado para {items} medidor. Los resultados podrán seguirse en "{panel}" a medida que avance el procesamiento. | El reenvío del día {date} fue programado para {items} medidores. Los resultados podrán seguirse en "{panel}" a medida que avance el procesamiento.',
          errorSummary: 'Error al reenviar',
          errorDetail: 'No fue posible reenviar el día. Intente nuevamente.',
          batchCompleted: {
            summary: 'Reenvío a la CCEE completado',
            detail:
              'Día {date}: {sent} enviados, {incomplete} incompletos, {failed} con falla, {skipped} omitidos y {notEligible} no elegibles.',
          },
        },
      },
      filters: {
        equipment: 'Distribuidora',
        installation: 'MFINSTALA',
        region: 'Región',
        polygon: 'Polígono',
        load: 'Carga',
        loadRange: '% CARGA',
        cluster: 'Cluster',
        selectPeriod: 'Seleccione el período',
        minPlaceholder: 'Min',
        maxPlaceholder: 'Máx',
        superintendency: 'Supervisión',
        sectional: 'En corte',
        city: 'Ciudad',
        itemsSelected: 'elementos seleccionados',
        equipmentOptions: {
          eqtlMa: 'EQTL-MA',
          eqtlBa: 'EQTL-BA',
          eqtlPi: 'EQTL-PI',
        },
        installationOptions: {
          mfinstala: 'MFINSTALA',
          finstala: 'FINSTALA',
          nfinstala: 'NFINSTALA',
        },
        regionOptions: {
          regional: 'Regional',
          east: 'Este',
          west: 'Oeste',
        },
        polygonOptions: {
          default: 'Polígono',
          centerWest: 'Centro-Oeste',
          coast: 'Litoral',
        },
        loadOptions: {
          default: 'Carga',
          normal: 'Normal',
          overload: 'Sobrecarga',
        },
        clusterOptions: {
          default: 'Cluster',
          upTo100: 'Hasta 100%',
          between100And125: '100% a 125%',
          above175: 'Por encima de 175%',
        },
      },
      legend: {
        normalLoad: 'Carga Normal',
        overload: 'Sobrecarga',
      },
      cards: {
        loadClusters: 'Clusters de Carga',
        overloadByPolygon: 'Sobrecarga por Polígono',
        maxMonthlyLoad: 'Carga Máxima Mensual',
        maxLoad: 'Carga Máxima',
        maxLoadCurve: 'Curva de Carga Máxima',
        maxPhaseUnbalanceCurve: 'Curva de Desbalance de Fase Máximo',
        timeByTier: 'Tiempo por Nivel',
        phaseUnbalanceClusters: 'Clusters de Desbalance de Fase',
      },
      charts: {
        maxLoadCurve: 'Curva de Carga Máxima',
        maxPhaseUnbalanceCurve: 'Curva de Desbalance de Fase Máximo',
        phaseUnbalanceClusters: 'Desbalance de Fase',
      },
      tiers: {
        upTo100: 'hasta 100%',
        between100And125: '100% a 125%',
        between125And150: '125% a 150%',
        between150And175: '150% a 175%',
        above175: 'Por encima de 175%',
      },
      unbalance: {
        upTo10: 'hasta 10%',
        between10And20: '10% a 20%',
        between20And30: '20% a 30%',
        between30And40: '30% a 40%',
        between40And50: '40% a 50%',
        above50: 'por encima de 50%',
      },
      tables: {
        transformer: 'Transformador',
        transformerName: 'Nombre del Transformador',
        loadPercent: '% Carga',
        maxLoad: 'Carga Máx.',
        cluster: 'Cluster',
        phaseUnbalance: 'Desbalance de Fase',
        date: 'Fecha',
        month: 'Mes',
        range: 'Rango',
        total: 'Total',
        percent: 'Porcentaje',
        polygon: 'Polígono',
        region: 'Región',
        normal: 'Normal',
        overload: 'Sobrecarga',
      },
      details: {
        mfinstala: 'MFINSTALA',
        distributor: 'Distribuidora',
        transformer: 'Transformador',
        power: 'Potencia',
        region: 'Región',
        polygon: 'Polígono',
        dataDate: 'Fecha de Datos',
        posto: 'Puesto',
        measurementDate: 'Fecha de Medición',
        imax: 'Imax',
        inum: 'Inum',
        loadPercent: '% Carga',
        loadPercentA: '% Carga A',
        loadPercentB: '% Carga B',
        loadPercentC: '% Carga C',
        clusterPercent: 'Cluster %',
        overload: 'Sobrecarga',
        phaseUnbalance: 'Desbalance de Fase',
        unbalanceCluster: 'Cluster de Desbalance',
        currentA: 'Corriente A',
        currentB: 'Corriente B',
        currentC: 'Corriente C',
        undefined: 'Indefinido',
      },
    },
    process: {
      title: 'Proceso',
      user: 'Usuario Responsable',
      processType: 'Tipo de Proceso',
      updatedAt: 'Última Actualización',
    },
    massCommandsCutReconnect: {
      title: 'Corte / Reconexión',
      importSpreadsheet: 'Importar planilla',
      send: 'Enviar',
      importHint: 'Importe la planilla para cargar los comandos de corte/reconexión.',
      importModalTitle: 'Importar Corte / Reconexión',
      validationTitle: 'Validación de los seriales importados',
      importedRecords: 'Registros importados:',
      foundCountLabel: 'Encontrados:',
      notFoundCountLabel: 'No encontrados:',
      queryingSerials: 'Consultando seriales...',
      noRecords: 'No se encontraron registros.',
      serial: 'Serial',
      action: 'Acción',
      situation: 'Situación',
      foundLabel: 'Encontrado',
      notFoundLabel: 'No encontrado',
      reason: 'Motivo',
      historyTitle: 'Historial de Corte / Reconexión',
      processDetails: 'Detalles del proceso',
      executedAt: 'Fecha de Ejecución:',
      commandStateFilter: 'Estado del comando',
      selectPlaceholder: 'Seleccione',
      activateRelay: 'Activar Relé',
      deactivateRelay: 'Desactivar Relé',
      getRelayState: 'Obtener estado del relé',
      invalidAction: 'Acción inválida',
      statusExecuting: 'Ejecutando',
      statusFinished: 'Finalizado',
      statusWaiting: 'Esperando',
      statusCancelled: 'Cancelado',
      statusFailed: 'Falló',
      confirmSendTitle: 'Confirmar envío',
      notFoundWarning:
        'Existen seriales no encontrados en el archivo enviado. Desea continuar la operación con los archivos procesados con éxito?',
      foundNotFoundCounts: 'Seriales encontrados: {found}. No encontrados: {notFound}.',
      sendQuestion: 'Desea enviar {count} comando(s) de corte/reconexión?',
      cancel: 'Cancelar',
      confirmImportTitle: 'Confirmar importación',
      importProceedMessage:
        'Seriales encontrados: {found}. No encontrados: {notFound}. Desea continuar con la importación solo de los elementos encontrados?',
      proceed: 'Continuar',
      downloadTicketsTitle: 'Descargar tickets',
      downloadQuestion: 'Desea descargar los tickets de esta ejecución?',
      filterApplied: 'Filtro aplicado:',
      noneFilter: 'Ninguno',
      download: 'Descargar',
      ticketDetailsTitle: 'Detalles del Ticket',
      createdAt: 'Fecha de creación',
      createdAtLabel: 'Fecha de creación:',
      ticketId: 'ID del ticket',
      ticketIdLabel: 'ID del ticket:',
      device: 'Dispositivo',
      deviceLabel: 'Dispositivo:',
      ticketStatus: 'Estado del Ticket',
      ticketStatusLabel: 'Estado del Ticket:',
      commandStatus: 'Estado del Comando',
      commandStatusLabel: 'Estado del Comando:',
      command: 'Comando',
      commandLabel: 'Comando:',
      messageLabel: 'Mensaje:',
      close: 'Cerrar',
      warnTitle: 'Atención',
      errorTitle: 'Error',
      noRowsInFile: 'No se encontró ninguna fila en el archivo.',
      invalidModelTitle: 'Modelo inválido',
      invalidModelDetail: 'Columnas obligatorias: Serial y Comando (o Medidor y Acción).',
      noValidSerials: 'No se encontró ningún serial válido en el archivo.',
      noSerialFoundTitle: 'Ningún serial encontrado',
      noSerialFoundDetail:
        'No es posible continuar, porque ningún serial del archivo existe en el sistema.',
      fileValidatedTitle: 'Archivo validado',
      fileValidatedDetail: '{count} serial(es) encontrado(s).',
      validateSerialFailReason: 'Error al validar el serial',
      validateErrorDetail: 'Error al validar los seriales en el sistema. Intente nuevamente.',
      importConfirmedTitle: 'Importación confirmada',
      importConfirmedDetail: 'Continuando con {count} serial(es) encontrado(s).',
      importCancelledTitle: 'Importación cancelada',
      importCancelledDetail: 'Ajuste el archivo e importe nuevamente.',
      sendSuccessTitle: 'Envío realizado',
      sendSuccessDetail: 'Proceso de comandos en masa iniciado.',
      sendErrorDetail: 'Error al enviar los comandos.',
      noTicketsToDownload: 'Ningún ticket para descargar.',
      downloadTitle: 'Descarga',
      downloadSuccess: 'Archivo generado con éxito.',
      downloadError: 'Error al descargar los tickets.',
      loadTicketsError: 'Error al cargar los tickets.',
      loadHistoryError: 'Error al cargar el historial.',
    },
    massCommandsReadings: {
      title: 'Lecturas',
      datePlaceholder: 'dd/mm/aaaa',
      importSpreadsheet: 'Importar planilla',
      selectDateHint: 'Seleccione una fecha e importe la planilla para cargar las lecturas.',
      importModalTitle: 'Importar Lecturas',
      validationTitle: 'Validación de los seriales importados',
      importedRecords: 'Registros importados:',
      foundCount: 'Encontrados:',
      notFoundCount: 'No encontrados:',
      queryingSerials: 'Consultando seriales...',
      noRecords: 'No se encontraron registros.',
      serial: 'Serial',
      date: 'Fecha',
      situation: 'Situación',
      foundLabel: 'Encontrado',
      notFoundLabel: 'No encontrado',
      reason: 'Motivo',
      couldNotValidate: 'No fue posible validar',
      bill: 'Facturar',
      noFileOrReading: 'Ningún archivo o lectura encontrada.',
      equipmentSerial: 'Serial del equipo',
      billingDate: 'Fecha de facturación',
      suggestedDate: 'Fecha sugerida',
      recoverReading: 'Recuperar lectura',
      serialsNotFoundTitle: 'Seriales no encontrados',
      foundSummary: 'Se encontraron {found} seriales y {notFound} no encontrados.',
      proceedQuestion: 'Desea continuar solo con los seriales encontrados?',
      proceedWarning: 'Si continúa, los seriales no encontrados serán ignorados.',
      cancel: 'Cancelar',
      proceed: 'Continuar',
      acceptNewDatesTitle: 'Aceptar nuevas fechas',
      bulkNewDatesMessage:
        'Las lecturas a continuación tienen fechas sugeridas. Desea aceptar las nuevas fechas y habilitar el envío?',
      requestedDate: 'Fecha solicitada',
      accept: 'Aceptar',
      singleNewDateTitle: 'Nueva fecha sugerida',
      singleNewDateMessage:
        'El medidor {serial} tiene una fecha sugerida. Desea aceptar la nueva fecha para habilitar el envío?',
      requestedDateLabel: 'Fecha solicitada:',
      suggestedDateLabel: 'Fecha sugerida:',
      confirmBillingTitle: 'Confirmar facturación',
      exportType: 'Tipo de exportación',
      exportSap: 'SAP',
      exportCustom: 'Personalizado',
      confirm: 'Confirmar',
      recoverTitle: 'Recuperar lectura',
      serialLabel: 'Serial:',
      loadingMeter: 'Cargando información del medidor...',
      recoverType: 'Tipo de recuperación:',
      smcHint: 'El medidor tiene SMC, se usará Recover Mass Memory SMC.',
      noSmcHint: 'Medidor sin SMC, se usará Recover Frozen Data.',
      smcQuantity: 'Cantidad (SMC)',
      smcQuantityHint:
        '(El backend usa esta cantidad en el endpoint /commands/recover-mass-memory-smc.)',
      recover: 'Recuperar',
      successTitle: 'Éxito',
      warnTitle: 'Atención',
      errorTitle: 'Error',
      validateSerialsError: 'Error al validar los seriales en el sistema.',
      noValidSerials: 'Ningún serial válido para continuar.',
      spreadsheetValidated: 'Planilla validada',
      proceedingWithFound: 'Continuando solo con los seriales encontrados.',
      preProcessEmpty:
        'El pre-procesamiento devolvió vacío. Verifique la fecha y el contenido de la planilla.',
      preProcessError: 'Error al pre-procesar las lecturas.',
      selectDateBeforeImport: 'Seleccione una fecha antes de importar.',
      noRowsInFile: 'No se encontró ninguna fila en el archivo.',
      noSerialsInSystem:
        'No fue posible continuar: ningún serial del archivo se encontró en el sistema.',
      partialFoundDetail: 'Se encontraron {found} serial(es) y {notFound} no fueron encontrados.',
      spreadsheetImported: 'Planilla importada',
      importedDetail:
        '{count} fila(s) cargada(s). Seriales validados y pre-procesamiento concluido.',
      meterLoadFallback:
        'No fue posible cargar los datos del medidor. Intentando recuperar usando Frozen Data por defecto.',
      selectDateBeforeRecover: 'Seleccione una fecha antes de recuperar.',
      recoveryTitle: 'Recuperación',
      recoverySent: 'Comando de recuperación enviado.',
      recoverFailed: 'Error al enviar el comando de recuperación.',
      importRemoved: 'Importación eliminada',
      dataCleared: 'Datos limpiados con éxito.',
    },
    gatewaysList: {
      title: 'Gateways',
      fileActions: 'Acciones por Archivo',
      importGateways: 'Importar Gateways',
      associateMeters: 'Asociar Medidores a los Gateways',
      listMeters: 'Listar Medidores de los Gateways',
      name: 'Nombre',
      serial: 'Serial',
      ipAddress: 'Dirección IP',
      countMeters: 'Cant.',
      description: 'Descripción',
      updatedAt: 'Última actualización',
      gatewaysPage: 'Página de Gateways',
      successTitle: 'Éxito',
      errorTitle: 'Error',
      fetchError: 'Error al buscar Gateways {message}',
      importSuccess: 'Gateways agregados',
      importError: 'Error al enviar los Gateways',
      associateSuccess: 'Medidores asociados a los Gateways',
      associateError: 'Error al asociar los medidores',
      listMetersSuccess:
        'Se creó el proceso de listado de medidores de los Gateways, puede seguir el progreso en el panel',
      listMetersError: 'Error al listar los medidores de los Gateways',
      noneSelected: 'Ningún Gateway seleccionado',
      deleteSuccess: 'Gateway(s) eliminado(s)',
      deleteError: 'Error al eliminar los Gateways {message}',
    },
    groupsList: {
      title: 'Grupos',
      newGroup: 'Nuevo Grupo',
      name: 'Nombre',
      createdAt: 'Fecha de Creación',
      numberOfClients: 'Número de clientes',
      tags: 'Tags',
      description: 'Descripción',
      updatedAt: 'Última Actualización',
      meterPage: 'Página del Medidor',
    },
    meters: {
      title: 'Medidores',
      periodUpdateAt: 'Período de última actualización',
      meterCreation: {
        createTitle: 'Nuevo Medidor',
        editTitle: 'Editar Medidor',
        loadError: 'Error al cargar los datos necesarios',
        retry: 'Intentar nuevamente',
        serial: 'Serial del Medidor',
        serialPlaceholder: 'Ingrese el serial del medidor',
        manufacturer: 'Fabricante',
        manufacturerPlaceholder: 'Seleccione el fabricante',
        phase: 'Fase',
        phasePlaceholder: 'Seleccione la fase',
        model: 'Modelo',
        modelPlaceholder: 'Seleccione el modelo',
        smc: 'SMC',
        smcPlaceholder: 'Seleccione el SMC',
        loading: 'Cargando...',
        hasTransparent: 'NIC Transparente',
        hasTransparentPlaceholder: 'Seleccione el estado del NIC',
        hasTransparentInvalid: 'Estado del NIC inválido',
        meterType: 'Tipo de Medidor',
        meterTypePlaceholder: 'Seleccione el tipo',
        cceeIntegration: 'Integración CCEE',
        cceeIntegrationPlaceholder: 'Seleccione una opción',
        cceeIntegrationStartDate: 'Inicio de la integración',
        cceeIntegrationStartDatePlaceholder: 'Seleccione la fecha de inicio',
        cceeIntegrationStartDateRequired:
          'Informe la fecha de inicio de la integración con la CCEE',
        cceeIntegrationStartBackfill:
          '{count} días (del {date} hasta ayer) se enviarán automáticamente a la CCEE en segundo plano.',
        cceeIntegrationStartBackfillOne:
          '1 día (del {date} hasta ayer) se enviará automáticamente a la CCEE en segundo plano.',
        cceeIntegrationStartFuture: 'El medidor comienza a integrarse a partir del {date}.',
        optional: 'opcional',
        rateType: 'Tipo de Tarifa',
        rateTypePlaceholder: 'Seleccione el tipo',
        latitude: 'Latitud',
        latitudePlaceholder: 'Ingrese la latitud',
        longitude: 'Longitud',
        longitudePlaceholder: 'Ingrese la longitud',
        installation: 'Código de Instalación',
        installationPlaceholder: 'Ingrese el código de instalación',
        connectionPhase: 'Fase de Conexión',
        connectionPhasePlaceholder: 'Seleccione la fase de conexión',
        registers: 'Registradores',
        registersPlaceholder: 'Seleccione los Registradores',
        tags: 'Tags',
        tagsPlaceholder: 'Seleccione las tags',
        clients: 'Clientes',
        clientsPlaceholder: 'Seleccione el Cliente',
        cancel: 'Cancelar',
        importFromFile: 'Importar con Archivo',
        create: 'Crear Medidor',
        update: 'Actualizar Medidor',
        yes: 'Sí',
        no: 'No',
        successTitle: 'Éxito',
        errorTitle: 'Error',
        createSuccess: 'Medidor creado con éxito',
        updateSuccess: 'Medidor actualizado con éxito',
        createError: 'Error al crear el medidor',
        updateError: 'Error al actualizar el medidor',
        modelsLoadError: 'Error al cargar los modelos del fabricante seleccionado',
        meterLoadError: 'Error al cargar los datos del medidor',
      },
      meterInfo: {
        title: 'Detalles del Medidor',
        infoClient: 'Info. Cliente',
        moreDetails: 'Ver Más',
        noInformation: 'Sin información',
        serial: 'Serial',
        installation: 'Instalación',
        displayConfigured: 'Configuración de Display',
        firmware: 'Firmware',
        referenceVoltage: 'Tensión de Referencia',
        accountantStatus: 'Estado de Relé',
        status: 'Estado de Comunicación',
        associatedGateway: 'Gateway asociado:',
        networkTypePublic: 'Pública',
        networkTypePrivate: 'Privada',
        latLong: 'Lat / Long',
        crcMassMemory: 'CRC memoria de masa',
        uplinkPeriod: 'Período de Uplink de Lectura',
        crcFrozenData: 'CRC Energía',
        tags: 'Etiquetas del Medidor',
        regional: 'Regional',
        sectional: 'Seccional',
        polygon: 'Polígono',
        potency: 'Potencia',
        noTags: 'No hay etiquetas encontradas',
        meterModel: {
          manufacturer: 'Fabricante',
        },
        delete: 'Excluir',
        confirmDelete: 'Confirmar exclusión del Medidor',
        confirmDeleteDescription: '¿Estás seguro de querer excluir el Medidor?',
        confirmDeleteText: 'Sí, excluir',
        actions: {
          fileUpload: 'Subir archivo',
          editReadings: 'Edición de Lecturas',
          editTags: 'Configurar Etiquetas',
          searchTags: 'Buscar etiquetas por nombre',
        },
        tabs: {
          overview: 'Visión General',
          iagd: 'IA-GD',
          vee: 'Visualización VEE',
        },
      },
      criticalAlarms: {
        title: 'Alertas Críticas',
        criticalAlarm: 'Alarma crítica',
        readDateTime: 'Horario de Lectura:',
        updatedAt: 'Última Actualización:',
        notFound: '¡No se encontraron alarmas críticas!',
        relayFailure: 'Falla del Relé',
        smiTimeout: 'SMI Timeout',
        lastGasp: 'Last Gasp',
        localReset: 'Reconexión local',
        measurementError: 'Error en el sistema de medición',
      },
      maps: {
        title: 'Visualización en el Mapa',
        noLocation: 'No hay ubicación disponible',
      },
      display: {
        title: 'Display del Medidor',
        config: 'Configuraciones del Display',
        save: 'Actualizar configuraciones',
        readDisplay: 'Solicitar lectura del Display',
        '001': 'Día, mes y año actuales',
        '002': 'Hora, minuto y segundos actuales',
        '003': 'Totalizador General Activo',
        '004': 'Totalizador Punta Activo',
        '006': 'Totalizador Reservado Activo',
        '008': 'Totalizador Fuera de Punta Activo',
        '009': 'Totalizador Intermedio Activo',
        '024': 'Totalizador de Energía Reactiva Inductiva',
        '103': 'Totalizador General Reverso',
        '104': 'Totalizador Punta Reverso',
        '106': 'Totalizador Reservado Reverso',
        '108': 'Totalizador Fuera de Punta Reverso',
        '109': 'Totalizador Intermedio Reverso',
      },
      placeholders: {
        serial: 'Ingrese el serial del medidor',
      },
    },
    meterDetails: {
      titleWithSerial: 'Información del medidor - {serial}',
    },
    meterFileUpload: {
      title: 'Carga de archivo',
      meterCardTitle: 'Medidor - {serial}',
      selectPlaceholder: 'Tipo de importación',
      importSpreadsheet: 'Importar planilla',
      cancel: 'Cancelar',
      send: 'Enviar',
      emptyHint: 'Seleccione un tipo e importe la planilla para ver los registros antes del envío.',
      importedRecordsTitle: 'Registros importados',
      qualityWarningTitle: 'Atención',
      qualityWarningDetail:
        'Existen {total} registro(s) sin indicadores de calidad completados. Estos registros pueden ser rechazados durante el procesamiento porque no contienen DRP, DRC, DTT95, FD95 o indicadores por fase.',
      total: 'Total',
      tableEmpty: 'No se encontraron registros.',
      removeDialogTitle: 'Eliminar importación',
      removeDialogMessage: '¿Desea eliminar el archivo y limpiar los datos cargados?',
      remove: 'Eliminar',
      sendDialogTitle: 'Confirmar envío',
      sendDialogMessage: '¿Desea finalizar esta operación y enviar {total} registro(s)?',
      importModalTitle: 'Importar - {label}',
      types: {
        massMemory: 'Memoria de masa',
        quality: 'Parámetros de calidad',
        energy: 'Totalizadores de energía',
        alarms: 'Alarmas',
      },
      toast: {
        importedTitle: 'Archivo importado',
        importedDetail: '{total} registro(s) cargado(s).',
        removedTitle: 'Importación eliminada',
        removedDetail: 'Datos limpiados con éxito.',
        unavailableTitle: 'No disponible',
        alarmsNotImplemented: 'La opción aún no está disponible.',
        sentTitle: 'Envío realizado',
        sentDetail: 'La importación se inició con éxito.',
        sendError: 'No fue posible enviar los datos. Inténtelo de nuevo.',
        noRows: 'No se encontraron registros en el archivo.',
        invalidSerial: 'Número de Serie inválido',
      },
    },
    meterVeeDetails: {
      titleWithSerial: ' VEE - Medidor {serial}',
      currentReadingCardTitle: 'Lectura actual',
      currentReadingUnavailable: 'No disponible',
      group: 'Grupo VEE',
      groupUnavailable: 'No disponible',
      statusCardTitle: 'Estado',
      blockingCardTitle: 'Bloqueo',
      status: {
        ok: 'Validado',
        exception: 'Con excepción',
        estimated: 'En estimación',
        noCommunication: 'Sin comunicación',
        blocked: 'Bloqueado',
        notBlocked: 'No bloqueado',
        unavailable: 'No disponible',
      },
      hierarchyLevel: {
        meter: 'Nivel: Medidor',
        existingGroup: 'Nivel: Grupo existente',
        tag: 'Nivel: Etiqueta',
        consumerUnit: 'Nivel: Unidad consumidora',
        tariffClass: 'Nivel: Clase tarifaria',
        technology: 'Nivel: Tecnología',
        default: 'Nivel: Predeterminado del tenant',
      },
      chart: {
        title: 'Lecturas',
        loadError: 'No fue posible cargar las lecturas.',
        availabilityConflictTitle: 'No fue posible consolidar las lecturas',
        availabilityConflictDescription:
          'Se identificaron clasificaciones de disponibilidad en conflicto para este medidor en el período seleccionado. Verifique las asociaciones VEE y las ocurrencias del período, o comuníquese con el administrador.',
        period: 'Período',
        periodPlaceholder: 'Seleccione el período',
        measurement: 'Magnitud',
        measurementPlaceholder: 'Seleccione la magnitud',
        displayedMeasurement: 'Magnitud mostrada',
        noValues: 'Sin valores para la magnitud seleccionada en el período.',
        semantics: {
          incremental: 'Incremental (por intervalo)',
          accumulative: 'Acumulada (totalizador)',
          instantaneous: 'Instantánea (promedio)',
        },
        real: 'Real',
        estimatedApproved: 'Estimado aprobado',
        edited: 'Editado',
        pendingProposal: 'Propuesta pendiente',
        gapMarker: 'Sin dato',
        gaps: {
          '5': 'Laguna',
          '6': 'Sin comunicación',
          '7': 'Interrupción',
        },
        availabilityReason: {
          dataSource: 'Tipo de dato',
          missingIntervals: 'Ausentes o inválidos',
          intervalOne: '{count} intervalo',
          intervalOther: '{count} intervalos',
          periodRange: '{start} hasta {end}',
          noEligibleSource:
            'Ninguna fuente elegible ni clasificación de indisponibilidad activa para este instante.',
        },
      },
      amiEvents: {
        title: 'Eventos AMI',
        loadError: 'No fue posible cargar los eventos AMI.',
        empty: 'Ningún evento AMI en el período seleccionado',
        categoryFilter: 'Tipo de evento',
        categoryFilterPlaceholder: 'Seleccione el tipo',
        origin: 'Origen',
        severity: 'Severidad',
        severityNotInformed: 'No informada',
        start: 'Inicio',
        end: 'Fin',
        duration: 'Duración',
        originAmi: 'AMI',
        originManual: 'Manual',
        durationMinutes: '{minutes} min',
        durationHoursMinutes: '{hours}h {minutes}min',
        categories: {
          outage: 'Corte de Energía',
          restoration: 'Restablecimiento',
          tamper: 'Manipulación',
          battery: 'Batería',
          communicationFailure: 'Falla de Comunicación',
          communicationRestored: 'Comunicación Restablecida',
        },
        intervalTypes: {
          powerInterruption: 'Interrupción de Energía',
          communicationFailureInterval: 'Falla de Comunicación',
          tamperInterval: 'Manipulación',
        },
        columns: {
          event: 'Evento',
        },
      },
      prolongedEstimation: {
        banner: 'En estimación continua hace {days} días',
        since: 'Inicio',
        cause: 'Causa',
        causeDetail: 'Estimación aprobada continua en {dataScope} para {quantity} (nivel {level})',
        levels: {
          initial: 'Inicial',
          intermediate: 'Intermedio',
          critical: 'Crítico',
        },
        recommendedAction: 'Acción recomendada',
        suggestServiceOrder: 'Sugerencia: considere abrir una orden de servicio de campo',
      },
      exceptions: {
        title: 'Excepciones activas',
        empty: 'Ninguna excepción activa',
        loadError: 'No fue posible cargar las excepciones.',
        edit: 'Editar',
        resolve: 'Resolver',
        ignore: 'Ignorar',
        resolveTooltip: 'Marcar esta excepción como resuelta',
        ignoreTooltip: 'Ignorar esta excepción',
        editTooltip: 'Editar las lecturas relacionadas con esta excepción',
        columns: {
          rule: 'Regla',
          status: 'Estado',
          actions: 'Acciones',
        },
        status: {
          pendente: 'Pendiente',
          emAnalise: 'En análisis',
          resolvida: 'Resuelta',
          ignorada: 'Ignorada',
        },
        availability: {
          dataGap: 'Laguna de datos',
          communicationFailure: 'Falla de comunicación',
          confirmedInterruption: 'Interrupción confirmada',
          confirmedInterruptionAmiHint:
            'Interrupción confirmada por correlación de eventos AMI (corte + restauración).',
        },
        correlatedEvent: {
          label: 'Evento Correlacionado',
          amiHint: 'Interrupción confirmada por correlación de eventos AMI (corte + restauración).',
          manualHint: 'Interrupción confirmada por alarma registrada manualmente.',
        },
        rules: {
          IntervalSize: 'Tamaño de Intervalo',
          DuplicateImd: 'Duplicidad en Memoria de Masa',
          ConsecutiveInterval: 'Intervalos Consecutivos',
          UoM: 'Unidad de Medida',
          SumCheck: 'Verificación de Suma',
          HighLow: 'Límite Superior/Inferior',
          Zero: 'Consumo Cero',
          Negative: 'Valor Negativo',
          Static: 'Lectura Estática',
          Spike: 'Variación Abrupta',
          Missing: 'Ausencia de Lectura',
          DynamicComparison: 'Comparación Dinámica',
          ProlongedZero: 'Cero Prolongado',
          RegisterInversion: 'Inversión de Registrador',
          Rollover: 'Rollover del Totalizador',
          Multiplier: 'Multiplicador',
          Duplicate: 'Duplicidad en Totalizador',
          UoMCompatibility: 'Compatibilidad de Unidad',
          InactiveMeasurement: 'Medición con Medidor Inactivo',
          ProlongedEstimation: 'Estimación Prolongada',
          CustomRuleEngine: 'Regla Personalizada',
          BurnedTp: 'TP quemado',
          BurnedTc: 'TC quemado',
          BurnedMeter: 'Medidor quemado',
        },
      },
      estimationRequest: {
        title: 'Generar Propuestas de Estimación',
        openTooltip: 'Generar propuestas de estimación para esta laguna',
        openLabel: 'Generar estimaciones',
        intro:
          'Solicite la generación de propuestas para un período de la laguna. El procesamiento ocurre en segundo plano y las propuestas pasan por validación secundaria y aprobación humana.',
        limits: 'Máximo de {max} intervalos por solicitud (intervalos de {minutes} min).',
        zeroFillNote:
          'Las lagunas continuas mayores que {hours} h no usan ZeroFill, aunque se soliciten en partes.',
        period: 'Período',
        periodPlaceholder: 'Seleccione el período',
        intervals: '{count} intervalo(s)',
        proposalsCount: '{count} propuesta(s)',
        intervalsExceeded: 'El período excede el máximo de {max} intervalos por solicitud.',
        periodStartRequired: 'Indique la fecha y hora de inicio.',
        periodEndRequired: 'Indique la fecha y hora de fin.',
        periodEndNotAfterStart: 'La fecha y hora de fin debe ser posterior a la de inicio.',
        periodNotAligned: 'La duración del período debe ser múltiplo de {minutes} minutos.',
        noGaps: 'La ocurrencia no presenta intervalos ausentes para estimar.',
        gaps: 'Lagunas de la ocurrencia',
        gapsLoadError: 'No se pudieron cargar las lagunas.',
        runExceedsLimit:
          'Excede {max} intervalos: al usar el período solo se aplica un subperíodo de hasta {max} intervalos.',
        appliedRunPartial:
          'Laguna completa: {period} ({total} intervalos). Aplicado al formulario: los primeros {max} intervalos ({subperiod}). Los demás intervalos requieren nuevas solicitudes.',
        viewProposals: 'Ver propuestas',
        useRun: 'Usar período',
        zeroFillAllowed: 'Permitido',
        zeroFillBlocked: 'Bloqueado',
        validationMissing: 'Validación secundaria no configurada',
        validationReady: 'Validación secundaria configurada para el período.',
        periodRejected: 'Período no aceptado para la generación',
        clear: 'Limpiar',
        clearTooltip: 'Limpiar el período seleccionado',
        appliedRun: 'Período completado a partir de la laguna',
        selectedRun: 'Seleccionada',
        periodStartPlaceholder: 'Fecha y hora de inicio',
        periodEndPlaceholder: 'Fecha y hora de fin',
        validationChecking: 'Verificando la validación secundaria del período...',
        validationCheckError: 'No se pudo verificar la validación secundaria del período.',
        request: 'Solicitar generación',
        requests: 'Solicitudes',
        noRequests: 'Ninguna solicitud para esta ocurrencia.',
        close: 'Cerrar',
        loadError: 'No fue posible cargar los datos de la generación de propuestas.',
        requestSuccess: 'Solicitud enviada. El procesamiento ocurre en segundo plano.',
        requestExisting: 'Ya existe una solicitud para este período.',
        requestError: 'No fue posible solicitar la generación de propuestas.',
        completedHint:
          'Propuestas generadas: aparecen en "Propuestas de Estimación" para validación y aprobación.',
        columns: {
          period: 'Período',
          intervals: 'Intervalos',
          status: 'Situación',
          proposals: 'Propuestas',
          details: 'Detalles',
          zeroFill: 'ZeroFill',
          actions: 'Acciones',
        },
        status: {
          pending: 'En cola',
          running: 'Procesando',
          completed: 'Concluida',
          completedWithFailures: 'Concluida con fallas',
          failed: 'Falló',
        },
        failedRuns: '{count} laguna(s) sin método aplicable',
        toast: {
          refreshErrorTitle: 'Error al actualizar',
          requestSuccessTitle: 'Generación solicitada',
          requestExistingTitle: 'Solicitud existente',
          requestErrorTitle: 'Error al solicitar la generación',
        },
      },
      estimateProposals: {
        title: 'Propuestas de estimación',
        empty: 'Ninguna propuesta pendiente',
        loadError: 'No fue posible cargar las propuestas de estimación.',
        approve: 'Aprobar',
        reject: 'Rechazar',
        notEligible: 'No elegible para aprobación',
        columns: {
          method: 'Método',
          actions: 'Acciones',
        },
        methods: {
          interpolation: 'Interpolación',
          proxyDay: 'Día de referencia',
          loadProfile: 'Perfil de carga',
          scalarCalculation: 'Cálculo por diferencia de acumulador',
          zeroFill: 'Relleno con cero',
          burnedEquipmentFactor15: 'Factor 1,5 (TP/TC quemado)',
          burnedMeterHistoricalAverage: 'Promedio histórico (medidor quemado)',
        },
      },
      approvedHistory: {
        title: 'Historial de Estimaciones Aprobadas',
        approvalPeriod: 'Período de aprobación',
        periodPlaceholder: 'Seleccione el período',
        periodTooltip: 'Filtra por la fecha de aprobación, no por el período de la lectura.',
        loadError: 'No se pudo cargar el historial de estimaciones aprobadas.',
        empty: 'Ninguna estimación aprobada para este medidor.',
        emptyFiltered: 'Ninguna estimación aprobada en el período de aprobación seleccionado.',
        columns: {
          approvedAt: 'Aprobada el',
          readingPeriod: 'Período de la lectura',
          method: 'Método',
          value: 'Valor aprobado',
          user: 'Usuario',
          status: 'Estado',
          actions: 'Acciones',
        },
        statusApproved: 'Aprobada',
        details: 'Detalles',
        footnote: 'Horarios: aprobación en hora local y lecturas en hora del medidor. El valor aprobado puede diferir del valor efectivo actual.',
        detailsTitle: 'Estimación Aprobada',
        readingPeriodSameDay: '{date}, de {start} a {end}',
        readingPeriodMultiDay: 'De {start} a {end}',
        auditNotFound: 'No se encontró el registro de auditoría de esta aprobación.',
        auditLoadError: 'No se pudo consultar la auditoría de esta aprobación.',
        detailsLoadError: 'No se pudieron cargar todos los detalles de la propuesta.',
        measurement: 'Magnitud',
        proposedValue: 'Valor propuesto',
        group: 'Grupo VEE',
        rule: 'Regla',
        effective: {
          title: 'Valor efectivo actual',
          hint: 'Consulte qué valor utiliza actualmente el VEE para esta lectura. Una lectura recibida posteriormente o una edición manual puede prevalecer sobre la estimación aprobada.',
          check: 'Consultar valor efectivo',
          value: 'Valor',
          origin: 'Origen',
          noValue: 'Sin valor',
          differs: 'El valor efectivo actual es distinto del valor aprobado.',
          loadError: 'No se pudo consultar el valor efectivo actual.',
          origins: {
            '0': 'Ninguno',
            '1': 'Edición manual',
            '2': 'Estimación aprobada',
            '3': 'Lectura bruta',
          },
        },
        quality: {
          '1': 'Real',
          '2': 'Estimación propuesta',
          '3': 'Estimado aprobado',
          '4': 'Editado',
          '5': 'Ausente',
          '6': 'Sin comunicación',
          '7': 'Interrumpido',
        },
        viewAudit: 'Ver auditoría',
        close: 'Cerrar',
      },
      auditTrail: {
        title: 'Historial de Ediciones',
        empty: 'Ningún registro de auditoría para el filtro seleccionado.',
        loadError: 'No fue posible cargar el historial de auditoría.',
        period: 'Período',
        periodPlaceholder: 'Seleccione el período',
        operator: 'Operador',
        operatorPlaceholder: 'Seleccione el operador',
        actionType: 'Tipo de acción',
        actionTypePlaceholder: 'Seleccione el tipo de acción',
        entityType: 'Entidad relacionada',
        entityTypePlaceholder: 'Seleccione la entidad',
        qualityStatus: 'Marca de calidad',
        qualityStatusPlaceholder: 'Seleccione la marca de calidad',
        clearFilters: 'Limpiar filtros',
        exportCsv: 'Exportar CSV',
        exportJson: 'Exportar JSON',
        before: 'Antes',
        after: 'Después',
        details: 'Ver detalles',
        qualityNotApplicable: 'No aplicable',
        proposalStatus: {
          pending: 'Pendiente',
          approved: 'Aprobada',
          rejected: 'Rechazada',
          invalid: 'Inválida',
          cancelled: 'Cancelada',
        },
        detailsDialog: {
          title: 'Detalles del Cambio',
          before: 'Antes',
          after: 'Después',
        },
        actionTypes: {
          Created: 'Creado',
          Edited: 'Editado',
          Approved: 'Aprobado',
          Rejected: 'Rechazado',
          StatusChanged: 'Estado cambiado',
          BillingManuallyReleased: 'Facturación desbloqueada manualmente',
          ManualOccurrenceCreated: 'Ocurrencia manual',
          HistoryConsolidated: 'Historial consolidado',
          BatchSubmitted: 'Lote enviado',
          BatchDecided: 'Lote decidido',
          DecisionRecorded: 'Decisión registrada',
          SecondaryValidated: 'Validación secundaria completada',
          Applied: 'Aplicado',
          ValueAdjusted: 'Valor ajustado',
          Updated: 'Actualizado',
          Deactivated: 'Desactivado',
          ParametersUpdated: 'Parámetros actualizados',
          ScheduledCreated: 'Programación creada',
          BillingCalendarTriggerCreated: 'Disparador del calendario de facturación creado',
          BillingCalendarEscalationTransferredAfterFailure:
            'Escalamiento del calendario de facturación transferido tras fallo',
          ScheduledSkippedNoEligibleMeters: 'Programación omitida: sin medidores elegibles',
        },
        entityTypes: {
          VeeManualReadingOverride: 'Edición manual de lectura',
          VeeEstimationProposal: 'Propuesta de estimación',
          VeeException: 'Excepción',
          VeeServiceRequest: 'Solicitud de servicio',
          VeeBillingReadinessCurrentStatus: 'Preparación de facturación',
          VeeManualEditBatch: 'Lote de edición manual',
          VeeExecution: 'Ejecución VEE',
          VeeGroup: 'Grupo VEE',
          VeeBillingCalendar: 'Calendario de facturación',
          VeeRuleParameter: 'Parámetro de regla',
          VeeRule: 'Regla VEE',
          VeeNotificationConfig: 'Configuración de notificación',
          VeeGroupBatchApprovalPolicy: 'Política de aprobación por lote del grupo',
          VeeBillingReadinessEvent: 'Evento de preparación de facturación',
          VeeBillingCalendarEscalation: 'Escalamiento del calendario de facturación',
        },
        columns: {
          occurredAt: 'Fecha/Hora',
          action: 'Tipo de acción',
          entity: 'Entidad',
          actor: 'Usuario',
          reason: 'Justificación',
          qualityStatus: 'Indicador de Calidad',
          actions: 'Acciones',
        },
      },
      decisionDialog: {
        approveTitle: 'Aprobar Propuesta de Estimación',
        rejectTitle: 'Rechazar Propuesta de Estimación',
        loading: 'Cargando detalles de la propuesta...',
        loadError: 'No fue posible cargar los detalles de la propuesta.',
        proposalChanged: 'La propuesta cambió desde que se cargó la lista.',
        reload: 'Recargar',
        method: 'Método',
        period: 'Período',
        proposedValue: 'Valor propuesto',
        measurementKey: 'Magnitud',
        secondaryValidation: 'Validación secundaria',
        secondaryValidationStatus: {
          approved: 'Aprobada',
          rejectedByRule: 'Rechazada por regla',
          infeasible: 'Inviable',
          technicalFailure: 'Falla técnica',
          none: 'No evaluada',
        },
        originalData: 'Dato original',
        originalDataUnavailable: 'Ningún dato original disponible.',
        originalDataFields: {
          timestamp: 'Fecha y hora',
          value: 'Valor',
          unit: 'Unidad',
          source: 'Origen',
          marker: 'Marcador',
          slot: 'Intervalo',
          measurementKey: 'Magnitud',
          slotStart: 'Inicio del intervalo',
          slotEnd: 'Fin del intervalo',
          slotTimestamp: 'Fecha y hora del intervalo',
          note: 'Observación',
        },
        referenceReadings: 'Lecturas de referencia utilizadas',
        referenceReadingsEmpty: 'Ninguna lectura de referencia disponible.',
        referenceReadingRole: {
          leading: 'Anterior',
          trailing: 'Posterior',
          context: 'Contexto',
          before: 'Antes',
          after: 'Después',
          anchor: 'Referencia',
          comparableTransition: 'Transición comparable',
          accumulatorBefore: 'Acumulador anterior',
          accumulatorAfter: 'Acumulador posterior',
        },
        secondaryValidationReason: {
          dataScopeMismatch: 'Fuera del alcance de datos de la regla',
          measurementKeyMismatch: 'Magnitud no coincide con la regla',
          unitMismatch: 'Unidad de medida incompatible',
          zeroToleranceViolation: 'Violación de tolerancia cero',
          negativeValueViolation: 'Valor negativo no permitido',
          rangeViolation: 'Valor fuera del rango permitido',
          meterInactive: 'Medidor inactivo',
          inactiveMeasurementHistoricalStateUnavailable: 'Historial del medidor no disponible',
          comparisonModeNotSupported: 'Modo de comparación no admitido',
          ruleNotImplemented: 'Regla no implementada',
          ruleInactive: 'Regla inactiva',
          mandatoryRuleNotImplemented: 'Regla obligatoria no implementada',
          consultiveRuleNotImplemented: 'Regla consultiva no implementada',
          invalidRuleConfiguration: 'Configuración de la regla inválida',
          insufficientDataForRule: 'Datos insuficientes para aplicar la regla',
          expectedUnitIncompatibleWithCanonical: 'Unidad esperada incompatible',
          noApplicableRules: 'Ninguna regla aplicable',
          noRulesConfigured: 'Ninguna regla configurada en el grupo VEE',
          incompleteProposalData: 'Datos de la propuesta incompletos',
          technicalErrorDuringRule: 'Falla técnica durante la ejecución de la regla',
        },
      },
      editReadingDialog: {
        title: 'Edición manual de lectura',
        editReading: 'Editar lectura',
        readingTimestamp: 'Fecha y hora de la lectura',
        readingTimestampPlaceholder: 'Seleccione la fecha y hora',
        scope: 'Alcance',
        scopePlaceholder: 'Seleccione el alcance',
        scopes: {
          massMemory: 'Memoria de Masa',
          totalizers: 'Totalizadores',
        },
        measurementKey: 'Magnitud',
        measurementKeyPlaceholder: 'Seleccione la magnitud',
        newValue: 'Nuevo valor',
        newValuePlaceholder: 'Ingrese el nuevo valor',
        justification: 'Justificación (obligatoria)',
        justificationPlaceholder: 'Describa el motivo de la edición manual',
        reasonCode: 'Motivo estructurado',
        reasonCodePlaceholder: 'Seleccione el motivo',
        reasonCodes: {
          meterReadingError: 'Error de lectura del medidor',
          communicationFailureCompensation: 'Compensación por falla de comunicación',
          fieldInspectionCorrection: 'Corrección por inspección de campo',
          dataEntryCorrection: 'Corrección de digitación',
          other: 'Otro',
        },
        preview: 'Previsualizar',
        previewing: 'Previsualizando...',
        previewErrors: 'Corrija los elementos siguientes antes de previsualizar de nuevo:',
        previewRequired: 'Previsualice la edición antes de confirmar.',
        previewSummary: {
          originalValue: 'Valor original',
          newValue: 'Nuevo valor',
          unit: 'Unidad',
          group: 'Grupo VEE',
          activeOverride:
            'Ya existe una edición activa en esta lectura (versión {version}, valor actual {value}).',
          predictedOccurrences: 'Impacto previsto en el reprocesamiento',
          noPredictedOccurrences: 'Ninguna ocurrencia prevista para el nuevo valor.',
        },
        severities: {
          info: 'Informativo',
          issue: 'Alerta',
          terminate: 'Crítico',
        },
        cancel: 'Cancelar',
        confirm: 'Confirmar edición',
        confirming: 'Confirmando...',
      },
      rejectProposalDialog: {
        justification: 'Justificación (obligatoria)',
        justificationPlaceholder: 'Describa el motivo del rechazo de la propuesta',
        cancel: 'Cancelar',
        confirm: 'Rechazar propuesta',
      },
      exceptionDecisionDialog: {
        resolveTitle: 'Resolver Excepción',
        ignoreTitle: 'Ignorar Excepción',
        justification: 'Justificación (obligatoria)',
        justificationPlaceholder: 'Describa el motivo de esta decisión sobre la excepción',
      },
      errors: {
        loadFailed: 'No fue posible cargar los datos VEE de este medidor.',
        retry: 'Intentar de nuevo',
      },
      ccee: {
        ready: 'Disponible para Mercado Libre',
        notReady: 'No disponible para Mercado Libre',
      },
      toast: {
        justificationRequiredTitle: 'Justificación obligatoria',
        justificationRequired: 'Informe la justificación para editar la lectura.',
        readingUpdatedTitle: 'Lectura actualizada',
        readingUpdatedDetail: 'La lectura se actualizó con éxito.',
        proposalApprovedTitle: 'Estimación aprobada',
        proposalApprovedDetail: 'Propuesta por {method} aprobada y aplicada a la lectura actual.',
        proposalRejectedTitle: 'Estimación rechazada',
        proposalRejectedDetail: 'Propuesta por {method} rechazada.',
        proposalActionErrorTitle: 'No fue posible completar la decisión',
        proposalActionErrorDetail:
          'Ocurrió un error al procesar la decisión sobre la propuesta. Intente de nuevo.',
        exceptionResolvedTitle: 'Excepción resuelta',
        exceptionResolvedDetail: '{rule} marcada como resuelta.',
        exceptionIgnoredTitle: 'Excepción ignorada',
        exceptionIgnoredDetail: '{rule} marcada como ignorada.',
        exceptionActionErrorTitle: 'No fue posible completar la acción',
        exceptionActionErrorDetail:
          'Ocurrió un error al procesar la acción sobre la excepción. Intente de nuevo.',
        overridePreviewErrorTitle: 'No fue posible previsualizar la edición',
        overridePreviewErrorDetail: 'Verifique los datos informados e intente de nuevo.',
        overrideConfirmedTitle: 'Lectura editada',
        overrideConfirmedDetail:
          'La edición fue confirmada y el reprocesamiento generó {count} ocurrencia(s).',
        overrideConflictTitle: 'Conflicto de edición',
        overrideConflictDetail:
          'La lectura fue alterada desde la previsualización. Previsualice de nuevo.',
        overrideConfirmErrorTitle: 'No fue posible confirmar la edición',
        overrideConfirmErrorDetail: 'Ocurrió un error al confirmar la edición. Intente de nuevo.',
        periodTooLongTitle: 'Período inválido',
        periodTooLongDetail: 'El período consultado no puede exceder {days} días.',
        periodIncompleteTitle: 'Período incompleto',
        periodIncompleteDetail: 'Seleccione fecha inicial y final antes de aplicar el filtro.',
        periodRequiredTitle: 'Período obligatorio',
        periodRequiredDetail: 'Informe la fecha inicial y final para consultar las lecturas.',
      },
    },
    manualInsertReadings: {
      title: 'Edición de Lecturas/Alarmas manuales',
      tabs: {
        meterAlarms: 'Alarmas Medidores',
        dataReadings: 'Memoria de Masa',
        frozenData: 'Totalizadores',
        qeeIndicators: 'Calidad',
        smcAlarms: 'Alarmas SMCs',
      },
      meterAlarmsTable: {
        serial: 'Serial',
        description: 'Descripción',
        terminal: 'Terminal',
        read: 'Leído',
        manualInsert: 'Es manual',
        installation: 'Instalación',
        user: 'Usuario',
        translate: 'Traducción',
        readDate: 'Fecha de Lectura',
        updatedAt: 'Última Actualización',
      },
      dataReadingsTable: {},
      frozenDataTable: {},
      qeeIndicatorsTable: {
        serial: 'Serial',
        comissioned: 'Comis',
        online: 'Online',
        dateTimeInitial: 'Fecha/Hora Inicial',
        dateTimeFinal: 'Fecha/Hora Final',
        drp: 'DRP',
        drc: 'DRC',
        dtt95: 'DTT95',
        fd95: 'FD95',
        count: 'Conteo',
        meterActivated: 'Medidores Activados',
        drcPhaseA: 'DrcPhaseA',
        drcPhaseB: 'DrcPhaseB',
        drcPhaseC: 'DrcPhaseC',
        drpPhaseA: 'DrpPhaseA',
        drpPhaseB: 'DrpPhaseB',
        drpPhaseC: 'DrpPhaseC',
        consumerUnitsId: 'Unidad Consumidora',
        updatedAt: 'Actualizado en',
      },
      smcAlarmsTable: {
        serial: 'Serial',
        description: 'Descripción',
        read: 'Leído',
        isManualInsert: 'Es manual',
        user: 'Usuario',
        translate: 'Traducción',
        readDateTime: 'Fecha/Hora de Lectura',
        updatedAt: 'Última Actualización',
      },
      messages: {
        qeeEditUnavailable: 'Edición no disponible.',
        qeeDeleteUnavailable: 'Eliminación no disponible.',
        qeeClosedCycle:
          'El período seleccionado ya fue cerrado y no permite edición manual. Plazo permitido hasta: {deadline}.',
        qeeDeleteClosedCycle:
          'El período seleccionado ya fue cerrado y no permite eliminación manual. Plazo permitido hasta: {deadline}.',
        invalidDateRange: 'La Fecha/Hora Inicial no puede ser mayor que la Fecha/Hora Final.',
        requiredDrpDrc: 'DRP y DRC son obligatorios.',
        useCommaDecimalSeparator: 'Informe DRP y DRC usando coma y hasta 3 decimales.',
        qeeUpdateSuccess: 'Parámetro actualizado correctamente.',
        qeeUpdateError: 'No fue posible actualizar el parámetro QEE.',
        qeeDeleteConfirmTitle: 'Confirmar eliminación',
        qeeDeleteConfirmMessage: '¿Desea realmente eliminar este parámetro de calidad?',
        qeeDeleteConfirmAction: 'Eliminar',
        qeeDeleteSuccess: 'Parámetro de calidad eliminado correctamente.',
        qeeDeleteError: 'No fue posible eliminar el parámetro de calidad.',
      },
    },
    consumerUnit: {
      fullName: 'Nombre Completo',
      address: 'Dirección',
      locationCode: 'Código de Ubicación',
      consumerUnitCode: 'Código de la Unidad',
      situationCode: 'Código de Situación',
      situationDate: 'Fecha de Situación',
      consumptionClassCode: 'Código de Consumo',
      equipmentNumber: 'Número de Equipo',
      historyUc: 'Histórico',
      communicationDescription: 'Comunicación',
      startRelationDatetime: 'Inicio de la Relación',
      endRelationDatetime: 'Fin de la Relación',
    },
    smcs: {
      title: 'SMCs',
      smcInfo: {
        title: 'Detalles del SMC',
        model: 'Modelo',
        brand: 'Marca',
        serial: 'Serial',
        qtyMeters: 'Cantidad de Clientes',
        uplinkPeriod: 'Período de Uplink de Lectura',
        signalQuality: 'Señal',
        networkPublic: 'Pública ',
        networkPrivate: 'Privada ',
        description: 'Descripción',
        latitude: 'Latitud',
        longitude: 'Longitud',
        tagsFilterTitle: 'Filtros aplicados',
        tagsFilterDetails: 'Filtros por etiquetas aplicados; sin embargo, SMC no tiene etiquetas.',
        doorStatus: 'Estado de la Puerta',
        online: 'Estado de la Comunicación',
        comissioned: 'Comisionado',
      },
      criticalAlarms: {
        title: 'Alertas Críticas',
        criticalAlarm: 'Alarma crítica',
        readDateTime: 'Hora de Lectura:',
        updatedAt: 'Última Actualización:',
        notFound: '¡No se encontraron alarmas críticas!',
        relayFailure: 'Falla del Relé',
        openDoor: 'Puerta Abierta',
        smcTimeout: 'Tiempo de espera del SMC',
        lastGasp: 'Último Gasp',
        localReset: 'Reconexión local',
        measurementError: 'Error en el sistema de medición',
        keysHLSInvalid: 'Claves HLS Inválidas',
        invalidMeter: 'Medidor Inválido',
      },
      success: {
        createSmc: 'SMC creado con éxito',
        updateSmc: 'SMC actualizado con éxito',
      },
      errors: {
        createSmc: 'Error al crear SMC',
        updateSmc: 'Error al actualizar SMC',
        loadSmcModels: 'Error al cargar modelos de SMC',
      },
      summary: {
        statusTitle: 'Estado',
        commissioningTitle: 'Comisionamiento',
        portTitle: 'Estado del puerto',
        fetchErrorTitle: 'Error',
        fetchErrorDetail: 'Error al buscar el resumen de SMCs',
        online: 'En línea',
        offline: 'Fuera de línea',
        absent: 'Ausente',
        commissioned: 'Comisionado',
        notCommissioned: 'No comisionado',
        authorized: 'Autorizado',
        unauthorized: 'Desautorizado',
        details: {
          onlineTitle: 'SMCs en línea',
          offlineTitle: 'SMCs fuera de línea',
          absentTitle: 'SMCs ausentes',
          commissionedTitle: 'SMCs comisionados',
          notCommissionedTitle: 'SMCs no comisionados',
          authorizedTitle: 'SMCs con estado del puerto autorizado',
          unauthorizedTitle: 'SMCs con estado del puerto desautorizado',
          selectBrand: 'Seleccione la marca',
        },
      },
      registerSmcFile: 'Importar SMCs desde archivo',
      editSmcFile: 'Editar SMCs desde archivo',
      massActionStartedTitle: 'Proceso iniciado',
      massActionStartedDetail: 'Proceso iniciado. Espere a que finalice la acción.',
    },
    modemInfo: {
      title: 'Módem',
      notAvailable: 'No disponible',
      noInformation: 'Sin información',
      deviceEui: 'EUI',
      firmwareVersion: 'Firmware',
      signal: 'Señal',
      iccid: 'ICCID',
      imei: 'IMEI',
      imsi: 'IMSI',
      operator: 'Operadora',
      cellId: 'Cell ID',
      signalQuality: 'Señal',
      bootCounter: 'Boot Counter',
      snr: 'SNR',
      rssi: 'RSSI',
      bleStack: 'BleStack',
      mcuRevision: 'Revisión MCU',
      celLv: 'Nivel de Celda',
      tempC: 'Temperatura',
      rsrp: 'RSRP',
      rsrq: 'RSRQ',
      txpwr: 'Potencia TX',
      band: 'Band',
      lastUpdated: 'Última actualización',
      resetNic: 'Reiniciar NIC',
      resetNicConfirm: '¿Está seguro?',
    },
    commands: {
      title: 'Comandos',
      command: 'Comando',
      notAvailable: 'No disponible',
      state: 'Estado',
      commandQueue: 'Comandos en Cola',
      noCommand: 'Sin Comando en Cola',
      lastSeen: 'Última Comunicación',
      communication: 'Comunicación',
      noCommunication: 'No disponible',
      lastCommand: 'Último Comando',
      sendCommand: 'Enviar',
      notImplemented: 'Comando no implementado',
      voltageOutIntervalMinites: 'Minuto(s)',
      voltageOutIntervalHours: 'Hora(s)',
      voltageOutIntervalDays: 'Día(s)',
      sendToSelected: 'Enviar a Seleccionados',
      sendToAll: 'Enviar a todos',
      listOfCommands: {
        setSmiVoltageOutInterval: 'Definir Intervalo DIC/FIC',
        setSmiQueeInterval: 'Definir Intervalo DRP/DRC',
        setTariff: 'Definir Tipo de Tarifa',
        updateDateTime: 'Actualizar Fecha y Hora',
        readDateTime: 'Leer Fecha y Hora',
        updatePeriod: 'Cambiar Período',
        getRelay: 'Obtener estado del relé',
        setRelayOff: 'Desconectar Relé',
        setRelayOn: 'Conectar Relé',
        setReferenceVoltage: 'Tensión de Referencia',
        getReferenceVoltage: 'Obtener Tensión de Referencia',
        recoverActiveEnergy: 'Solicitar Energías',
        getNetworkType: 'Obtener Tipo de Red',
        setNetworkPublic: 'Cambiar a red pública',
        setNetworkPrivate: 'Cambiar a red privada',
        getTech: 'Obtener Tecnología',
        setNetworkCatm1: 'Cambiar a CATM1',
        setNetworkNbiot: 'Cambiar a NBIoT',
        getCellIdAndIP: 'Obtener Cell ID e IP',
        getHeartbeat: 'Recuperar calidad de señal',
        setEventQeeIndicator: 'Recuperar Parámetros de Calidad',
        setStandartFrozenData: 'Definir Energías Estándar',
        setDisplayAuto: 'Configurar Display Automático',
        setDisplayManual: 'Configurar Display Manual',
        setDisplayAutoMicroMax: 'Configurar Display Automático MicroMax',
        setDisplayManualMicroMax: 'Configurar Display Manual MicroMax',
        recoverShortDurationAlarms: 'Recuperar Alarmas de Corta Duración',
        getFiscalPage: 'Recuperar Página Fiscal',
        getLoadProfile: 'Recuperar Perfil de Carga',
        getDailyBilling: 'Recuperar Facturación Diaria',
        updateDatetimeSmc: 'Actualizar Fecha/Hora (SMC)',
        updateDatetimeSmi: 'Actualizar Fecha/Hora (SMI)',
        instantMeasureSmc: 'Lectura Instantánea SMC',
        instantMeasureSmi: 'Lectura Instantánea',
        requestInstantMeasures: 'Solicitar mediciones instantáneas',
        nicResetSmi: 'Reiniciar NIC SMI',
        nicResetSmc: 'Reiniciar NIC SMC',
        recoverMassMemorySmc: 'Recuperar Memoria de Masa (SMC)',
        recoverMassMemorySmi: 'Recuperar Memoria de Masa (SMI)',
        recoverEnergySmc: 'Recuperar Energía SMC',
        recoverEnergySmi: 'Recuperar Energía',
        recoverQeeIndicator: 'Recuperar Indicador QEE (Nepen)',
        requestRelayStatusAllSmc: 'Obtener estado del relé SMC',
        requestDoorStatus: 'Obtener Estado de la Puerta',
        getVoltageOutLong: 'Obtener Alarma de Interrupción Larga',
        getVoltageOutShort: 'Obtener Alarma de Interrupción Corta',
        setStandardFrozenData: 'Configurar Plantilla de Energía Estándar',
        getQeeTransparent: 'Obtener Transparencia',
        readDisplayConfiguration: 'Leer Configuración del Display',
        setDisplayConfiguration: 'Configurar Display',
        voltageInterruptionMonthly: 'Obtener Interrupción de Tensión Mensual',
        drpDrcMonthly: 'Obtener DRP/DRC Mensual',
        drpDrcCycle: 'Obtener DRP/DRC Semanal',
        nicReset: 'Reset de la NIC',
        monitoring: 'Perfil de Carga (Energía + Memoria)',
        deviceReset: 'Reiniciar Dispositivo',
        infoRequest: 'Solicitar información general',
        requestConfiguration: 'Solicitar configuración',
        getBlockSize: 'Obtener Tamaño del Bloque',
        imageTransferInitiate: 'Iniciar Transferencia de Imagen',
        imageTransferData: 'Datos de Transferencia de Imagen',
        getFirstBlockNotTransferred: 'Obtener Primer Bloque No Transferido',
        imageTransferVerify: 'Verificar Transferencia de Imagen',
        imageTransferActivate: 'Activar Transferencia de Imagen',
        updateFirmware: 'Actualizar Firmware',
        uploadFirmware: 'Cargar Firmware',
        getHardwareInfo: 'Obtener Información de Hardware',
        readNicInfo: 'Esperando',
        readNicSetup: 'Esperando',
        readRelay: 'Esperando',
        readTimestamp: 'Esperando',
        readNicData: 'Esperando',
        nicSetup: 'Esperando',
        readLdrUpper: 'Esperando',
        readLdrBottom: 'Esperando',
        readLdrMin: 'Esperando',
        setLdrUpper: 'Esperando',
        setLdrBottom: 'Esperando',
        setLdrMin: 'Esperando',
        readNicSerial: 'Esperando',
        readRelayWithLastSwitchOn: 'Esperando',
        readRelayWithLastSwitchOnAndOff: 'Esperando',
        setBlockSize: 'Esperando',
        multicastGroupSetup: 'Esperando',
        multicastClassCSession: 'Esperando',
        multicastSetupConfirmation: 'Esperando',
        imageTransferStatus: 'Esperando',
        getFirmwareVersion: 'Esperando',
        readAlarmFakeOnOff: 'Esperando',
        configureApplicationGroup: 'Esperando',
        readALarmLastGasp: 'Esperando',
        setLastGaspVoltageLevel: 'Esperando',
        readAlarmVoltageMonitor: 'Esperando',
        setVoltageMinimalInterval: 'Esperando',
        setAlarmFakeOnOffThreshold: 'Esperando',
        readTemperatureValue: 'Esperando',
        readRelayWithDelay: 'Esperando',
        deviceCreated: 'Dispositivo creado',
        deviceUpdated: 'Dispositivo actualizado',
        scheduleCreated: 'Programación creada',
        scheduleUpdated: 'Programación actualizada',
        groupCreated: 'Grupo creado',
        groupUpdated: 'Grupo actualizado',
        setAlarmFakeOnOff: 'Alarma On/Off',
        scheduleCanceled: 'Programación cancelada',
        scheduleDeleted: 'Programación eliminada',
        deviceDeleted: 'Dispositivo eliminado',
        groupDeleted: 'Grupo eliminado',
        checkScheduleStatus: 'Verificar estado de la programación',
        activateSchedule: 'Activar programación',
        deactivateSchedule: 'Desactivar programación',
        checkScheduleExist: 'Verificar si existe la programación',
        readDeviceType: 'Leer tipo de dispositivo',
        writeDeviceRole: 'Asignar tipo de dispositivo',
        fullScheduleCommand: 'Comando de programación completo',
        scheduleCreatedOnSystem: 'Programación creada (Sistema)',
        activateScheduleOnSystem: 'Activar programación (Sistema)',
        checkScheduleStatusOnSystem: 'Verificar estado de la programación (Sistema)',
        writeDeviceRoleOnSystem: 'Asignar tipos de dispositivo (Sistema)',
        deactivateScheduleOnSystem: 'Desactivar programación (Sistema)',
        checkScheduleExistOnSystem: 'Verificar si existe la programación (Sistema)',
        readDeviceTypeOnSystem: 'Leer tipo de dispositivo (Sistema)',
        setDatetimeOnSystem: 'Actualizar Fecha y Hora (Sistema)',
        periodicConfiguration: 'Configuración de Periodicidad',
        decommissioning: 'Desmantelamiento',
        openSession: 'Abrir Sesión con Medidor',
        readMeterSerial: 'Leer Serial del Medidor',
        importMassMeters: 'Importar medidores en masa',
        saveConfig: 'Guardar configuración',
        readConfig: 'Leer configuración',
        saveTime: 'Guardar fecha y hora',
        timeCorrection: 'Corrección de hora',
        storage: 'Almacenamiento',
        fuotaPause: 'Pausa de actualización de firmware',
        deleteSpecialDays: 'Eliminar días festivos',
        getTotalizers: 'Leer totalizadores',
        getRelayStatusControl: 'Leer Estado de Control del Relé',
        setRelayStatusControl: 'Cambiar Estado de Control del Relé',
        getIntegrationInstantaneousReadings: 'Leer valores instantáneos',
        getVoltageOutLongShort: 'Obtener Alarma de Voltage Out Larga y corta',
        relayStatusOrca: 'Recuperar estado del relé orca',
        getQeeOnDemand: 'Solicitar parámetros de calidad por demanda',
        getQeeHistoricalData:
          'Solicitar el historial de lectura de datos de los parámetros de calidad',
        recoverFragmentedPacket: 'Recuperar datos fragmentados',
        drpDrcEventLog: 'Registro de eventos DRP y DRC',
        readTariffPeriods: 'Obtener Lectura de Tarifa',
        smartFuseAlarmAck: 'Alarma Ack',
        getCollectiveCutStatus: 'Obtener Estado de corte colectivo',
        sendRollback: 'Enviar RollBack',
        disableCollectiveCut: 'Autorizar Apertura de Puertas',
        enableCollectiveCut: 'Desactivar Apertura de Puerta',
        relayOnAllMeterSmc: 'Reconectar Todos los Clientes',
        getStatus: 'Obtener Estado del Relé',
        activate: 'Activar Relé',
        disable: 'Desactivar Relé',
        requestMeters: 'Requisitar Medidores',
        getTariffReading: 'Obtener Tipo de Tarifa',
      },
      placeholders: {
        selectCommand: 'Seleccione un comando',
        sendToSelected: 'Enviar a Seleccionados',
      },
      messagesSuccess: {
        success: 'Éxito',
        commandSent: '¡Comando enviado con éxito!',
        commandExecuted: '¡Comando ejecutado con éxito!',
      },
      messagesErrors: {
        error: 'Erro',
        commandSent: 'Error al enviar comando',
        commandExecuted: 'Error al ejecutar comando',
        errorVerifyCommandCondition: 'Error al verificar condición del comando',
        errorFilterCommands: 'Error al filtrar comandos disponibles',
        commandExecutedTryAgain:
          'No fue posible ejecutar el comando.\nIntente nuevamente más tarde.',
        commandExecutedPartial: 'Los comandos fueron ejecutados parcialmente.',
        commandExecutedPartialNotExecute: ' no ejecutaron.',
      },
    },
    dataExtraction: {
      title: 'Exportación de datos',
      cardTitle: 'Extracción masiva de datos',
      dateRangePlaceholder: 'Seleccione el período',
      dateRangeTooltip: 'Informe un período de como máximo 30 días',
      selectPlaceholder: 'Tipo de exportación',
      consult: 'Consultar',
      serialLabel: 'Serial',
      serialsPlaceholder:
        'Ingrese un serial por línea o separados por coma, espacio o punto y coma. Este campo es opcional. Puede ajustar la información que desea extraer según los filtros informados. Solo el tipo de exportación y el período son obligatorios; serial y cliente son opcionales.',
      serialsHint: 'Total de seriales válidos: {total}',
      previewTitle: 'Previsualización de registros',
      tableEmpty: 'No se encontraron registros',
      noResults: 'No se encontraron registros para los filtros informados.',
      previewError: 'Error al consultar los datos para exportación.',
      columnsError: 'Error al cargar las columnas disponibles para este tipo de exportación.',
      maxRangeExceededError: 'El intervalo informado debe ser de como máximo 30 días.',
      maxRangeFutureDateError: 'La fecha final no puede ser mayor que la fecha de hoy.',
      filter: {
        typeLabel: 'Tipo de exportación',
        periodLabel: 'Período',
        clientLabel: 'Cliente',
        clientPlaceholder: 'Seleccione un cliente',
        columnsLabel: 'Columnas',
        columnsPlaceholder: 'Todas las columnas con datos',
        columnsSelected: '{0} columnas seleccionadas',
        columnsHint:
          'La lista trae solo las columnas con datos en el período consultado. Sin selección, la descarga lleva todas ellas.',
        columnsEmptyHint:
          'Consulte los datos para elegir entre las columnas que vengan con contenido.',
        validationMessage:
          'Indique el tipo de exportación y el período. El serial y el cliente son opcionales.',
      },
      types: {
        massMemory: 'Memoria de masa',
        energy: 'Energía',
        alarms: 'Alarmas',
        latestQualityParameters: 'Parámetros de calidad más recientes',
        qualityDicFic: 'Parámetros de calidad - DIC/FIC',
        qualityDrpDrc: 'Parámetros de calidad - DRP/DRC',
      },
      clearFiltersDialog: {
        title: 'Limpiar filtros',
        message: '¿Realmente desea limpiar los filtros y la vista previa de los datos?',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
      },
      summary: {
        warning: 'Atención',
        info: 'Información',
        success: 'Éxito',
        error: 'Error',
      },
    },
    firmware: {
      title: 'Versión de Firmware',
      version: 'Versión de Firmware',
      registerFirmware: 'Nueva Versión',
      editFirmware: 'Editar firmware',
      registerFirmwareFile: 'Importar firmwares desde archivo',
      editFirmwareFile: 'Editar firmwares desde archivo',
      success: {
        getFirmwares: 'Firmwares buscados con éxito',
      },
      errors: {
        getFirmwares: 'Error al buscar firmwares',
      },
    },
    keys: {
      title: 'Claves',
      importKeys: 'Importar Claves',
      editKeysInBulk: 'Editar Claves en Masa',
      registerKeysInBulk: 'Registrar Claves en Masa',
      periodPlaceholder: 'Seleccione el período',
      success: {
        getKeys: 'Claves buscadas con éxito',
        createKey: 'Clave registrada con éxito',
        updateKey: 'Clave actualizada con éxito',
        addMassKeys: 'Solicitud de registro de claves enviada',
      },
      errors: {
        getKeys: 'Error al buscar claves',
        createKey: 'Error al registrar clave',
        updateKey: 'Error al actualizar clave',
        addMassKeys: 'Error al enviar comando',
        convertKey: 'Error al convertir clave a hexadecimal',
      },
      toasts: {
        importSuccess: 'Importación completada con éxito',
        importSuccessDetail: 'Todas las claves han sido importadas con éxito',
        importPartial: 'Importación parcialmente completada',
        importPartialDetail: 'clave importada con éxito, | claves importadas con éxito,',
        importError: 'Error al importar claves',
        editSuccess: 'Edición completada con éxito',
        editSuccessDetail: 'Todas las claves han sido editadas con éxito',
        editPartial: 'Edición parcialmente completada',
        editPartialDetail: 'clave editada con éxito, | claves editadas con éxito,',
        editError: 'Error al editar claves',
        failed: 'falló | fallaron',
      },
    },
    tags: {
      title: 'Etiquetas',
      newTag: 'Nueva Etiqueta',
      success: {
        getTags: 'Etiquetas buscadas con éxito',
        createTag: 'Etiqueta creada con éxito',
        updateTag: 'Etiqueta actualizada con éxito',
        deleteTag: 'Etiqueta eliminada con éxito',
      },
      errors: {
        getTags: 'Error al buscar etiquetas',
        createTag: 'Error al crear etiqueta',
        updateTag: 'Error al actualizar etiqueta',
        deleteTag: 'Error al eliminar etiqueta',
      },
    },
    clients: {
      client: 'Cliente',
      clients: 'Clientes',
      clientDetails: 'Detalles del Cliente',
      editClient: 'Editar Cliente',
      fullName: 'Nombre Completo',
      location: 'Ubicación',
      updatedAt: 'Actualizado en',
      metersTableTitle: 'Medidores del Cliente',
      addMeters: 'Agregar Medidores',
      removeMeters: 'Eliminar Medidores',
      removeMetersDescription:
        '¿Está seguro que desea eliminar los medidores seleccionados de este cliente?',
      confirmRemoveMeters: 'Si, eliminar',
      weights: 'Pesos',
      prefixUf: 'Prefijo UF',
      bulkLink: 'Vincular en lote',
      manageLinks: 'Gestionar vínculos',
      linkedUsers: 'Usuarios vinculados',
      unlinkSelected: 'Desvincular seleccionados',
      associateClients: 'Asociar clientes',
      addToTenant: 'Agregar usuario',
      removeFromTenant: 'Eliminar del cliente',
      userAdded: 'Usuario agregado al cliente.',
      userRemoved: 'Usuario eliminado del cliente.',
      newUser: 'Nuevo usuario',
      editUser: 'Editar usuario',
      bulkLinkHeader: 'Vincular usuario a clientes en lote',
      manageLinkHeader: 'Gestionar vínculos de usuario',
      unlinkConfirm: 'Desvincular seleccionados',
      selectUser: 'Seleccione un usuario',
      selectClients: 'Seleccione los clientes',
      link: 'Vincular',
      errorLoadingClients: 'Error al cargar clientes',
      deleteClients: 'Eliminación de clientes',
      noClientSelected: 'Ningún cliente seleccionado',
      linksTitle: 'Vínculos',
      clientsLinked: '{count} cliente(s) vinculado(s).',
      clientsLinkFailed: '{count} fallaron.',
      errorLinkingClients: 'Error al vincular clientes.',
      unlinked: 'Desvinculado.',
      countUnlinked: '{count} desvinculado(s).',
      errorUnlinking: 'Error al desvincular.',
      goToBulkLink: 'Ir a vincular en lote',
      goToManageLinks: 'Ir a gestionar vínculos',
      userCreated: 'Usuario creado con éxito.',
      errorCreatingUser: 'Error al crear usuario',
    },
    users: {
      title: 'Usuarios',
      user: 'Usuario',
      newUser: 'Nuevo usuario',
      editUser: 'Editar usuario',
      yourAccountTab: 'Su Cuenta',
      allUsersTab: 'Todos los Usuarios',
      lastUpdateLabel: 'Última Actualización',
      confirmDelete: 'Confirmar eliminación de usuarios',
      userEdited: 'Usuario editado con éxito.',
      userAddedToClient: 'Usuario agregado al cliente.',
      errorAddingUser: 'Error al agregar usuario',
      userUnlocked: 'Usuario desbloqueado con éxito.',
      errorFetchingUsers: 'Error al buscar usuarios',
      noUserSelected: 'Ningún usuario seleccionado',
      deleteUsers: 'Eliminación de usuarios',
      removeUsers: 'Eliminar usuarios',
      countRemoved: '{count} eliminado(s) del cliente.',
      countFailed: '{count} fallaron.',
      usernameLabel: 'Nombre de usuario',
      adUsernameLabel: 'Nombre de usuario de AD',
      usernamePlaceholder: 'Ingrese el nombre de usuario',
      grantAccess: 'Conceder acceso',
      createUser: 'Crear',
      userTypeLabel: 'Tipo de Autenticación',
      userTypeNormal: 'Normal',
      userTypeLdap: 'LDAP',
      userExists: 'Usuario encontrado en el sistema.',
      userNotFound: 'Usuario no encontrado. Complete los datos para crear.',
      nameLabel: 'Nombre',
      emailLabel: 'Correo electrónico',
      emailPlaceholder: 'Ingrese el correo electrónico',
      passwordLabel: 'Contraseña',
      confirmPasswordLabel: 'Confirmar contraseña',
      descriptionLabel: 'Descripción',
      roleLabel: 'Función',
      receiveEmailsLabel: 'Recibir correos electrónicos',
      licenseAccessLabel: 'Acceso a la licencia',
      licenseAccessHint: 'Permite ver la pantalla de licencia y quitar o restaurar puntos. Activar la licencia y cambiar el total siguen siendo solo de NEPEN.',
      selectRolePlaceholder: 'Seleccione una función',
      optionalPlaceholder: 'Opcional',
      passwordOptionalPlaceholder: 'Dejar en blanco para mantener la contraseña actual',
      updateButton: 'Actualizar',
      invalidEmail: 'Correo electrónico inválido.',
      nameMinLength: 'El nombre debe contener al menos 4 letras.',
      passwordRequirements:
        'La contraseña debe contener al menos 8 caracteres, una letra mayúscula y una minúscula.',
      passwordMismatch: 'Las contraseñas no coinciden.',
      clientLabel: 'Vínculos de cliente',
      noClientPlaceholder: 'Sin vínculo',
      ldapOnly: 'Solo LDAP',
      statusHeader: 'Situación',
      blocked: 'Bloqueado',
      active: 'Activo',
      loginTypeHeader: 'Tipo de inicio de sesión',
      updated: 'Usuario actualizado con éxito.',
      errorUpdatingUser: 'Error al actualizar usuario.',
      noClients: 'Ningún cliente vinculado.',
      addClientPlaceholder: 'Agregar clientes...',
    },
    balance: {
      title: 'Balance',
      balanceCalculation: 'Cálculo de Balance',
      balanceSettings: 'Configuraciones del Balance',
      publicLighting: 'Iluminación Pública - IP (kWh)',
      search: 'Buscar',
      balanceEnergy: 'Balance Energético',
      balanceEnergyChart: 'Gráfico de Balance Energético',
      data: 'Fecha',
      meterTrafo: 'Medidor del Trafo',
      energyRequired: 'Energía Requerida (kWh)',
      energyConsumed: 'Energía Consumida (kWh)',
      energyPublicLightingLabel: 'Iluminación Pública',
      loss: 'Pérdida (kWh)',
      lossPercentage: 'Pérdida %',
      energyPublicLighting: 'Energía IP (kWh)',
      readingDateTime: 'Fecha de Lectura',
      initialReadingDateTime: 'Fecha de Lectura Inicial',
      finalReadingDateTime: 'Fecha de Lectura Final',
      energyInjectedConsumers: 'Energía Inyectada a los Consumidores (kWh)',
      energyReverseTransformer: 'Energía Reversa del Trafo (kWh)',
      empty: 'Vacío por ahora...',
      results: 'Resultado',
      transformerName: 'Nombre del Trafo',
      areaName: 'Nombre del Área',
      regionName: 'Nombre de la Región',
      placeholders: {
        publicLighting: 'Ingrese el valor',
      },
      errors: {
        loadBalance: 'Error al buscar balance',
      },
    },
    transformers: {
      title: 'Transformadores',
      transformer: 'Transformador',
      startDate: 'Fecha inicial',
      endDate: 'Fecha final',
      placeholders: {
        loading: 'Cargando...',
        select: 'Elegir Transformador',
        selectDate: 'Seleccione la fecha',
      },
      errors: {
        title: 'Error',
        loadTransformers: 'Error al cargar transformadores',
      },
    },
    veeGroups: {
      pageTitle: 'Configuración VEE - Grupos VEE',
      title: 'Grupos VEE',
      tableTitle: 'Grupos VEE',
      actions: {
        newGroup: 'Nuevo Grupo VEE',
        refresh: 'Actualizar',
        retry: 'Intentar nuevamente',
      },
      columns: {
        name: 'Nombre',
        purpose: 'Finalidad',
        scope: 'Alcance',
        mode: 'Modo',
        period: 'Vigencia',
        frequency: 'Frecuencia',
        priority: 'Prioridad',
        rules: 'Reglas',
        status: 'Estado',
        actions: 'Acciones',
      },
      filters: {
        searchLabel: 'Buscar por nombre',
        searchPlaceholder: 'Buscar por nombre',
        purpose: 'Finalidad',
        status: 'Estado',
        scope: 'Alcance de datos',
        mode: 'Modo operativo',
        referenceDate: 'Fecha de referencia',
        referenceDatePlaceholder: 'Seleccione la fecha de referencia',
        selectOption: 'Seleccione',
      },
      status: {
        active: 'Activo',
        inactive: 'Inactivo',
      },
      scopes: {
        massMemory: 'Memoria Masiva',
        totalizers: 'Totalizadores',
        both: 'Híbrido',
      },
      modes: {
        gate: 'Gate',
        consultative: 'Consultivo',
      },
      purpose: {
        billing: 'Validación para Facturación',
        monitoring: 'Monitoreo Operativo',
      },
      sourceRole: {
        initialLoad: 'Carga Inicial',
        manualOverride: 'Anulación Manual',
        estimationValidation: 'Validación de Estimación',
        billingValidation: 'Validación de Facturación',
      },
      retentionLevel: {
        reading: 'Lectura',
        channel: 'Canal',
        cycle: 'Ciclo',
        meter: 'Medidor',
      },
      period: {
        openEnded: 'Abierto',
      },
      loading: {
        list: 'Cargando grupos VEE...',
        action: 'Procesando...',
      },
      empty: {
        title: 'No se encontraron grupos VEE',
        description: 'Ajuste los filtros o cree un nuevo grupo VEE.',
      },
      pagination: {
        showing: 'Mostrando {first} a {last} de {total} grupos',
        pageSize: 'Elementos por página',
      },
      permissions: {
        title: 'Acceso no permitido',
        view: 'No tiene permiso para visualizar grupos VEE.',
        create: 'No tiene permiso para crear grupos VEE.',
        edit: 'No tiene permiso para editar grupos VEE.',
        deactivate: 'No tiene permiso para desactivar grupos VEE.',
        configure: 'No tiene permiso para acceder a la configuración del grupo VEE.',
        updateFallback: 'No tiene permiso para actualizar la configuración de fallback.',
        updateBatchApprovalPolicy:
          'No tiene permiso para actualizar la política de aprobación en lote.',
      },
      details: {
        loadingTitle: 'Cargando Grupo VEE...',
        breadcrumbTitle: 'Detalles del Grupo VEE',
        badge: 'Operación/consulta',
        sections: {
          configuration: 'Configuración del Grupo VEE',
          fallback: 'Configuración de Estimación (Fallback)',
          batchApproval: 'Aprobación en Lote',
          pipeline: 'Pipeline',
          readingHistory: 'Histórico de Lecturas',
          groupMeters: 'Medidores del Grupo',
          pendingEstimates: 'Propuestas de Estimación Pendientes',
        },
        labels: {
          historicalWindow: 'Ventana Histórica',
        },
        fallbackSettings: {
          caption:
            'Reordene los métodos de fallback y ajuste la ventana histórica según el contrato actual.',
          enableZeroFillLabel: 'Habilitar relleno con cero (ZeroFill)',
          savingTitle: 'Guardando...',
          saving: 'Guardando configuración de fallback...',
          successTitle: 'Éxito',
          success: 'Configuración de fallback actualizada correctamente',
          errorTitle: 'Error',
          error: 'Error al actualizar configuración de fallback',
        },
        batchApprovalPolicy: {
          caption:
            'Defina los límites que autorizan la aprobación en lote de estimaciones para este grupo.',
          allowLabel: 'Permite aprobación en lote',
          maxGapDurationMinutesLabel: 'Duración máxima de la brecha (minutos)',
          maxGapDurationMinutesPlaceholder: 'Ingrese la duración máxima de la brecha',
          maxDeviationPercentLabel: 'Desviación máxima (%)',
          maxDeviationPercentPlaceholder: 'Ingrese la desviación máxima permitida',
          maxProposalsPerBatchLabel: 'Cantidad máxima por lote',
          maxProposalsPerBatchPlaceholder: 'Ingrese la cantidad máxima por lote',
          requiredFieldsHint:
            'Los tres límites son obligatorios cuando la aprobación en lote está habilitada.',
          disabledHint:
            'Ningún límite configurado. La aprobación en lote está bloqueada para este grupo.',
          loadErrorTitle: 'Error',
          loadError: 'Error al cargar la política de aprobación en lote',
          successTitle: 'Éxito',
          success: 'Política de aprobación en lote actualizada correctamente',
          errorTitle: 'Error',
          error: 'Error al actualizar la política de aprobación en lote',
          validation: {
            fieldsRequired: 'Informe los tres límites para habilitar la aprobación en lote.',
            gapMustBePositive: 'La duración máxima de la brecha debe ser mayor que cero.',
            deviationMustBeNonNegative: 'La desviación máxima no puede ser negativa.',
            maxProposalsMustBePositive: 'La cantidad máxima por lote debe ser mayor que cero.',
          },
        },
        actions: {
          retry: 'Intentar nuevamente',
          backToList: 'Volver a Grupos VEE',
          configureGroup: 'Configurar grupo',
          approveSelected: 'Aprobar seleccionadas',
          reject: 'Rechazar',
        },
        empty: {
          fallback: 'No hay fallback configurado.',
        },
        summary: {
          notAvailable: '-',
          caption: 'Resumen operativo con datos reales ya disponibles en el detalle del grupo.',
          labels: {
            group: 'Grupo',
            scope: 'Tipo/Alcance',
            objective: 'Objetivo',
            sourceRole: 'Source Role',
            mode: 'Modo',
            lastExecution: 'Última ejecución',
            priority: 'Prioridad',
            frequency: 'Frecuencia',
            period: 'Período',
            status: 'Estado',
          },
        },
        configuration: {
          caption: 'Alcance, vigencia, modo, bloqueo y nivel de resolución del grupo.',
          labels: {
            scope: 'Alcance del grupo',
            validity: 'Vigencia',
            mode: 'Modo Gate/Consultivo',
            blockingPolicy: 'Política de bloqueo',
            resolutionLevel: 'Nivel de resolución jerárquica',
            frequency: 'Frecuencia',
          },
          blockingPolicies: {
            none: 'No aplica',
            blockOnOpenException: 'Bloquear por excepción abierta',
          },
        },
        errors: {
          title: 'Error al cargar Grupo VEE',
          load: 'Error al cargar Grupo VEE',
          groupNotFound: 'Grupo no encontrado',
        },
        pipeline: {
          caption:
            'Vista previa visual local del pipeline mientras la biblioteca nativa de reglas y el flujo real aún no están implementados.',
          columns: {
            name: 'Nombre',
            lastExecution: 'Última ejecución',
            actions: 'Acciones',
          },
        },
        readingHistory: {
          real: 'Lecturas reales',
          approvedEstimated: 'Estimaciones aprobadas',
          proposed: 'Propuestas pendientes',
          subtitle: 'Cantidad diaria por origen',
          axisLabel: 'Cantidad',
          loadError: 'No fue posible cargar el historial de lecturas del grupo.',
          maxPeriodError: 'El período del historial de lecturas no puede exceder {days} días.',
        },
        meters: {
          loadError: 'No fue posible cargar los medidores del grupo.',
        },
        pendingEstimates: {
          pendingStatus: 'Pendiente',
          empty: 'Ninguna propuesta pendiente para este grupo.',
          loadError: 'No fue posible cargar las propuestas de estimación pendientes.',
          rejectError: 'No fue posible rechazar la propuesta seleccionada.',
          labels: {
            method: 'Método',
            proposedValue: 'Valor propuesto',
          },
          columns: {
            status: 'Estado',
          },
        },
      },
      form: {
        createTitle: 'Crear Grupo VEE',
        editTitle: 'Editar Grupo VEE',
        fields: {
          name: 'Nombre del grupo',
          purposeCode: 'Finalidad',
          sourceRole: 'Rol de la fuente',
          dataScope: 'Alcance de datos',
          period: 'Período',
          effectiveFrom: 'Vigencia inicial',
          effectiveTo: 'Vigencia final',
          fallback: 'Fallback',
          historicalWindow: 'Ventana histórica',
          blockingPolicyCode: 'Disparador de facturación',
          executionFrequency: 'Frecuencia de ejecución',
          operationalMode: 'Modo',
          priority: 'Prioridad (0-10)',
          validatedReadingsThreshold: 'Meta de lecturas validadas (%)',
        },
        placeholders: {
          name: 'Nombre del grupo',
          effectiveFrom: 'Seleccione',
          effectiveTo: 'Seleccione',
          blockingPolicyCode: 'Disparador de facturación',
          select: 'Seleccione',
          validatedReadingsThreshold: 'Ingrese la meta',
        },
        frequency: {
          immediate: 'Bajo demanda',
          dailyDigest: 'Resumen diario',
          dailyDigestDelayed: 'Resumen diario (retraso de 5 días)',
          weeklyDigest: 'Resumen semanal',
        },
        fallback: {
          interpolation: 'Interpolación',
          proxyDay: 'Día Proxy',
          loadProfile: 'Perfil de carga',
          scalarCalculation: 'Cálculo escalar',
          transformerNeighborAverage: 'Promedio de vecinos del transformador',
          moveUp: 'Mover fallback hacia arriba',
          moveDown: 'Mover fallback hacia abajo',
          reorderHint: 'Arrastre los métodos para definir el orden de ejecución.',
          dragHandle: 'Arrastre para reordenar (o use las flechas del teclado)',
          sevenDays: '7 días',
          fifteenDays: '15 días',
          oneMonth: '1 mes',
        },
        priorityScale: {
          low: 'Baja',
          medium: 'Media',
          high: 'Alta',
        },
        actions: {
          cancel: 'Cancelar',
          save: 'Guardar',
          saving: 'Guardando',
        },
        messages: {
          saveNotAvailableTitle: 'Flujo en preparación',
          saveNotAvailableDetail:
            'El guardado del VEE Group se implementará en las próximas microactividades.',
        },
        validation: {
          title: 'Atención',
          summary: 'Revise los campos resaltados antes de guardar',
          required: 'Campo obligatorio',
          nameRequired: 'El nombre del grupo es obligatorio',
          purposeRequired: 'La finalidad es obligatoria',
          dataScopeRequired: 'El alcance de datos es obligatorio',
          effectiveFromRequired: 'La fecha inicial es obligatoria',
          invalidPeriod: 'La fecha final debe ser mayor o igual a la fecha inicial',
          blockingPolicyCodeRequired: 'El disparador de facturación es obligatorio en modo Gate',
          executionFrequencyRequired: 'La frecuencia de ejecución es obligatoria',
          operationalModeRequired: 'El modo es obligatorio',
          priorityRange: 'La prioridad debe estar entre 0 y 10',
          validatedReadingsThresholdRange: 'La meta debe ser mayor que 0 y como máximo 100',
        },
      },
      errors: {
        title: 'Error',
        loadList: 'Error al cargar grupos VEE',
        loadDetails: 'No fue posible cargar los datos actualizados del Grupo VEE.',
        create: 'Error al crear Grupo VEE',
        update: 'Error al actualizar Grupo VEE',
        deactivate: 'Error al eliminar Grupo VEE',
        unauthorized: 'Su sesión ha expirado. Inicie sesión nuevamente para continuar.',
        forbidden: 'No tiene permiso para realizar esta acción.',
        notFound: 'No se encontró el Grupo VEE solicitado.',
        validation: 'Revise los datos informados e intente nuevamente.',
        unexpected: 'Ocurrió un error inesperado. Intente nuevamente.',
      },
      success: {
        title: 'Éxito',
        create: 'Grupo VEE creado con éxito',
        update: 'Grupo VEE actualizado con éxito',
        deactivate: 'Grupo VEE eliminado con éxito',
      },
      deactivateDialog: {
        title: 'Confirmar eliminación',
        description: '¿Realmente desea eliminar este Grupo VEE?',
        confirm: 'Eliminar',
      },
      placeholderDialog: {
        title: 'Flujo en preparación',
        close: 'Cerrar',
        messages: {
          view: 'La visualización detallada del VEE Group se implementará en las próximas microactividades.',
          inactivate:
            'La inactivación del VEE Group se implementará en las próximas microactividades.',
        },
      },
    },
    veeConfiguration: {
      groupDetails: {
        loadingTitle: 'Cargando configuración...',
        breadcrumbTitle: 'Configuración del Grupo VEE',
        pageTitlePrefix: 'Configuración VEE',
        actions: {
          backToDetails: 'Volver al Detalle del Grupo',
          retry: 'Intentar nuevamente',
        },
        sections: {
          identification: 'Alcance, vigencia, modo, bloqueo, nivel jerárquico y frecuencia',
          pipeline: 'Pipeline de Reglas',
          fallback: 'Estimación - Fallback y Ventana Histórica',
        },
        labels: {
          scope: 'Alcance',
          scopeCardTitle: 'Configuración del Grupo - {name}',
          validity: 'Vigencia',
          mode: 'Modo',
          blockingPolicy: 'Política de bloqueo',
          resolutionLevel: 'Nivel de resolución jerárquica',
          frequency: 'Frecuencia',
        },
        blockingPolicyOptions: {
          perMeter: 'Por medidor completo',
          perReadingPeriod: 'Por período de lectura',
          alertOnly: 'Solo alerta',
        },
        pipeline: {
          caption:
            'Vista previa local del pipeline mientras la biblioteca nativa de reglas (actividad 008) aún no está disponible.',
          loading: 'Cargando reglas del pipeline...',
          savingOrder: 'Guardando el orden del pipeline...',
          empty: {
            pipeline: 'Vacío por ahora...',
            availableRules: 'No hay reglas activas disponibles para agregar.',
          },
          messages: {
            activeOnly: 'Solo se pueden agregar reglas activas al pipeline.',
            inactiveConfigured:
              'La regla está inactiva en el catálogo, pero permanece visible porque ya forma parte de este pipeline.',
            orderPreserved: 'El orden de las reglas se preservará al guardar.',
          },
          columns: {
            order: 'Orden',
            rule: 'Regla',
            severity: 'Severidad',
            action: 'Acción',
            validity: 'Vigencia',
            actions: 'Acciones',
          },
          severities: {
            info: 'Informativo',
            issue: 'Alerta',
            terminate: 'Crítico',
          },
          actions: {
            alert: 'Solo alertar',
            hold: 'Retener',
            blockBilling: 'Bloquear facturación',
            stopPipeline: 'Impedir finalización',
          },
          crud: {
            create: 'Crear Pipeline',
            edit: 'Editar',
            delete: 'Eliminar',
          },
          form: {
            createTitle: 'Crear Regla del Pipeline',
            editTitle: 'Editar Regla del Pipeline',
            fields: {
              rule: 'Regla',
              severity: 'Severidad',
              action: 'Acción',
              effectiveFrom: 'Vigencia inicio',
              effectiveTo: 'Vigencia fin',
            },
            placeholders: {
              select: 'Seleccione',
              effectiveFrom: 'Fecha de inicio de vigencia',
              effectiveTo: 'Fecha de fin de vigencia',
            },
            validation: {
              ruleRequired: 'Seleccione una regla para el pipeline',
              effectiveFromRequired: 'La vigencia inicio es obligatoria',
              invalidPeriod: 'La vigencia fin no puede ser anterior a la vigencia inicio',
            },
          },
          deleteDialog: {
            title: 'Quitar regla del pipeline',
            description:
              'La regla será quitada del pipeline activo. Su configuración e historial de parámetros se conservan y vuelven a estar disponibles si la regla se agrega nuevamente.',
            confirm: 'Quitar',
          },
          toast: {
            created: 'Regla del pipeline creada con éxito',
            updated: 'Regla del pipeline actualizada con éxito',
            deleted: 'Regla del pipeline eliminada con éxito',
          },
          errors: {
            loadRules: 'No fue posible cargar las reglas disponibles.',
            duplicateRule: 'Esta regla ya fue agregada al pipeline.',
            saveOrder: 'No fue posible guardar el orden del pipeline.',
          },
        },
        errors: {
          title: 'Error al cargar configuración',
          load: 'Error al cargar la configuración del grupo',
          groupNotFound: 'Grupo no encontrado',
        },
      },
      rulesLibrary: {
        pageTitle: 'Configuración VEE - Biblioteca de Reglas',
        breadcrumbTitle: 'Biblioteca de Reglas',
        tableTitle: 'Biblioteca de Reglas',
        description: 'Catálogo configurable de reglas nativas VEE.',
        columns: {
          name: 'Regla',
          description: 'Descripción',
          scope: 'Alcance',
          classification: 'Clasificación',
          dataType: 'Tipo de dato',
          defaultSeverity: 'Severidad predeterminada',
          defaultAction: 'Acción operacional predeterminada',
          cost: 'Costo',
          status: 'Estado',
          actions: 'Acción',
        },
        actions: {
          create: 'Crear regla',
          thresholds: 'Umbrales',
          thresholdsTooltip: 'Ver umbrales de la regla',
          viewTooltip: 'Ver regla',
          editTooltip: 'Editar regla',
          edit: 'Editar',
          activate: 'Activar',
          deactivate: 'Desactivar',
          activateTooltip: 'Activar regla',
          deactivateTooltip: 'Desactivar regla',
          refresh: 'Actualizar',
          retry: 'Intentar nuevamente',
          clearFilters: 'Limpiar filtros',
        },
        filters: {
          searchLabel: 'Buscar por nombre o descripción',
          searchPlaceholder: 'Búsqueda rápida',
          scope: 'Alcance',
          dataType: 'Tipo de dato',
          cost: 'Costo',
          status: 'Estado',
          severity: 'Severidad',
          selectOption: 'Seleccione',
        },
        status: {
          active: 'Activa',
          inactive: 'Inactiva',
        },
        scopes: {
          massMemory: 'Memoria Masiva',
          totalizers: 'Totalizadores',
          both: 'Ambos',
        },
        dataTypes: {
          percentage: 'Porcentaje',
          count: 'Conteo',
          binary: 'Binario',
          numeric: 'Numérico',
        },
        costs: {
          low: 'Bajo',
          medium: 'Medio',
          high: 'Alto',
        },
        loading: {
          list: 'Cargando biblioteca de reglas...',
          action: 'Actualizando regla...',
        },
        empty: {
          title: 'No se encontraron reglas.',
        },
        pagination: {
          pageSize: 'Elementos por página',
        },
        permissions: {
          title: 'Acceso no permitido',
          view: 'No tiene permiso para visualizar la biblioteca de reglas.',
          manage: 'No tiene permiso para modificar la biblioteca de reglas.',
          configureThresholds: 'No tiene permiso para configurar parámetros de la regla.',
        },
        form: {
          createTitle: 'Crear Regla',
          editTitle: 'Editar Regla',
          detailsTitle: 'Detalles de la Regla',
          fields: {
            name: 'Regla',
            description: 'Descripción',
            scope: 'Alcance',
            ruleTypeSelection: 'Tipo de la Regla',
            ruleType: 'Tipo de regla',
            classification: 'Clasificación',
            dataType: 'Tipo de dato',
            defaultSeverity: 'Severidad predeterminada',
            defaultAction: 'Acción operativa predeterminada',
            cost: 'Costo',
            status: 'Estado',
            parametersMetadata: 'Parámetros configurables',
          },
          legacyTypeNotice:
            'Este registro tiene un tipo técnico heredado sin un handler reconocido por el sistema. Puede guardar los demás cambios sin seleccionar un nuevo tipo, o elegir un tipo válido arriba para corregirlo.',
          parametersMetadata: {
            key: 'Clave',
            keyPlaceholder: 'Clave técnica del parámetro',
            label: 'Etiqueta',
            labelPlaceholder: 'Etiqueta mostrada al usuario',
            valueType: 'Tipo de valor',
            required: 'Obligatorio',
            min: 'Mínimo',
            minPlaceholder: 'Valor mínimo permitido',
            max: 'Máximo',
            maxPlaceholder: 'Valor máximo permitido',
            add: 'Agregar parámetro',
            addTooltip: 'Agregar un nuevo parámetro',
            remove: 'Quitar',
            removeTooltip: 'Quitar parámetro',
            removeAll: 'Quitar parámetros',
            removeAllTooltip: 'Quitar todos los parámetros agregados',
            maxReached: 'Límite máximo de {max} parámetros alcanzado.',
            itemLabel: 'Parámetro {index}',
            empty: 'Ningún parámetro configurable agregado.',
            valueTypes: {
              string: 'Texto',
              integer: 'Número entero',
              decimal: 'Número decimal',
              boolean: 'Verdadero o falso',
              json: 'Estructurado (JSON)',
              dateTime: 'Fecha y hora',
            },
          },
          placeholders: {
            name: 'Nombre de la regla',
            description: 'Descripción breve de la regla',
            select: 'Seleccione',
            selectScopeFirst: 'Seleccione primero el alcance',
          },
          validation: {
            nameRequired: 'Ingrese el nombre de la regla',
            ruleTypeRequired: 'Seleccione la clasificación de la regla',
            ruleTypeSelectionRequired: 'Seleccione el tipo de la regla',
            scopeRequired: 'Seleccione el alcance',
            dataTypeRequired: 'Seleccione el tipo de dato',
            costRequired: 'Seleccione el costo operativo',
            severityRequired: 'Seleccione la severidad predeterminada',
            actionRequired: 'Seleccione la acción operativa predeterminada',
            parameterKeyRequired: 'Ingrese la clave del parámetro',
            parameterLabelRequired: 'Ingrese la etiqueta del parámetro',
            parameterRangeInvalid: 'El mínimo no puede ser mayor que el máximo',
          },
          ruleTypeOptions: {
            consistency: 'Consistencia',
            continuity: 'Continuidad',
            comparison: 'Comparación',
            threshold: 'Límite',
            calibration: 'Calibración',
            custom: 'Personalizada',
            correction: 'Corrección',
          },
          actions: {
            cancel: 'Cancelar',
            close: 'Cerrar',
            save: 'Guardar',
            saving: 'Guardando...',
          },
        },
        statusDialog: {
          activateTitle: 'Activar Regla',
          activateDescription: '¿Desea activar la regla {rule}?',
          deactivateTitle: 'Desactivar Regla',
          deactivateDescription:
            '¿Desea desactivar la regla {rule}? Las configuraciones existentes serán preservadas.',
          confirmActivate: 'Activar',
          confirmDeactivate: 'Desactivar',
          cancel: 'Cancelar',
        },
        toast: {
          created: 'Regla creada con éxito',
          updated: 'Regla actualizada con éxito',
          activated: 'Regla activada con éxito',
          deactivated: 'Regla desactivada con éxito',
          ruleTypeClearedByScopeChange:
            'El tipo de regla seleccionado no es compatible con el nuevo alcance y fue limpiado. Seleccione un tipo válido.',
        },
        errors: {
          title: 'Error al cargar biblioteca de reglas',
          load: 'No fue posible cargar la biblioteca de reglas.',
          unauthorized: 'Su sesión ha expirado. Inicie sesión nuevamente para continuar.',
          forbidden: 'No tiene permiso para acceder a este recurso.',
          notFound: 'No se encontró la regla solicitada.',
          validation: 'Revise los filtros o datos informados.',
          unprocessable: 'No fue posible procesar los datos informados.',
          activate: 'No fue posible activar la regla.',
          deactivate: 'No fue posible desactivar la regla.',
          create: 'No fue posible crear la regla.',
          update: 'No fue posible actualizar la regla.',
          unexpected: 'Ocurrió un error inesperado. Intente nuevamente.',
        },
      },
      ruleThresholds: {
        dialogTitle: 'Umbrales de la Regla',
        ruleLabel: 'Regla: {rule}',
        subtitle: 'Configure los parámetros de la regla para el Grupo VEE seleccionado.',
        preview: {
          catalogOnlyNotice:
            'Vista de solo lectura de los parámetros del catálogo. La configuración efectiva se realiza en el pipeline del grupo.',
        },
        sections: {
          parameters: 'Parámetros',
          currentConfiguration: 'Configuración actual',
          futureConfiguration: 'Configuración futura',
          validity: 'Vigencia',
          audit: 'Auditoría',
        },
        labels: {
          group: 'Grupo VEE',
          rule: 'Regla',
          parameter: 'Parámetro',
          value: 'Valor',
          unit: 'Unidad',
          minimum: 'Mínimo',
          maximum: 'Máximo',
          upperLimit: 'Límite superior (%)',
          lowerLimit: 'Límite inferior (%)',
          basis: 'Base de cálculo',
          seasonality: 'Estacionalidad',
          severity: 'Severidad',
          action: 'Acción operativa',
          cost: 'Costo operativo',
          billing: 'Impacto en facturación',
          historicalWindow: 'Ventana histórica',
          effectiveFrom: 'Inicio de vigencia',
          effectiveTo: 'Fin de vigencia',
          currentConfiguration: 'Configuración actual',
          futureConfiguration: 'Configuración futura',
          nextEligibleExecution: 'Próxima ejecución elegible',
          changedBy: 'Modificado por',
          changedAt: 'Modificado el',
          createdBy: 'Creado por',
          createdAt: 'Creado el',
          previousValue: 'Valor anterior',
          newValue: 'Nuevo valor',
          changeReason: 'Motivo del cambio',
        },
        basisOptions: {
          absolute: 'Absoluto',
          historical: 'Basado en histórico',
        },
        parameterLabels: {
          measurementKey: 'Magnitud evaluada',
          basis: 'Base de cálculo',
          lowerLimitPercent: 'Límite inferior (%)',
          upperLimitPercent: 'Límite superior (%)',
        },
        parameterValues: {
          bothDirections: 'Por encima y por debajo',
        },
        seasonalityOptions: {
          none: 'Sin estacionalidad',
          daily: 'Diaria',
          weekly: 'Semanal',
          monthly: 'Mensual',
          annual: 'Anual',
        },
        billingOptions: {
          none: 'Sin impacto en facturación',
          hold: 'Retener para análisis',
          block: 'Bloquear facturación',
        },
        placeholders: {
          selectRule: 'Seleccione la regla',
          select: 'Seleccione',
          enterValue: 'Informe el valor',
          enterValueFor: 'Ingrese {label}',
          effectiveFrom: 'Seleccione el inicio de vigencia',
          effectiveTo: 'Seleccione el fin de vigencia',
          changeReason: 'Describa el motivo del cambio',
        },
        validation: {
          required: 'Campo obligatorio',
          invalidType: 'Informe un valor compatible con el tipo del parámetro.',
          belowMinimum: 'El valor debe ser mayor o igual a {minimum}.',
          aboveMaximum: 'El valor debe ser menor o igual a {maximum}.',
          lowerGreaterThanUpper: 'El límite inferior no puede ser mayor que el límite superior',
          invalidPeriod:
            'La fecha de inicio de la vigencia no puede ser anterior a la fecha de hoy.',
          effectiveFromRequired: 'El inicio de vigencia es obligatorio.',
          noChanges: 'No se informó ningún cambio.',
        },
        help: {
          minimum: 'Menor valor aceptado para este parámetro.',
          maximum: 'Mayor valor aceptado para este parámetro.',
          severity: 'Define la severidad de la excepción generada cuando se viola la regla.',
          action: 'Define la acción operativa aplicada cuando la regla identifica una excepción.',
          cost: 'Indica el costo operativo estimado para procesar esta regla.',
          billing:
            'Bloquear facturación impide que la facturación continúe hasta que se trate la excepción.',
          validity:
            'La vigencia define cuándo se puede usar la configuración sin cambiar ejecuciones anteriores.',
          historicalWindow:
            'Define el período de datos anteriores usado como referencia por la regla.',
          seasonality:
            'Define el ciclo estacional considerado al comparar con el historial disponible.',
          currentConfiguration: 'Configuración vigente en el momento de la consulta.',
          futureConfiguration: 'Configuración programada para una vigencia futura.',
          nextEligibleExecution:
            'El cambio solo se considerará en la próxima ejecución elegible dentro de su vigencia.',
        },
        loading: {
          load: 'Cargando parámetros de la regla...',
          save: 'Guardando configuración...',
        },
        empty: {
          parameters: 'Esta regla no tiene parámetros configurables.',
          currentConfiguration: 'No se encontró ninguna configuración actual.',
          futureConfiguration: 'No hay ninguna configuración futura programada.',
          audit: 'No se encontró ningún historial de cambios.',
        },
        messages: {
          effectiveNextExecution:
            'La configuración guardada solo entrará en vigor en la próxima ejecución elegible.',
          noRetroactivity: 'El cambio no modifica ejecuciones ni resultados anteriores.',
          inactiveRule:
            'Esta regla está inactiva. Su configuración existente permanece disponible para consulta.',
          missingContext:
            'No fue posible identificar la regla del pipeline para configurar los thresholds. Guarde la regla en el pipeline del grupo antes de configurar los parámetros.',
        },
        audit: {
          created: 'Configuración creada',
          updated: 'Configuración actualizada',
          scheduled: 'Nueva vigencia programada',
          unknownUser: 'Usuario no informado',
        },
        permissions: {
          title: 'Acceso no permitido',
          view: 'No tiene permiso para consultar los parámetros de esta regla.',
          edit: 'No tiene permiso para cambiar los parámetros de esta regla.',
        },
        actions: {
          cancel: 'Cancelar',
          close: 'Cerrar',
          save: 'Guardar',
          saving: 'Guardando...',
          refresh: 'Actualizar',
          retry: 'Intentar nuevamente',
        },
        toast: {
          saved: 'Configuración guardada con éxito',
          updated: 'Configuración actualizada con éxito',
        },
        errors: {
          title: 'Error al cargar parámetros',
          load: 'No fue posible cargar los parámetros de la regla.',
          unauthorized: 'Su sesión ha expirado. Inicie sesión nuevamente para continuar.',
          forbidden: 'No tiene permiso para acceder a este recurso.',
          notFound: 'No se encontró la configuración solicitada.',
          validation: 'Revise los parámetros informados.',
          unprocessable: 'No fue posible procesar los parámetros informados.',
          save: 'No fue posible guardar la configuración.',
          unexpected: 'Ocurrió un error inesperado. Intente nuevamente.',
        },
      },
      billingCalendar: {
        pageTitle: 'Configuración VEE - Calendario de Facturación',
        breadcrumbTitle: 'Calendario de Facturación',
        tableTitle: 'Calendario de Facturación',
        columns: {
          group: 'Grupo',
          readingDay: 'Día de lectura',
          closingDay: 'Fecha de cierre',
          triggerDMinusN: 'Disparador D-N',
          status: 'Estado',
          actions: 'Acciones',
        },
        statusOptions: {
          ready: 'Listo',
          pending: 'Pendiente',
          blocked: 'Bloqueado',
          noData: 'Sin datos',
        },
        labels: {
          group: 'Grupo',
          readingDay: 'Día de lectura',
          closingDay: 'Fecha de cierre',
          triggerDMinusN: 'Disparador D-N',
          effectiveFrom: 'Vigencia inicial',
          effectiveTo: 'Vigencia final',
          escalationThreshold: 'Umbral de escalonamiento',
          timezone: 'Zona horaria',
        },
        placeholders: {
          selectGroup: 'Seleccione el grupo',
          selectReadingDay: 'Seleccione el día de lectura',
          selectClosingDay: 'Seleccione el día de cierre',
          triggerDMinusN: 'Informe el D-N',
          effectiveFrom: 'Seleccione la vigencia inicial',
          effectiveTo: 'Seleccione la vigencia final',
          escalationThreshold: 'Informe el umbral (%)',
          timezone: 'Seleccione el fuso horario',
          searchPlaceholder: 'Búsqueda rápida',
        },
        actions: {
          retry: 'Intentar de nuevo',
        },
        form: {
          createTitle: 'Crear Calendario de Facturación',
          editTitle: 'Editar Calendario',
          actions: {
            create: 'Crear Calendario',
            cancel: 'Cancelar',
            save: 'Guardar',
            edit: 'Editar',
            delete: 'Eliminar',
          },
        },
        deleteDialog: {
          title: 'Eliminar calendario',
          description: 'Esta acción inactiva el calendario de facturación del grupo seleccionado.',
          confirm: 'Eliminar',
        },
        toast: {
          created: 'Calendario creado con éxito',
          updated: 'Calendario actualizado con éxito',
          deleted: 'Calendario eliminado con éxito',
        },
        errors: {
          title: 'Error',
          loadList: 'No fue posible cargar los calendarios de facturación.',
          loadDetails: 'No fue posible cargar los datos actualizados del calendario.',
          create: 'No fue posible crear el calendario de facturación.',
          update: 'No fue posible actualizar el calendario de facturación.',
          delete: 'No fue posible eliminar el calendario de facturación.',
          invalidEffectivePeriod: 'La vigencia final no puede ser anterior a la vigencia inicial.',
        },
        validation: {
          groupRequired: 'El grupo es obligatorio.',
          readingDayRequired: 'El día de lectura es obligatorio.',
          closingDayRequired: 'La fecha de cierre es obligatoria.',
          triggerDaysRequired: 'El gatillo D-N es obligatorio.',
          effectiveFromRequired: 'La vigencia inicial es obligatoria.',
        },
      },
      notifications: {
        pageTitle: 'Configuración VEE - Notificaciones',
        breadcrumbTitle: 'Notificaciones',
        tableTitle: 'Notificaciones',
        columns: {
          group: 'Grupo',
          frequency: 'Frecuencia',
          recipients: 'Destinatarios',
          escalationChannel: 'Canal de escalamiento',
          eventTypes: 'Tipos de evento',
          status: 'Estado',
          actions: 'Acciones',
        },
        labels: {
          veeGroup: 'Grupo VEE',
          frequency: 'Frecuencia',
          groupRecipients: 'Destinatarios por grupo',
          escalationChannel: 'Canal de escalamiento (preparación crítica para facturación)',
          eventTypes: 'Tipos de evento monitoreados',
        },
        actions: {
          viewDetails: 'Haga clic para ver los detalles',
          itemsCount: '{count} registros',
          close: 'Cerrar',
        },
        placeholders: {
          searchPlaceholder: 'Buscar grupo',
          selectVeeGroup: 'Seleccione el grupo VEE',
          emailExample: "nombre{'@'}empresa.com",
        },
        filters: {
          frequency: 'Frecuencia',
          status: 'Estado',
          selectOption: 'Seleccione',
        },
        frequencies: {
          immediate: 'Inmediata',
          dailyDigest: 'Resumen diario',
          weeklyDigest: 'Resumen semanal',
        },
        eventTypes: {
          CriticalException: 'Excepción crítica',
          CommunicationFailure: 'Falla de comunicación',
          PendingEstimationProposal: 'Propuesta de estimación pendiente',
          OverdueServiceRequestSla: 'SLA de solicitud de servicio vencido',
          CriticalBillingReadiness: 'Preparación crítica para facturación',
          CustomRuleTriggered: 'Regla personalizada activada',
        },
        statuses: {
          active: 'Activa',
          inactive: 'Inactiva',
        },
        form: {
          createTitle: 'Crear Notificación',
          editTitle: 'Editar Notificación',
          actions: {
            create: 'Crear notificación',
            cancel: 'Cancelar',
            save: 'Guardar',
            saving: 'Guardando...',
            edit: 'Editar',
            delete: 'Eliminar',
            addEmail: 'Agregar correo',
            removeEmail: 'Quitar correo',
          },
        },
        deleteDialog: {
          title: 'Desactivar notificación',
          description: 'Esta configuración de notificación será desactivada.',
          confirm: 'Desactivar',
          notConfigured: 'No informado',
        },
        validation: {
          invalidEmail: 'Ingrese un correo electrónico válido',
          veeGroupRequired: 'Seleccione el grupo VEE',
          groupRecipientsRequired: 'Ingrese al menos un destinatario del grupo',
          eventTypesRequired: 'Seleccione al menos un tipo de evento',
        },
        toast: {
          created: 'Notificación creada con éxito',
          updated: 'Notificación actualizada con éxito',
          deleted: 'Notificación desactivada con éxito',
          loadError: 'Error al cargar las notificaciones',
          loadDetailsError: 'No fue posible cargar los datos actualizados de la notificación.',
          saveError: 'Error al guardar la notificación',
          deleteError: 'Error al desactivar la notificación',
        },
      },
      hierarchyAssociation: {
        pageTitle: 'Configuración VEE - Asociación por Jerarquía',
        breadcrumbTitle: 'Asociación por Jerarquía',
        tableTitle: 'Asociación por Jerarquía',
        columns: {
          level: 'Nivel',
          criterion: 'Criterio',
          appliedGroup: 'Grupo aplicado',
          priority: 'Prioridad',
          priorityConflict: 'Conflicto',
          priorityConflictHint:
            'Otra asociación activa tiene la misma prioridad para este criterio',
          validity: 'Vigencia',
          indeterminateValidity: 'Indeterminado',
          status: 'Estado',
          actions: 'Acciones',
        },
        statusOptions: {
          active: 'Activo',
          inactive: 'Inactivo',
        },
        levelOptions: {
          meter: 'Medidor',
          meterGroup: 'Grupo de medidores',
          tariffClass: 'Clase tarifaria',
          technology: 'Tecnología',
          default: 'Default',
        },
        actions: {
          create: 'Crear asociación',
          edit: 'Editar',
          editTooltip: 'Editar',
          deactivateTooltip: 'Desactivar',
          reactivateTooltip: 'Reactivar',
        },
        filters: {
          searchPlaceholder: 'Búsqueda rápida',
          level: 'Nivel',
          levelPlaceholder: 'Ingrese el nivel',
          appliedGroup: 'Grupo aplicado',
          appliedGroupPlaceholder: 'Ingrese el grupo',
          validity: 'Vigencia',
          validityPlaceholder: 'Ingrese la vigencia',
          status: 'Estado',
          statusPlaceholder: 'Ingrese el estado',
        },
        form: {
          createTitle: 'Crear Asociación',
          editTitle: 'Editar Asociación',
          fields: {
            level: 'Nivel',
            criterion: 'Criterio',
            appliedGroup: 'Grupo aplicado',
            priority: 'Prioridad',
            effectiveFrom: 'Vigencia inicio',
            effectiveTo: 'Vigencia fin',
            status: 'Estado',
          },
          placeholders: {
            level: 'Ingrese el nivel',
            meter: 'Ingrese el medidor',
            tag: 'Ingrese el grupo de medidores',
            tariffClass: 'Ingrese la clase tarifaria',
            technology: 'Ingrese la tecnología',
            appliedGroup: 'Ingrese el grupo aplicado',
            status: 'Ingrese el estado',
            searchMeter: 'Escriba el serial del medidor',
            effectiveFrom: 'Ingrese la vigencia inicio',
            effectiveTo: 'Ingrese la vigencia fin (opcional)',
            priority: 'Ingrese la prioridad',
          },
          validation: {
            veeGroupRequired: 'Seleccione el VEE Group a aplicar',
            criterionRequired: 'Ingrese el criterio',
            effectiveFromRequired: 'La vigencia inicio es obligatoria',
            invalidPeriod: 'La vigencia inicio no puede ser mayor que la vigencia fin y viceversa',
          },
          actions: {
            cancel: 'Cancelar',
            save: 'Guardar',
            saving: 'Guardando...',
          },
        },
        statusDialog: {
          deactivateTitle: 'Desactivar Asociación',
          deactivateDescription:
            'La asociación será desactivada y continuará registrada, pudiendo ser reactivada después. ¿Desea continuar?',
          reactivateTitle: 'Reactivar Asociación',
          reactivateDescription:
            'La asociación volverá a ser considerada en la resolución del VEE Group efectivo, respetando la vigencia. ¿Desea continuar?',
          confirmDeactivate: 'Desactivar',
          confirmReactivate: 'Reactivar',
          priorityConflictWarning:
            'Atención: esta asociación está en conflicto de prioridad con otra asociación activa',
        },
        toast: {
          created: 'Asociación creada con éxito',
          updated: 'Asociación actualizada con éxito',
          deactivated: 'Asociación desactivada con éxito',
          reactivated: 'Asociación reactivada con éxito',
          loadError: 'No fue posible cargar las asociaciones',
          loadDetailsError: 'No fue posible cargar los datos actualizados de la asociación.',
          saveError: 'No fue posible guardar la asociación',
          deactivateError: 'No fue posible desactivar la asociación',
          reactivateError: 'No fue posible reactivar la asociación',
        },
      },
      customRule: {
        pageTitle: 'Configuración VEE - Regla Personalizada',
        breadcrumbTitle: 'Regla Personalizada',
        sections: {
          group: 'Grupo VEE',
          list: 'Reglas Personalizadas',
          newRule: 'Nueva Regla Personalizada',
          editRule: 'Editar Regla Personalizada',
          details: 'Detalles de la Regla Personalizada',
          info: 'Información de la Regla',
          sandbox: 'Sandbox',
          dryRun: 'Dry Run - Impacto',
          history: 'Historial y Versionado',
        },
        labels: {
          group: 'Grupo',
          name: 'Nombre',
          description: 'Descripción',
          measurementKey: 'Magnitud',
          condition: 'Condición',
          operator: 'Operador',
          value: 'Valor',
          secondaryValue: 'Valor secundario',
          values: 'Valores',
          valuesPlaceholder: 'Separe los valores con una coma',
          action: 'Acción operativa',
          estimationMethod: 'Método de estimación',
          severityOverride: 'Severidad (override)',
          operationalActionOverride: 'Acción operativa (override)',
          historicalWindowDays: 'Ventana histórica (días)',
          effectiveFrom: 'Vigencia inicial',
          effectiveTo: 'Vigencia final',
          openEnded: 'Sin fecha final',
          preview: 'Resumen de la regla',
          sampleMeters: 'Medidores de muestra',
          sampleMetersPlaceholder: 'Seleccione los medidores para la prueba',
          periodStart: 'Inicio del período',
          periodEnd: 'Fin del período',
        },
        placeholders: {
          group: 'Seleccione un grupo VEE',
          name: 'Ingrese el nombre de la regla',
          description: 'Ingrese una descripción',
          measurementKey: 'Seleccione la magnitud',
          condition: 'Seleccione la condición',
          operator: 'Seleccione el operador',
          action: 'Seleccione la acción',
          estimationMethod: 'Seleccione el método de estimación',
          severityOverride: 'Seleccione la severidad',
          operationalActionOverride: 'Seleccione la acción operativa',
          date: 'Seleccione la fecha y hora',
          value: 'Ingrese el valor',
          secondaryValue: 'Ingrese el valor secundario',
          periodStart: 'Seleccione el inicio del período',
          periodEnd: 'Seleccione el fin del período',
          historicalWindowDays: 'Ingrese la ventana histórica en días',
        },
        validation: {
          groupRequired: 'Seleccione el grupo VEE',
          nameRequired: 'Ingrese el nombre de la regla',
          measurementKeyRequired: 'Seleccione la magnitud',
          conditionRequired: 'Seleccione la condición',
          operatorRequired: 'Seleccione el operador',
          valueRequired: 'Ingrese el valor',
          valuesRequired: 'Ingrese al menos un valor',
          secondaryValueRequired: 'Indique el valor secundario',
          actionRequired: 'Seleccione la acción',
          estimationMethodRequired: 'Seleccione el método de estimación',
          effectiveFromRequired: 'La vigencia inicial es obligatoria',
          invalidPeriod: 'La vigencia final no puede ser anterior a la vigencia inicial',
          invalidSandboxPeriod: 'El fin del período no puede ser anterior al inicio del período',
        },
        actions: {
          newRule: 'Nueva Regla',
          preview: 'Actualizar resumen',
          save: 'Guardar',
          cancel: 'Cancelar',
          runTest: 'Ejecutar Prueba',
          activate: 'Activar Regla',
          view: 'Ver Versión',
          rollback: 'Revertir a esta versión',
          enableCustomRuleEngine: 'Habilitar reglas personalizadas',
          enablingCustomRuleEngine: 'Habilitando...',
        },
        columns: {
          name: 'Nombre',
          group: 'Grupo',
          version: 'Versión',
          status: 'Estado',
          measurementKey: 'Magnitud',
          action: 'Acción',
          validity: 'Vigencia',
          origin: 'Origen',
          createdAt: 'Creado en',
          actions: 'Acciones',
        },
        filters: {
          group: 'Grupo',
          status: 'Estado',
          measurementKey: 'Magnitud',
          actionType: 'Acción',
          selectOption: 'Seleccione una opción',
        },
        status: {
          active: 'Activa',
          draft: 'Borrador',
          expired: 'Expirada',
          superseded: 'Sustituida',
          inactive: 'Inactiva',
        },
        origin: {
          created: 'Creación',
          edited: 'Edición',
          rolledBack: 'Rollback',
        },
        enums: {
          conditionType: {
            value: 'Valor',
            consecutiveDifference: 'Diferencia consecutiva',
            historicalAverage: 'Promedio histórico',
            historicalStandardDeviation: 'Desviación estándar histórica',
            hourOfDay: 'Hora del día',
            dayOfWeek: 'Día de la semana',
            dayType: 'Tipo de día',
            consumptionClass: 'Clase de consumo',
            region: 'Región',
          },
          operator: {
            equals: 'Igual a',
            notEquals: 'Diferente de',
            greaterThan: 'Mayor que',
            greaterThanOrEqual: 'Mayor o igual que',
            lessThan: 'Menor que',
            lessThanOrEqual: 'Menor o igual que',
            between: 'Entre',
            in: 'En (lista)',
          },
          actionType: {
            generateException: 'Generar excepción',
            proposeEstimation: 'Proponer estimación',
            markForReview: 'Marcar para revisión',
            notify: 'Notificar',
          },
          estimationMethod: {
            loadProfile: 'Perfil de carga',
            proxyDay: 'Día proxy',
            interpolation: 'Interpolación',
            scalarCalculation: 'Cálculo escalar',
            zeroFill: 'Relleno con cero',
          },
          dayType: {
            businessDay: 'Día hábil',
            weekend: 'Fin de semana',
          },
        },
        dryRun: {
          requestedMeters: 'Medidores solicitados',
          affectedMeters: 'Medidores afectados',
          evaluatedMeters: 'Medidores evaluados',
          readingsEvaluated: 'Lecturas evaluadas',
          simulatedExceptions: 'Excepciones simuladas',
          simulatedProposals: 'Propuestas simuladas',
          simulatedNotifications: 'Notificaciones simuladas',
          performanceRisk: 'Riesgo de rendimiento identificado',
          examples: 'Ejemplos',
          successTitle: 'Prueba ejecutada con éxito',
          successDescription:
            'Los resultados a continuación reflejan la simulación más reciente de esta regla.',
          status: {
            success: 'Éxito',
            failed: 'Falla',
          },
        },
        rollback: {
          title: 'Revertir a una versión anterior',
          description:
            'El rollback crea una nueva versión en borrador con el contenido de la versión seleccionada. Indique el motivo para continuar.',
          reasonPlaceholder: 'Ingrese el motivo del rollback',
          cancel: 'Cancelar',
          confirm: 'Confirmar rollback',
        },
        activateDialog: {
          title: 'Activar Regla',
          description:
            'Esta acción activa efectivamente la versión actual de esta regla, aplicándola de inmediato a las siguientes evaluaciones. ¿Desea continuar?',
          cancel: 'Cancelar',
          confirm: 'Confirmar activación',
        },
        history: {
          detailsTitle: 'Detalles de la versión v{version}',
          previousVersion: 'Versión anterior',
        },
        sandbox: {
          metersHelpTitle: '¿Cómo habilitar medidores?',
          metersHelpIntro:
            'Los medidores mostrados en el Sandbox dependen de la configuración del Grupo VEE.',
          metersHelpRequirementsTitle: 'Para habilitarlos:',
          metersHelpSource: 'Configure un Rol de la fuente para el grupo.',
          metersHelpAssignments:
            'Asegúrese de que el grupo tenga asociaciones de medidores válidas y vigentes.',
          metersHelpWhereConfigure: '¿Dónde configurar?',
          metersHelpSourcePath:
            'Rol de la fuente: Configuración VEE → Grupos VEE → Editar Grupo VEE',
          metersHelpAssignmentsPath: 'Asociaciones: Configuración VEE → Asociación por Jerarquía',
          noMetersAvailable:
            'No hay medidores disponibles para este grupo. Consulte el ícono de ayuda para revisar la configuración necesaria.',
        },
        empty: {
          definitions: 'No se encontraron reglas personalizadas.',
          preview: 'Complete los campos obligatorios de la regla para generar el resumen.',
          dryRunTitle: 'Todavía no se ejecutó ninguna prueba',
          dryRun:
            'Ejecute una prueba en el Sandbox para ver el impacto simulado de esta regla antes de activarla.',
          history: 'No hay historial disponible.',
        },
        errors: {
          loadGroups: 'No fue posible cargar los grupos VEE.',
          resolveGroupRule:
            'No fue posible localizar el motor de regla personalizada de este grupo.',
          customRuleEngineIntegrity:
            'Se encontró más de una configuración interna de reglas personalizadas. Corrija la configuración del VEE antes de continuar.',
          noCustomRuleEngine:
            'Este grupo todavía no está habilitado para usar reglas personalizadas. Habilite esta función para el grupo y luego continúe con la configuración de la regla.',
          noCustomRuleEnginePermission:
            'Este grupo todavía no está habilitado para usar reglas personalizadas. Solicite a un usuario con permiso de configuración del VEE que habilite esta función.',
          customRuleEngineScopeUnsupported:
            'Este grupo está configurado con el Alcance de datos "Totalizadores". Las reglas personalizadas utilizan lecturas de Memoria Masiva y, por eso, solo pueden habilitarse en grupos con alcance "Memoria Masiva" o "Híbrido".',
          groupVigenciaExpired:
            'Este grupo está fuera de su vigencia (la fecha final ya pasó). Ajuste la vigencia del grupo antes de habilitar reglas personalizadas.',
          enableCustomRuleEngine: 'No fue posible habilitar reglas personalizadas para este grupo.',
          loadDefinitions: 'No fue posible cargar las reglas personalizadas.',
          loadHistory: 'No fue posible cargar el historial de la regla.',
          loadMeters: 'No fue posible cargar los medidores del grupo.',
          save: 'No fue posible guardar la regla personalizada.',
          preview: 'No fue posible actualizar el resumen de la regla.',
          validationFailed:
            'La combinación informada no es válida. Revise los detalles a continuación antes de continuar.',
          reviewHighlightedFields: 'Revise los campos resaltados en rojo antes de guardar.',
          dryRun: 'No fue posible ejecutar la prueba de la regla.',
          activate: 'No fue posible activar la regla personalizada.',
          rollback: 'No fue posible revertir la regla personalizada.',
        },
        toast: {
          customRuleEngineEnabled: 'Reglas personalizadas habilitadas para este grupo.',
          saved: 'Regla personalizada guardada con éxito.',
          savedNewVersion:
            'La regla estaba en uso: se creó una nueva versión. La versión anterior permanece sin cambios.',
          previewUpdated: 'Resumen de la regla actualizado con éxito.',
          previewUnchanged: 'No se identificaron cambios para actualizar el resumen.',
          dryRunSuccess: 'Prueba ejecutada con éxito.',
          dryRunFailed:
            'La prueba se ejecutó, pero el resultado indicó fallo. Revise los detalles del dry-run.',
          activated: 'Regla personalizada activada efectivamente.',
          rolledBack:
            'Rollback completado: se creó una nueva versión en borrador. Ajuste la vigencia y ejecute una nueva prueba antes de activar.',
        },
      },
    },
    veeResume: {
      pageTitle: 'Monitoreo - Resumen',
      title: 'Resumen',
      badge: 'Operación/consulta',
      cards: {
        batchProcessed: 'Lote Procesado (%)',
        metersCompleted: 'Medidores Concluidos',
        estimatesToApprove: 'Estimaciones para Aprobar',
        blocks: 'Bloqueos',
        unavailable: 'No Disponible',
      },
      billingReadiness: {
        title: 'Preparación para Facturación',
        empty: 'No se encontraron medidores.',
        loadError: 'No fue posible cargar la preparación para facturación.',
        columns: {
          meter: 'Medidor',
          status: 'Estado',
          pending: 'Pendientes',
          action: 'Acción Recomendada',
        },
        status: {
          ready: 'Listo',
          pending: 'Pendientes',
          blocked: 'Bloqueos',
          manuallyReleased: 'Liberado Manualmente',
          notApplicable: 'No Aplicable',
        },
        units: {
          estimates: 'estimaciones',
          critical: 'crítica',
          exceptions: 'excepciones',
        },
        actions: {
          approveEstimates: 'Aprobar Estimaciones',
          reviewBlock: 'Revisar Bloqueo',
        },
        noPending: '-',
        filters: {
          group: 'Grupo',
          selectGroup: 'Seleccione el grupo',
          status: 'Status',
          selectStatus: 'Seleccione el status',
          searchPlaceholder: 'Buscar por medidor',
        },
      },
      calendar: {
        title: 'Calendario de Facturación',
        configureTooltip: 'Configurar calendario de facturación',
        empty: 'Ningún calendario de facturación configurado.',
        unavailable: 'No fue posible cargar el calendario de facturación.',
        partial: 'Algunos grupos no pudieron cargarse.',
        nextClosing: 'Próximo cierre',
        daysRemaining: '{count} día(s) restante(s)',
        columns: {
          name: 'Nombre',
          nextClosing: 'Próximo Cierre',
          status: 'Status',
        },
        status: {
          ready: 'Listo',
          pending: 'Pendientes',
          blocked: 'Bloqueos',
          unavailable: 'Sin Datos',
        },
      },
      toast: {
        loadError: 'No fue posible cargar el resumen operacional.',
        partialLoadTitle: 'Carga parcial',
        partialLoadDetail: 'Algunos grupos del calendario de facturación no pudieron cargarse.',
      },
    },
    veeBatchApproval: {
      pageTitle: 'Monitoreo - Aprobación en Lote',
      title: 'Aprobación en Lote',
      badge: 'Operación/consulta · supervisor',
      filters: {
        title: 'Filtros',
        group: 'Grupo',
        selectGroup: 'Seleccione el grupo',
        region: 'Región',
        selectRegion: 'Seleccione la región',
        noRegions: 'No se encontraron regiones',
        method: 'Método',
        selectMethod: 'Seleccione el método',
        period: 'Período',
        selectPeriod: 'Seleccione el período',
        severity: 'Severidad',
        selectSeverity: 'Seleccione la severidad',
        minAgingDays: 'Aging mínimo (días)',
        maxAgingDays: 'Aging máximo (días)',
        agingPlaceholder: 'Ingrese el valor',
        clear: 'Limpiar',
        apply: 'Aplicar',
        validation: {
          title: 'Filtros inválidos',
          agingMustBeNonNegative: 'El aging mínimo y máximo no pueden ser negativos.',
          minAgingAboveMax: 'El aging mínimo no puede ser mayor que el aging máximo.',
        },
      },
      table: {
        title: 'Estimaciones pendientes de aprobación',
        searchPlaceholder: 'Buscar por medidor',
        empty: 'No hay estimaciones pendientes de aprobación.',
        mixedGroupSelection:
          'La selección contiene propuestas de más de un grupo VEE. La aprobación en lote exige que todas las propuestas seleccionadas pertenezcan al mismo grupo.',
        valueUnavailable: 'No disponible',
        reasonUnavailable: 'Motivo no disponible',
        columns: {
          meter: 'Medidor',
          group: 'Grupo',
          region: 'Región',
          severity: 'Severidad',
          aging: 'Aging (días)',
          periodStart: 'Inicio del período',
          periodEnd: 'Fin del período',
          method: 'Método',
          originalValue: 'Valor pre-VEE',
          referenceValue: 'Referencia del método',
          proposedValue: 'Valor propuesto',
          measurementKey: 'Magnitud',
          unit: 'Unidad',
          deviation: 'Desviación',
          secondaryValidation: 'Validación secundaria',
          reason: 'Motivo de la propuesta',
        },
      },
      actions: {
        approve: 'Aprobar seleccionadas',
      },
      toasts: {
        approveSummary: 'Estimaciones aprobadas',
        approveDetail: '{count} estimación(es) aprobada(s) con éxito.',
        noSelectionSummary: 'Ninguna estimación seleccionada',
        noSelectionDetail: 'Seleccione al menos una estimación para continuar.',
        mixedGroupSummary: 'Selección con grupos diferentes',
        mixedGroupDetail: 'Todas las propuestas seleccionadas deben pertenecer al mismo grupo VEE.',
        partialSummary: 'Aprobación parcial',
        partialDetail: '{approved} aprobada(s) y {failed} no aprobada(s).',
        allFailedSummary: 'Ninguna propuesta aprobada',
        allFailedDetail: 'Ninguna de las {failed} propuesta(s) seleccionada(s) pudo ser aprobada.',
        requestErrorSummary: 'No fue posible aprobar el lote',
        requestErrorDetail: 'Ocurrió un error al procesar la solicitud de aprobación en lote.',
        loadErrorSummary: 'No fue posible cargar las estimaciones',
        loadErrorDetail:
          'Ocurrió un error al cargar la lista de estimaciones pendientes de aprobación en lote.',
      },
      outcomeReasons: {
        notFoundInTenant: 'Propuesta no encontrada',
        alreadyDecided: 'Propuesta ya decidida',
        notEligible: 'Propuesta no elegible',
        secondaryValidationNotApproved: 'Validación secundaria no aprobada',
        gapUnavailable: 'Duración de la brecha no disponible',
        gapExceeded: 'Duración de la brecha por encima del límite permitido',
        deviationUnavailable: 'Desviación no disponible',
        deviationExceeded: 'Desviación por encima del límite permitido',
        policyMissingOrIncomplete:
          'Política de aprobación en lote ausente o incompleta para el grupo',
        concurrencyConflict: 'Propuesta decidida por otra operación simultánea',
        coverageConflict: 'Período ya cubierto por otra propuesta aprobada',
        technicalError: 'Error técnico al procesar la propuesta',
      },
      confirmDialog: {
        title: 'Confirmar Aprobación en Lote',
        warning: 'Esta operación aprobará las estimaciones seleccionadas.',
        count: 'Cantidad seleccionada',
        group: 'Grupo',
        distinctMeters: 'Medidores distintos',
        methods: 'Métodos involucrados',
        byUnitAndMeasurement: 'Cantidad por magnitud y unidad',
        cancel: 'Cancelar',
        confirm: 'Confirmar aprobación',
      },
    },
    veeReadingImport: {
      pageTitle: 'Monitoreo - Importación de Lecturas',
      title: 'Importación de Lecturas',
      badge: 'Operación/consulta',
      clearAll: 'Limpiar todo',
      addRow: 'Agregar línea',
      importSpreadsheet: 'Importar planilla',
      importDialogTitle: 'Importar Lecturas',
      empty: 'Ningún ítem agregado todavía. Importe una planilla o agregue líneas manualmente.',
      importedRecordsTitle: 'Registros Insertados',
      total: 'Total',
      columns: {
        meter: 'Medidor',
        meterPlaceholder: 'Número de serie del medidor',
        scope: 'Alcance',
        scopePlaceholder: 'Seleccione el alcance',
        measurementKey: 'Magnitud',
        measurementKeyPlaceholder: 'Seleccione la magnitud',
        measurementKeyUnrecognized:
          'Magnitud "{value}" no reconocida para el alcance seleccionado.',
        readingTimestamp: 'Fecha/Hora',
        readingTimestampPlaceholder: 'Fecha y hora',
        newValue: 'Nuevo valor',
        newValuePlaceholder: 'Ingrese el nuevo valor',
        reasonCode: 'Motivo',
        reasonCodePlaceholder: 'Seleccione el motivo',
        itemJustification: 'Justificación del ítem',
        itemJustificationPlaceholder: 'Opcional',
        originalValue: 'Valor original',
        difference: 'Diferencia',
        status: 'Estado',
        validationReason: 'Motivo de la validación',
        suggestion: 'Sugerencia',
        actions: 'Acción',
      },
      status: {
        ok: 'Válido',
        warning: 'Alerta',
        rejected: 'Inválido',
      },
      requiredFields: {
        meterSerial: 'Medidor es obligatorio.',
        dataScope: 'Alcance es obligatorio.',
        measurementKey: 'Magnitud es obligatoria.',
        readingTimestamp: 'Fecha/Hora es obligatoria.',
        newValue: 'Nuevo valor es obligatorio.',
        reasonCode: 'Motivo es obligatorio.',
      },
      acceptSuggestion: 'Aceptar sugerencia',
      invalidRowsSummary:
        '{count} ítem(s) no pasaron la validación leve. Consulte el motivo en la columna "Motivo de la validación".',
      warningRowsSummary:
        '{count} ítem(s) tienen alerta de validación leve. Revise la sugerencia, si existe, antes de enviar.',
      validRowsSummary: 'Todos los ítems son válidos. Ya puede enviar el lote para aprobación.',
      batchJustification: 'Justificación del lote',
      batchJustificationPlaceholder: 'Explique el motivo de las ediciones de este lote',
      validate: 'Validar',
      submit: 'Enviar para aprobación',
      clearAllDialog: {
        title: 'Limpiar todas las líneas',
        message:
          '¿Realmente desea eliminar las {count} líneas de la tabla? Esta acción no se puede deshacer.',
        cancel: 'Cancelar',
        confirm: 'Limpiar todo',
      },
      confirmDialog: {
        title: 'Confirmar Envío para Aprobación',
        warning:
          'El lote será enviado para aprobación del supervisor y todavía no será efectivado.',
        totalCount: 'Total de registros',
        validCount: 'Registros válidos',
        meters: 'Medidores involucrados',
        measurements: 'Magnitudes',
        cancel: 'Cancelar',
        confirm: 'Confirmar envío',
      },
      toasts: {
        emptyFile: 'No se encontraron líneas en el archivo importado.',
        importedSummary: 'Planilla importada',
        importedDetail: '{count} línea(s) agregada(s). Revise y valide antes de enviar.',
        validateErrorSummary: 'Error al validar',
        validateErrorDetail: 'No fue posible validar el lote.',
        invalidRowsSummary: 'Ítems inválidos',
        warningRowsSummary: 'Ítems con alerta',
        validRowsSummary: 'Lote validado',
        submitSuccessSummary: 'Lote enviado para aprobación',
        submitSuccessDetail:
          'El lote fue registrado como pendiente y espera la decisión del supervisor.',
        submitErrorSummary: 'Error al enviar el lote',
        submitErrorDetail: 'No fue posible enviar el lote para aprobación.',
        suggestionAppliedSummary: 'Sugerencia aplicada',
        suggestionAppliedDetail:
          'El nuevo valor fue actualizado con la sugerencia. Valide de nuevo antes de enviar.',
      },
    },
    veeManualEditBatchApproval: {
      pageTitle: 'Monitoreo - Aprobación de Edición en Lote',
      title: 'Aprobación de Edición en Lote',
      listCardTitle: 'Lotes de Edición',
      filters: {
        title: 'Filtros',
        status: 'Estado',
        selectStatus: 'Seleccione el estado',
        author: 'Autor/Operador',
        selectAuthor: 'Seleccione el autor',
        period: 'Período de envío',
        selectPeriod: 'Seleccione el período',
        clear: 'Limpiar',
        apply: 'Aplicar',
      },
      empty: 'Ningún lote de edición encontrado.',
      columns: {
        submittedAt: 'Enviado en',
        status: 'Estado',
        totalItems: 'Ítems',
        appliedFailed: 'Aplicados / Fallidos',
        justification: 'Justificación',
        itemStatus: 'Estado del ítem',
        actions: 'Acciones',
      },
      viewDetails: 'Ver detalles',
      detailTitle: 'Detalle del Lote de Edición',
      itemsTitle: 'Ítems del lote',
      itemsSearchPlaceholder: 'Buscar por medidor',
      itemsEmpty: 'Ningún medidor encontrado para la búsqueda informada.',
      close: 'Cerrar',
      batchJustification: 'Justificación del lote',
      decisionNote: 'Motivo de la decisión',
      rejectionJustification: 'Justificación del rechazo',
      rejectionJustificationPlaceholder: 'Explique el motivo del rechazo',
      decisionNotAllowed:
        'Puede consultar este lote, pero aprobar o rechazar requiere el perfil Administrador o Gestor.',
      reject: 'Rechazar',
      approve: 'Aprobar',
      statuses: {
        pending: 'Pendiente',
        approved: 'Aprobado',
        rejected: 'Rechazado',
        processing: 'Procesando',
        completed: 'Completado',
        failed: 'Con falla',
      },
      itemStatuses: {
        pending: 'Pendiente',
        applied: 'Aplicado',
        failed: 'Con falla',
        skipped: 'Omitido',
      },
      toasts: {
        loadErrorSummary: 'Error al cargar lotes',
        loadErrorDetail: 'No fue posible cargar los lotes de edición.',
        loadDetailErrorSummary: 'Error al cargar detalle',
        loadDetailErrorDetail: 'No fue posible cargar el detalle del lote.',
        approveSummary: 'Lote procesado',
        approveDetail: '{applied} ítem(s) aplicado(s), {failed} ítem(s) con falla.',
        rejectSummary: 'Lote rechazado',
        rejectDetail: 'El lote fue rechazado y ninguna lectura fue efectivada.',
        decisionErrorSummary: 'Error al decidir sobre el lote',
        decisionErrorDetail: 'No fue posible registrar la decisión sobre el lote.',
      },
    },
    veeRequestQueue: {
      pageTitle: 'Monitoreo - Cola de Solicitudes',
      title: 'Cola de Solicitudes',
      badge: 'Operación/consulta',
      empty: 'Ninguna solicitud pendiente.',
      slaNotConfigured: 'SLA no configurado',
      columns: {
        meter: 'Medidor',
        issue: 'Tipo/Problema',
        priority: 'Prioridad',
        slaRemaining: 'SLA',
        aging: 'Antigüedad (días)',
        status: 'Estado',
        actions: 'Acciones',
      },
      requestType: {
        estimationExhausted: 'Ningún método de estimación fue aceptable',
        proposalRejected: 'Propuesta de estimación rechazada o inviable',
        operationalEscalation: 'Excepción escalada para acción operativa',
      },
      status: {
        open: 'Pendiente',
        inProgress: 'En tratamiento',
        resolved: 'Resuelta',
        cancelled: 'Cancelada',
      },
      severity: {
        info: 'Info',
        issue: 'Alerta',
        terminate: 'Crítico',
      },
      actions: {
        editReading: 'Editar lectura manualmente para este medidor',
        changeStatus: 'Editar estado',
      },
      filters: {
        status: 'Estado',
        selectStatus: 'Seleccione el estado',
        slaOverdue: 'SLA',
        selectSlaOverdue: 'Seleccione',
        overdueOnly: 'Solo vencidos',
        withinSla: 'Dentro del plazo',
        searchPlaceholder: 'Buscar por medidor',
      },
      statusDialog: {
        title: 'Cambiar Estado de la Solicitud',
        newStatusLabel: 'Nuevo estado',
        selectStatusPlaceholder: 'Seleccione el nuevo estado',
        note: 'Observación',
        notePlaceholder: 'Describa el motivo del cambio de estado.',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        noteRequiredSummary: 'Observación obligatoria',
        noteRequiredDetail: 'Describa el motivo antes de resolver o cancelar la solicitud.',
      },
      toasts: {
        loadErrorSummary: 'Error al cargar',
        loadErrorDetail: 'No fue posible cargar la cola de solicitudes.',
        loadDetailsErrorDetail: 'No fue posible cargar los datos actualizados de la solicitud.',
        statusChangedSummary: 'Estado actualizado con éxito.',
        statusChangeErrorSummary: 'Error al cambiar el estado',
        statusChangeErrorDetail: 'No fue posible cambiar el estado de la solicitud.',
      },
    },
    veeManualBillingRelease: {
      pageTitle: 'Monitoreo - Desbloqueo Manual de Facturación',
      breadcrumbTitle: 'Desbloqueo Manual de Facturación',
      tableTitle: 'Desbloqueo Manual de Facturación',
      columns: {
        group: 'Grupo',
        meter: 'Medidor',
        referenceMonth: 'Ciclo',
        status: 'Estado',
        blockingReason: 'Motivo del bloqueo',
        actions: 'Acciones',
      },
      statusOptions: {
        ready: 'Listo',
        pending: 'Pendiente',
        blocked: 'Bloqueado',
        manuallyReleased: 'Liberado manualmente',
        notApplicable: 'No aplicable',
      },
      placeholders: {
        searchPlaceholder: 'Buscar por medidor',
        selectGroup: 'Seleccione el grupo',
        selectStatus: 'Seleccione el estado',
      },
      filters: {
        group: 'Grupo',
        status: 'Estado',
      },
      actions: {
        release: 'Desbloquear facturación',
        retry: 'Intentar de nuevo',
      },
      dialog: {
        title: 'Desbloquear Facturación',
        justificationLabel: 'Justificación',
        justificationPlaceholder: 'Describa el motivo del desbloqueo manual de la facturación.',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
      },
      toast: {
        released: 'Facturación desbloqueada manualmente con éxito.',
      },
      errors: {
        title: 'Error',
        loadList: 'No fue posible cargar la lista de disposición de facturación.',
        release: 'No fue posible desbloquear la facturación manualmente.',
      },
    },
    veeManualOccurrences: {
      pageTitle: 'Monitoreo - Ocurrencias Manuales VEE',
      breadcrumbTitle: 'Ocurrencias Manuales',
      tableTitle: 'Ocurrencias Registradas',
      columns: {
        diagnosisType: 'Diagnóstico',
        meter: 'Medidor',
        validity: 'Vigencia',
        status: 'Estado',
        createdAt: 'Registrado en',
        actions: 'Acciones',
      },
      diagnosisTypeOptions: {
        burnedTp: 'TP quemado',
        burnedTc: 'TC quemado',
        burnedMeter: 'Medidor quemado',
      },
      statusOptions: {
        pending: 'Pendiente',
        inAnalysis: 'En análisis',
        resolved: 'Resuelta',
        ignored: 'Ignorada',
      },
      validityOpenEnded: 'Indeterminado',
      filters: {
        diagnosisType: 'Diagnóstico',
        diagnosisTypePlaceholder: 'Informe el diagnóstico',
        meterSerial: 'Medidor',
        meterSerialPlaceholder: 'Informe el serial del medidor',
        validity: 'Vigencia',
        validityPlaceholder: 'Informe la vigencia',
      },
      actions: {
        create: 'Registrar ocurrencia',
        viewMeterTooltip: 'Ver medidor',
      },
      form: {
        title: 'Registrar Ocurrencia de TP/TC/Medidor Quemado',
        fields: {
          meter: 'Medidor',
          diagnosisType: 'Diagnóstico',
          validity: 'Vigencia',
          justification: 'Justificación',
        },
        placeholders: {
          meter: 'Busque el medidor por el serial',
          meterSearchHint: 'Escriba el serial para buscar un medidor.',
          meterNoResults: 'Sin opciones disponibles',
          diagnosisType: 'Informe el diagnóstico',
          validity: 'Seleccione el inicio y, si existe, el fin de la vigencia',
          justification: 'Describa el diagnóstico y la evidencia de la ocurrencia',
        },
        validation: {
          meterRequired: 'Seleccione el medidor.',
          diagnosisTypeRequired: 'Seleccione el diagnóstico.',
          validityStartRequired: 'Informe el inicio de la vigencia.',
          validityStartFuture: 'El inicio de la vigencia no puede estar en el futuro.',
          validityRangeInvalid: 'El inicio de la vigencia no puede ser posterior al fin.',
          justificationRequired: 'La justificación es obligatoria.',
        },
        actions: {
          cancel: 'Cancelar',
          save: 'Registrar',
          saving: 'Registrando...',
        },
      },
      toast: {
        created: 'Ocurrencia registrada con éxito.',
        loadError: 'No fue posible cargar las ocurrencias.',
        saveError: 'No fue posible registrar la ocurrencia.',
      },
    },
    veeZeroConsumption: {
      pageTitle: 'Monitoreo - Consumo Cero',
      title: 'Consumo Cero Prolongado',
      tableTitle: 'Ocurrencias de Consumo Cero Prolongado',
      empty: 'Ninguna ocurrencia de consumo cero prolongado encontrada.',
      cards: {
        affectedMeters: 'Medidores Afectados',
        criticalMeters: 'Medidores Críticos',
        pendingMeters: 'Pendientes de Tratamiento',
        inAnalysisMeters: 'En Análisis',
        vacantMeters: 'Desocupados',
      },
      columns: {
        meter: 'Medidor',
        zeroSince: 'Cero desde',
        duration: 'Duración',
        region: 'Región',
        class: 'Clase',
        occupancy: 'Ocupación',
        severity: 'Severidad',
        status: 'Estado',
        recommendedAction: 'Acción recomendada',
        actions: 'Acción',
      },
      durationDays: '{days} día(s)',
      statusOptions: {
        pending: 'Pendiente',
        inAnalysis: 'En análisis',
        resolved: 'Resuelta',
        ignored: 'Ignorada',
      },
      occupancyOptions: {
        occupied: 'Ocupada',
        vacant: 'Desocupada',
        unknown: 'No informado',
      },
      levelOptions: {
        initial: 'Inicial',
        intermediate: 'Intermedio',
        critical: 'Crítico',
      },
      operationalActionOptions: {
        alert: 'Alerta',
        hold: 'Retención',
        blockBilling: 'Bloqueo de facturación',
        stopPipeline: 'Interrupción del pipeline',
      },
      filters: {
        status: 'Estado',
        statusPlaceholder: 'Seleccione el estado',
        occupancy: 'Ocupación',
        occupancyPlaceholder: 'Seleccione la ocupación',
        level: 'Nivel',
        levelPlaceholder: 'Seleccione el nivel',
        regionCode: 'Región',
        regionCodePlaceholder: 'Seleccione la región',
        noRegions: 'No se encontraron regiones',
        classCode: 'Clase',
        classCodePlaceholder: 'Informe el código de la clase',
        minDurationHours: 'Duración mínima (h)',
        minDurationHoursPlaceholder: 'Informe la duración mínima',
        maxDurationHours: 'Duración máxima (h)',
        maxDurationHoursPlaceholder: 'Informe la duración máxima',
        searchPlaceholder: 'Buscar por medidor',
      },
      actions: {
        resolve: 'Resolver',
        ignore: 'Ignorar',
        processing: 'Procesando...',
        disabledClosed: 'Ocurrencia ya {status}, ninguna acción disponible.',
      },
      decisionDialog: {
        resolveTitle: 'Resolver Ocurrencia',
        ignoreTitle: 'Ignorar Ocurrencia',
        message: 'Informe la justificación para continuar con esta ocurrencia.',
        meterLabel: 'Medidor',
        justification: 'Justificación',
        justificationPlaceholder: 'Describa la verificación realizada y la evidencia encontrada',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
      },
      toast: {
        loadError: 'No fue posible cargar las ocurrencias de consumo cero.',
        actionErrorTitle: 'Error al actualizar la ocurrencia',
        actionErrorDetail: 'No fue posible actualizar el estado de la ocurrencia.',
        resolvedTitle: 'Ocurrencia resuelta',
        resolvedDetail: 'La ocurrencia del medidor {meter} fue marcada como resuelta.',
        ignoredTitle: 'Ocurrencia ignorada',
        ignoredDetail: 'La ocurrencia del medidor {meter} fue marcada como ignorada.',
      },
    },
    veeLimitDeviations: {
      pageTitle: 'Monitoreo - Desviaciones de Límites',
      title: 'Desviaciones de Límites',
      badge: 'Operación/consulta',
      empty: 'No se encontraron desviaciones.',
      cards: {
        above: 'Desviaciones por Encima',
        aboveUnit: 'medidores',
        below: 'Desviaciones por Debajo',
        belowUnit: 'medidores',
      },
      charts: {
        deviationTitle: 'Distribución de desviaciones por medidor',
        severityTitle: 'Distribución por severidad',
        legendAbove: 'Por encima del límite',
        legendBelow: 'Por debajo del límite',
      },
      columns: {
        meter: 'Medidor',
        direction: 'Dirección',
        deviation: 'Desviación',
        baseline: 'Baseline',
        severity: 'Severidad',
        status: 'Estado',
        region: 'Región',
        class: 'Clase',
      },
      filters: {
        searchPlaceholder: 'Buscar por medidor',
        direction: 'Dirección',
        directionPlaceholder: 'Seleccione la dirección',
        status: 'Estado',
        statusPlaceholder: 'Seleccione el estado',
        severity: 'Severidad',
        severityPlaceholder: 'Seleccione la severidad',
        regionCode: 'Región',
        regionCodePlaceholder: 'Seleccione la región',
        noRegions: 'No se encontraron regiones',
        classCode: 'Clase',
        classCodePlaceholder: 'Informe el código de la clase',
      },
      directionOptions: {
        above: 'Por encima',
        below: 'Por debajo',
      },
      statusOptions: {
        pending: 'Pendiente',
        inAnalysis: 'En análisis',
        resolved: 'Resuelta',
        ignored: 'Ignorada',
      },
      baselineMethods: {
        absoluteLimit: 'Límite absoluto',
        percentageLimit: 'Límite porcentual',
        historicalAverage: 'Promedio histórico',
        comparableDay: 'Día comparable',
        seasonalProfile: 'Perfil estacional',
      },
      toast: {
        loadError: 'No fue posible cargar las desviaciones de límites.',
      },
    },
    veeExecutionMonitor: {
      pageTitle: 'Monitoreo - Monitor de Ejecución',
      title: 'Monitor de Ejecución del Batch',
      badge: 'Operación/consulta',
      empty: 'No se encontraron ejecuciones.',
      columns: {
        execution: 'Ejecución',
        group: 'Grupo',
        period: 'Período',
        status: 'Estado',
        volume: 'Volumen',
        duration: 'Duración',
        backlog: 'Backlog',
      },
      status: {
        pending: 'Pendiente',
        running: 'En ejecución',
        completed: 'Concluida',
        completedWithAlert: 'Concluida con alerta',
        failed: 'Fallida',
        cancelled: 'Cancelada',
      },
      filters: {
        status: 'Estado',
        statusPlaceholder: 'Seleccione un estado',
        period: 'Período',
        selectPeriod: 'Seleccione un período',
      },
      toast: {
        loadError: 'No fue posible cargar las ejecuciones.',
      },
    },
    groupDetails: {
      monthlyQualityParameters: {
        title: 'Promedio mensual de DRP/DRC',
        button: 'Calcular promedio mensual de DRP/DRC',
        dialogTitle: 'Promedio mensual de DRP/DRC',
        success: 'Promedio mensual de DRP/DRC calculado correctamente',
        error: 'Error al calcular el promedio mensual de DRP/DRC',
        exportError: 'Seleccione una referencia para exportar el promedio mensual de DRP/DRC.',
      },
      latestQualityParameters: {
        title: 'Parámetros de calidad más recientes',
        error: 'Error al cargar los parámetros de calidad más recientes',
      },
    },
    scheduledCommands: {
      title: 'Listado de Rutinas',
      filterByGroup: 'Filtrar por nombre del Grupo',
      statusChanged: 'Estado de la programación cambiado',
      deleteSuccess: 'Programación eliminada correctamente',
      timeMax: 'Tiempo máximo para ejecutar el comando',
      description: 'Descripción',
      selectGroup: 'Seleccionar grupo',
      selectCommand: 'Seleccionar comando',
      editRoutine: 'Editar Rutina',
      addRoutine: 'Agregar Rutina',
      configure: 'Configurar',
      review: 'Revisar',
      quantityLastMeasures: 'Cantidad de Últimas Mediciones',
      quantityLastMeasuresSmc: 'Cantidad de Últimas Mediciones (SMC)',
      commandParameters: 'Parámetros del Comando',
      alternativeDataSmi: 'Datos Alternativos (SMI)',
      energyRecoveryDataSmi: 'Datos de Recuperación de Energía (SMI)',
      initialDateTime: 'Fecha/Hora Inicial',
      finalDateTime: 'Fecha/Hora Final',
      intervalMinutes: 'Intervalo en Minutos',
      seconds: 'Segundos',
      back: 'Volver',
      update: 'Actualizar',
      add: 'Agregar',
      routineUpdated: 'Rutina Actualizada',
      routineCreated: 'Rutina Creada',
      saveRoutineError: 'Error al guardar Rutina',
      unknownError: 'Error desconocido',
      loadGroupsError: 'Error al buscar grupos',
      successTitle: 'Éxito',
      errorTitle: 'Error',
      statusChangeError: 'Error al cambiar el estado de la programación',
      deleteRoutineError: 'Error al eliminar la programación',
      minuteUnit: 'minuto',
      minutesUnit: 'minutos',
      placeholders: {
        filterByGroup: 'Ingrese el nombre del Grupo',
        description: 'Ingrese una descripción para la rutina',
        selectGroup: 'Seleccione un grupo',
        selectCommand: 'Seleccione un comando',
        quantity: 'Ingrese la cantidad',
        initialDate: 'Seleccione la fecha inicial',
        finalDate: 'Seleccione la fecha final',
        interval: 'Ingrese el intervalo',
        secondsQuantity: 'Ingrese la cantidad de segundos',
      },
      days: 'Día(s)',
      hours: 'Hora(s)',
      minutes: 'Minuto(s)',
      cronEditor: 'Editor Cron',
      validation: {
        descriptionRequired: 'Ingrese la descripción de la rutina.',
        descriptionHtmlNotAllowed: 'La descripción de la rutina no puede contener HTML.',
        groupRequired: 'Seleccione un grupo.',
        minimumDuration: 'El tiempo máximo para ejecutar el comando debe ser de al menos 1 minuto.',
        invalidCron: 'Configure un cron válido para la rutina.',
      },
      cronEditorOptions: {
        intlLocale: 'es-ES',
        every: 'Todo(a)',
        second: 'Segundo',
        minute: 'Minuto',
        hour: 'Hora',
        day: 'Día',
        week: 'Semana',
        month: 'Mes',
        year: 'Año',
        everySecond: 'cada segundo',
        everyMinute: 'cada minuto',
        everyHour: 'cada hora',
        everyMonth: 'cada mes',
        everyDayOfWeek: 'cada día específico de la semana',
        noSpecificDay: 'sin día específico',
        noSpecificDayOfWeek: 'sin día específico de la semana',
        all: 'todos',
        of: 'de',
        onDays: 'en el/los día(s)',
        and: 'y',
        andOf: 'y de',
        at: 'a las',
        secondsSuffix: 'segundo(s)',
      },
      nextExecution: 'Próxima ejecución',
      lastExecution: 'Última ejecución',
      routineDetails: 'Detalles de la Rutina',
      routinePage: 'Página de la Rutina',
      deleteRoutine: 'Eliminar Rutina',
      noProcessYet: 'No se encontró ningún proceso para esta rutina hasta el momento.',
      dateRange: {
        label: 'Intervalo',
        relativeSummary: 'Últimos {daysBack} día(s)',
        relativeEndsBefore: ', terminando {endDaysBack} día(s) antes del disparo',
        relativeTruncateToDay: ', alineado a la medianoche',
      },
    },
    transformerDetails: {
      title: 'Detalles del Transformador',
      details: 'Detalles',
      transformer: 'Transformador',
      editTransformer: 'Editar Transformador',
      name: 'Nombre',
      meterSerial: 'Serial del Medidor',
      metersCount: 'Cantidad de Medidores',
      publicLighting: 'Iluminación Pública',
      coordinates: 'Coordenadas',
      updatedAt: 'Última Actualización',
      description: 'Descripción',
      viewMore: 'Ver Más',
      meterDetails: 'Medidor del Transformador',
      manufacturerType: 'Fabricante | Tipo',
      serial: 'Serial',
      installation: 'Instalación',
      displayConfiguration: 'Configuración de Display',
      firmware: 'Firmware',
      relayStatus: 'Estado de Relé',
      status: 'Estado',
      meterMoreDetails: 'Detalles del Medidor',
      latitude: 'Lat',
      longitude: 'Long',
      massMemoryCrc: 'CRC Memoria de Masa',
      uplinkPeriod: 'Período de Uplink de Lectura',
      energyCrc: 'CRC Energía',
      tags: 'Etiquetas del Medidor',
      noTags: 'No hay etiquetas encontradas',
      close: 'Cerrar',
      loading: 'Cargando...',
    },
    areas: {
      title: 'Áreas',
      startDate: 'Fecha inicial',
      endDate: 'Fecha final',
      search: 'Buscar',
      placeholders: {
        loading: 'Cargando...',
        select: 'Elegir Área',
        selectDate: 'Seleccione la fecha',
      },
      errors: {
        title: 'Error',
        loadAreas: 'Error al cargar áreas',
      },
    },
    areaDetails: {
      title: 'Detalles de la Área',
      details: 'Detalles',
      area: 'Área',
      editArea: 'Editar Área',
      name: 'Nombre',
      transformersCount: 'Cantidad de Transformadores',
      updatedAt: 'Última Actualización',
      description: 'Descripción',
      errors: {
        title: 'Error',
        loadAreaInfo: 'Error al buscar información de la área',
      },
    },
    regions: {
      title: 'Regiones',
      regions: 'Regiones',
      selectPeriod: 'Seleccione el período',
      startDate: 'Fecha inicial',
      endDate: 'Fecha final',
      search: 'Buscar',
      placeholders: {
        loading: 'Cargando...',
        select: 'Elegir Región',
        selectDate: 'Seleccione la fecha',
      },
      errors: {
        title: 'Error',
        loadRegions: 'Error al cargar regiones',
      },
    },
    regionDetails: {
      title: 'Detalles de la Región',
      details: 'Detalles',
      region: 'Región',
      editRegion: 'Editar Región',
      name: 'Nombre',
      areasCount: 'Cantidad de Áreas',
      updatedAt: 'Última Actualización',
      description: 'Descripción',
      errors: {
        title: 'Error',
        loadRegionInfo: 'Error al buscar información de la región',
      },
    },
    serviceNotes: {
      code: 'Código',
      contractAccount: 'Cuenta de Contrato',
      dateTimeLimitConclusion: 'Fecha Límite de Finalización',
      dateTimeStart: 'Fecha de Inicio',
      codeGroup: 'Grupo de Código',
      installation: 'Instalación',
      measureCodeGroup: 'Grupo de Código de Medición',
      noteNumber: 'Número de Nota',
      equipmentSerialNumber: 'Número de Serie del Equipo',
      cancellationRequest: 'Solicitud de Cancelación',
      noteType: 'Tipo de Nota',
      cPNumber: 'Número CP',
      cSNumber: 'Número CS',
      cSPosition: 'Posición CS',
      noteGroup: 'Grupo de Notas',
      noteCode: 'Código de Nota',
      measureGroup: 'Grupo de Medición',
      equipment: 'Equipo',
      referenceMonth: 'Mes de Referencia',
      creationDate: 'Fecha de Creación',
      creationHour: 'Hora de Creación',
      limitDate: 'Fecha Límite',
      limitHour: 'Hora Límite',
      serialMeter: 'Número de Serie del Medidor',
      rateType: 'Tipo de Tarifa',
      ssn: 'SSN',
      min: 'MIN',
      readingDate: 'Fecha de Lectura',
      readingUnit: 'Unidad de Lectura',
      day: 'Día',
      serial: 'Serial',
      registers: 'Registros',
      attempts: 'Intentos',
      origin: 'Origen',
      datetime: 'Fecha',
      online: 'Estado',
      meterActivated: 'Estado del Relé',
      comissioned: 'Comisionado',
      dateTimeInitial: 'Fecha de Inicio',
      dateTimeFinal: 'Fecha de Finalización',
      drp: 'DRP',
      drc: 'DRC',
      updatedAt: 'Actualizado en',
      count: 'Conteo',
      description: 'Descripción',
      dataResponse: 'Respuesta de la Nota',
    },
    models: {
      title: 'Modelos',
      meterModels: 'Modelos de Medidores',
      smcModels: 'Modelos de SMCs',
      newModel: 'Nuevo Modelo',
      registerModelFile: 'Importar modelos por archivo',
      editModelFile: 'Editar modelos por archivo',
      import: {
        successAll: 'Importación realizada con éxito',
        partial: 'Importación parcialmente completada',
        error: 'Error al importar modelos',
      },
      edit: {
        successAll: 'Edición realizada con éxito',
        partial: 'Edición parcialmente completada',
        error: 'Error al editar modelos',
      },
      success: {
        createModel: 'Modelo creado con éxito',
        updateModel: 'Modelo actualizado con éxito',
      },
      errors: {
        title: 'Error',
        loadModels: 'Error al buscar modelos',
        noModelSelected: 'Ningún modelo seleccionado',
        manufacturerNotFound: 'Fabricante no encontrado',
        createModel: 'Error al crear modelo',
        updateModel: 'Error al actualizar modelo',
      },
    },
    configuration: {
      title: 'Configuraciones',
      configure: 'Configurar',
      effectiveness: {
        title: 'Efectividad',
        description: 'Configure la cantidad mínima de medidores para el cálculo de efectividad.',
        dialog: {
          title: 'Configuración de Efectividad',
          model: 'Modelo',
          modelPlaceholder: 'Seleccione un modelo',
          searchModel: 'Buscar modelo',
          emptyModels: 'Ningún modelo encontrado',
          minimumQuantity: 'Cantidad Mínima',
          loading: 'Cargando...',
          cancel: 'Cancelar',
          save: 'Guardar',
        },
      },
      abruptVariation: {
        title: 'Variación Abrupta',
        description: 'Configure los parámetros de detección de variación abrupta de consumo.',
      },
      onlineHistoryInterval: {
        title: 'Verificación del Estado de los Medidores',
        description:
          'Configura el valor del intervalo para la verificación del estado de los medidores',
        dialog: {
          title: 'Configuración de intervalo',
          minimumInterval: 'Intervalo Mínimo',
          loading: 'Cargando...',
          cancel: 'Cancelar',
          save: 'Guardar',
        },
      },
    },
    displayText: {
      showMore: 'Ver más',
      showLess: 'Ver menos',
    },
  },
  auth: {
    login: {
      title: 'Acceso al Sistema',
      emailLabel: 'Correo electrónico',
      associate: 'Asociado',
      associateWarn:
        'Hemos verificado que aún no tienes vínculo en el sistema. Por favor, agrega tu correo electrónico.',
      passwordLabel: 'Contraseña',
      submitButton: 'Ingresar',
      submitButtonAd: 'Iniciar sesión Active Directory',
      tabEmail: 'E-mail',
      tabLdap: 'AD',
      usernameLdapLabel: 'Usuario AD',
      usernameLdapPlaceholder: 'Nombre de usuario de AD',
      forgotPassword: '¿La contraseña expiró?',
      placeholders: {
        email: 'Ingrese su correo electrónico',
        password: 'Ingrese su contraseña',
      },
      validation: {
        emailRequired: 'El correo electrónico es obligatorio',
        invalidEmail: 'Correo electrónico inválido',
        adCredentialRequired: 'El usuario de red o correo electrónico es obligatorio',
        passwordRequired: 'La contraseña es obligatoria',
      },
      recoverPassword: {
        saveButton: 'Guardar',
        cancelButton: 'Cancelar',
      },
    },
    userType: {
      admin: 'Administrador',
      operator: 'Operador Técnico',
      user: 'Usuário',
      erector: 'Instalador',
      manager: 'Gestor Técnico',
      sap: 'Usuário SAP',
      monitor: 'Monitor',
      root: 'Root',
      invalid: 'Inválido',
    },
    errors: {
      invalidCredentials: 'Correo electrónico o contraseña inválidos',
      missingFields: 'Todos los campos deben ser completados',
    },
    requiredChangePassword: {
      title: 'Cambio de Contraseña Obligatorio',
      emailLabel: 'Correo electrónico',
      expiredPasswordLabel: 'Contraseña actual',
      newPasswordLabel: 'Nueva contraseña',
      submitButton: 'Cambiar Contraseña',
      instructions: 'Cambie la contraseña creada por el administrador.',
      passwordRequirements:
        'La contraseña debe contener al menos 8 caracteres, una letra mayúscula, una letra minúscula, un número y un carácter especial.',
      placeholders: {
        email: 'Ingrese su correo electrónico',
        expiredPassword: 'Ingrese la contraseña actual',
        newPassword: 'Ingrese su nueva contraseña',
      },
      messages: {
        successSummary: 'Contraseña Cambiada Exitosamente',
        successDetail: 'La próxima vez, inicie sesión con su email y nueva contraseña',
        errorSummary: 'Error',
        errorDetail: 'Error al cambiar contraseña',
      },
      validation: {
        emailRequired: 'El correo electrónico es obligatorio',
        expiredPasswordRequired: 'La contraseña actual es obligatoria',
        newPasswordMinLength: 'La contraseña debe tener al menos 8 caracteres',
        newPasswordUppercase: 'La contraseña debe contener al menos una letra mayúscula',
        newPasswordLowercase: 'La contraseña debe contener al menos una letra minúscula',
        newPasswordNumber: 'La contraseña debe contener al menos un número',
        newPasswordSpecial: 'La contraseña debe contener al menos un carácter especial',
        uppercase: 'Letras mayúsculas y minúsculas [A-Z]',
        lowercase: 'Letras minúsculas [a-z]',
        number: 'Números [0-9]',
        special: 'Caracteres especiales [!,@,#,$,%,^,&,* o *]',
        minLength: 'Mínimo 8 caracteres',
      },
    },
  },
  forms: {
    firmware: {
      title: 'Versión de Firmware',
      detailsFirmware: 'Detalles del Firmware: ',
      crcHexInfo: 'Valor de hex en decimal: ',
      fields: {
        crc: 'CRC (Hex o Decimal)',
        firmwareForSMC: 'Firmware para SMC',
        nameFirmware: 'Nombre de la versión:',
        manufacturer: 'Fabricante:',
      },
      validation: {
        crcRequired: 'CRC es obligatorio',
        crcPrefixError: 'Elimine el 0x o el espacio antes del número hexadecimal',
        crcInvalidError:
          'Valor inválido. Ingrese solo números decimales o hexadecimales (0-9, A-F)',
        crcImmutableInfo: 'El CRC no puede ser alterado después de la creación',
        nameFirmwareRequired: 'El nombre de la versión es obligatorio',
        manufacturerRequired: 'El fabricante es obligatorio',
      },
      actions: {
        registerFirmware: 'Registrar',
        editFirmware: 'Editar firmware',
        deleteFirmware: 'Eliminar firmware',
        deleteConfirmationTitle: 'Confirmar eliminación de firmware en masa',
        cancel: 'Cancelar',
      },
      placeholder: {
        crc: 'Ingrese el CRC',
        nameFirmware: 'Ingrese el nombre de la versión',
        selectManufacturer: 'Seleccione un fabricante',
        loadingManufacturers: 'Cargando fabricantes...',
      },
    },
    keys: {
      title: 'Registrar clave',
      titleEdit: 'Modificar Clave',
      fields: {
        serial: 'Serial',
        authenticationKey: 'Clave de Autenticación',
        encryptionKey: 'Clave de Cifrado',
        masterKey: 'Clave Maestra',
        lls2: 'LLS2',
        usSecret: 'Secret US (opcional)',
        mrSecret: 'Secret MR (opcional)',
        fuSecret: 'Secret FU (opcional)',
      },
      validation: {
        fieldRequired: '¡Este campo es obligatorio!',
        serialImmutableInfo: 'El Serial no se puede cambiar después de la creación',
        keySize: 'Este campo debe contener 32 caracteres.',
        lls2Size: 'Este campo debe contener 16 (gateway) o 20 (medidor) caracteres.',
      },
      actions: {
        cancel: 'Cancelar',
        create: 'Registrar',
        update: 'Modificar',
        save: 'Guardar',
      },
    },
    tags: {
      title: 'Nueva Etiqueta',
      titleDetails: 'Detalles de la Etiqueta: ',
      fields: {
        name: 'Nombre',
        colors: 'Colores',
      },
      actions: {
        create: 'Crear etiqueta',
        update: 'Editar etiqueta',
        delete: 'Eliminar etiqueta',
        cancel: 'Cancelar',
        deleteConfirmationTitle: 'Confirmar eliminación de etiqueta en masa',
      },
      validation: {
        fieldRequired: '¡Este campo es obligatorio!',
      },
    },
    smcs: {
      title: 'Registrar nuevo SMC',
      titleEdit: 'Editar SMC',
      fields: {
        serial: 'Serial del SMC',
        description: 'Descripción',
        manufacturer: 'Fabricante',
        model: 'Modelo',
        latitude: 'Latitud',
        longitude: 'Longitud',
      },
      validation: {
        serialRequired: 'El serial es obligatorio',
        serialNoSpaces:
          'El serial del SMC no puede contener espacios al inicio, en el medio ni al final.',
        descriptionRequired: 'La descripción es obligatoria',
        manufacturerRequired: 'El fabricante es obligatorio',
        modelRequired: 'El modelo es obligatorio',
        warningDialogTittle:
          '¿Está seguro de que desea marcar las alarmas seleccionadas como leídas?',
        warningDialogMessage:
          'Al confirmar, se generará automáticamente un ticket con los datos del usuario responsable para fines de historial.',
        warningDialogTittleSingle: '¿Está seguro de que desea marcar esta alarma como leída?',
      },
      actions: {
        cancel: 'Cancelar',
        create: 'Crear SMC',
        update: 'Actualizar',
        confirm: 'Confirmar',
      },
      placeholders: {
        serial: 'Ingrese el serial del SMC',
        description: 'Ingrese la descripción del SMC',
        manufacturer: 'Ingrese el nombre del fabricante',
        model: 'Seleccione el modelo',
        latitude: 'Ingrese la latitud',
        longitude: 'Ingrese la longitud',
      },
    },
    clients: {
      title: 'Registrar nuevo cliente',
      titleEdit: 'Editar cliente',
      fields: {
        fullName: 'Nombre completo',
        location: 'Ubicación',
        weights: 'Pesos',
        prefixUf: 'Prefijo UF',
        selectAvailableMeters: 'Seleccionar Medidores Disponibles',
      },
      validation: {
        fullNameRequired: 'El nombre completo es obligatorio',
        locationRequired: 'La ubicación es obligatoria.',
        weightsInvalidFormat:
          'Ingrese pesos con un solo dígito por posición, separados por coma, espacio o punto y coma.',
        weightsInvalidLength: 'Cantidad de pesos no válida. Valores aceptados: 6, 7 o 10 dígitos.',
        prefixUfRequired: 'El Prefijo UF es obligatorio.',
        prefixUfInvalid: 'Ingrese un Prefijo UF válido.',
        meterSerialRequired: 'El serial del medidor es obligatorio',
      },
      actions: {
        cancel: 'Cancelar',
        create: 'Registrar',
        update: 'Actualizar',
      },
    },
    tariffs: {
      dateStart: 'Fecha de inicio',
      select: 'Seleccionar tipo de tarifa',
      dateActivation: 'Fecha de activación',
      send: 'Enviar',
    },
    models: {
      title: 'Registrar nuevo modelo',
      titleEdit: 'Editar modelo',
      fields: {
        name: 'Nombre',
        manufacturer: 'Fabricante',
        positionsCount: 'Cantidad de posiciones',
      },
      validation: {
        nameRequired: 'El nombre es obligatorio',
        manufacturerRequired: 'El fabricante es obligatorio',
      },
      actions: {
        cancel: 'Cancelar',
        create: 'Registrar',
        update: 'Guardar',
      },
      placeholder: {
        name: 'Ingrese el nombre del modelo',
        selectManufacturer: 'Seleccione el fabricante',
        loadingManufacturers: 'Cargando fabricantes...',
        positionsCount: 'Cantidad de posiciones',
      },
    },
  },
  tables: {
    noData: 'No hay datos encontrados',
    general: {
      search: 'Búsqueda rápida',
      status: 'Status',
      period: 'Período',
      dateRange: 'Intervalo de fechas',
      dateRangeError: 'Seleccione un intervalo de fechas válido.',
      quickOptions: 'Opciones rápidas',
      quickOptionsHint: 'seleccione un período sugerido',
      commands: 'Comandos',
      searchByEmail: 'Búsqueda por e-mail',
      searchBySerial: 'Búsqueda por serial',
      selectColumns: 'Seleccionar columnas:',
      selectCommands: 'Seleccione los comandos',
      selectionLimitSummary: 'Límite de selección',
      alarmTypesSelectionLimitDetail: 'Puede seleccionar como máximo 5 tipos de alarma.',
      commandsSelectionLimitSummary: 'Límite de selección',
      commandsSelectionLimitDetail: 'Puede seleccionar como máximo 5 comandos.',
      commandsSelectionRequiredSummary: 'Atención',
      commandsSelectionRequiredDetail: 'Seleccione al menos un comando.',
      selectStatus: 'Seleccionar estado:',
      searchByText: 'Busca por texto',
      gatewayName: 'Nombre del Gateway',
      commissioning: 'Comissionado',
      typeSignalQuality: 'Tipo de señal',
      gatewaySerial: 'Serial del Gateway',
      type: 'Tipo',
      details: 'Detalles',
      tags: 'Tags',
      selectTags: 'Seleccione las tags',
      selectOption: 'Seleccione una opción',
      cleanFilters: 'Limpiar Filtros',
      addFilter: 'Agregar Filtro',
      all: 'Todos',
      error: 'Error',
      totalRecords: 'Total de registros: {totalRecords}',
      yes: 'Sí',
      no: 'No',
      placeholders: {
        search: 'Buscar',
        searchByText: 'Realiza tu búsqueda aquí',
        gatewayName: 'Nombre del Gateway',
        gatewaySerial: 'Serial del Gateway',
        commissioning: 'Seleccionar comissionado',
        period: 'Seleccionar período',
        type: 'Seleccionar tipo',
        typeSignalQuality: 'Seleccionar tipo de señal',
        selectColumns: 'Seleccionar columnas',
      },
      tableChart: {
        showAll: 'Mostrar todo',
        showLess: 'Mostrar menos',
        displayedColumns: 'Columnas mostradas:',
        monoChartDisplayedColumns: 'Gráfico:',
      },
    },
    meterFileUpload: {
      massMemory: {
        dateTime: 'Fecha/Hora de lectura',
        totalEnergy_Wh: 'Totalizador general (Wh)',
        totalEnergyIncremental_Wh: 'Totalizador incremental (Wh)',
        q1ReactiveEnergy_VarH: 'Energía reactiva Q1 (VarH)',
        q4ReactiveEnergy_VarH: 'Energía reactiva Q4 (VarH)',
        group2VoltageVaH_V: 'Tensión Va (V)',
        group2VoltageVbH_V: 'Tensión Vb (V)',
        group2VoltageVcH_V: 'Tensión Vc (V)',
        group3CurrentIaH_A: 'Corriente Ia (A)',
        group3CurrentIbH_A: 'Corriente Ib (A)',
        group3CurrentIcH_A: 'Corriente Ic (A)',
        totalActiveEnergy_KWh: 'Energía activa total (kWh)',
        totalInductiveReactiveEnergy_KVarh: 'Energía reactiva inductiva total (kvarh)',
        totalCapacitiveReactiveEnergy_KVarh: 'Energía reactiva capacitiva total (kvarh)',
        totalReverseActiveEnergy_KWh: 'Energía activa inversa total (kWh)',
        reactiveEnergyImportQiiiRi_KVarH: 'Importación energía reactiva Q3 +Ri (kvarh)',
        reactiveEnergyImportQiiRc_KVarH: 'Importación energía reactiva Q2 +Rc (kvarh)',
        q1ReactiveEnergyIncremental_VarH: 'Energía reactiva Q1 incremental (kWh)',
        q4ReactiveEnergyIncremental_VarH: 'Energía reactiva Q4 incremental (kWh)',
        totalActiveEnergy_Wh: 'Energía activa directa (kWh)',
        totalDirectActiveEnergy_Wh: 'Energía activa directa total (kWh)',
        borderTotalizer_Wh: 'Totalizador punta (kWh)',
        reservedTotalizer_Wh: 'Totalizador fuera de punta (kWh)',
        offBorderTotalizer_Wh: 'Totalizador reservado (kWh)',
        totalIntermediary_Wh: 'Total intermediario (kWh)',
        generatedEnergyTotal_Wh: 'Energía generada - total (kWh)',
        totalReverseActiveEnergy_Wh: 'Energía activa inversa total (kWh)',
        totalDemand_W: 'Demanda activa total (W)',
        borderDemand_W: 'Demanda activa punta (W)',
        reservedDemand_W: 'Demanda activa fuera de punta (W)',
        totalApparentDemand_Va: 'Demanda aparente total (VA)',
        borderApparentDemand_Va: 'Demanda aparente punta (VA)',
        reservedApparentDemand_Va: 'Demanda aparente fuera de punta (VA)',
        totalDemandIncremental_W: 'Demanda activa total incremental (W)',
        borderDemandIncremental_W: 'Demanda activa punta incremental (W)',
        reservedDemandIncremental_W: 'Demanda activa fuera de punta incremental (W)',
        demandResetCount: 'Cantidad de reinicios de demanda',
        demandResetTime: 'Hora de reinicio de demanda',
        demandResetTimeMs: 'Hora de reinicio de demanda (ms)',
        demandCurrentTime: 'Hora actual de demanda',
        demandCurrentTimeMs: 'Hora actual de demanda (ms)',
        voltageA: 'Tensión A (V)',
        voltageB: 'Tensión B (V)',
        voltageC: 'Tensión C (V)',
        currentA: 'Corriente A (A)',
        currentB: 'Corriente B (A)',
        currentC: 'Corriente C (A)',
        maximumCurrentA_A: 'Corriente máxima A (A)',
        activePowerA: 'Potencia activa A (W)',
        activePowerB: 'Potencia activa B (W)',
        activePowerC: 'Potencia activa C (W)',
        lastAverageVoltageL1_V: 'Tensión media L1 (V)',
        lastAverageCurrentL1_A: 'Corriente media L1 (A)',
        lastAverageVoltageL2_V: 'Tensión media L2 (V)',
        lastAverageCurrentL2_A: 'Corriente media L2 (A)',
        lastAverageVoltageL3_V: 'Tensión media L3 (V)',
        lastAverageCurrentL3_A: 'Corriente media L3 (A)',
        totalPowerFactor_NoUnit: 'Factor de potencia total',
      },
      quality: {
        dateTimeInitial: 'Fecha/Hora Inicial',
        dateTimeFinal: 'Fecha/Hora Final',
        description: 'Descripción',
        drp: 'DRP (%)',
        drc: 'DRC (%)',
        dtt95: 'DTT95 (%)',
        fd95: 'FD95 (%)',
      },
      energy: {
        dateTime: 'Fecha/Hora',
        totalEnergy_Wh: 'Energía activa total (Wh)',
        borderTotalizer_Wh: 'Totalizador punta (Wh)',
        reservedTotalizer_Wh: 'Totalizador reservado (Wh)',
        offBorderTotalizer_Wh: 'Totalizador fuera de punta (Wh)',
        totalIntermediary_Wh: 'Totalizador intermediario (Wh)',
        generatedEnergyTotal_Wh: 'Energía generada total (Wh)',
        totalReverseActiveEnergy_Wh: 'Energía activa inversa total (kWh)',
        totalInductiveReactiveEnergy_VarH: 'Reactiva inductiva total (VarH)',
        totalCapacitiveReactiveEnergy_VarH: 'Reactiva capacitiva total (VarH)',
        consumedMaximunDemand_W: 'Demanda máxima consumida (W)',
        injectedMaximunDemand_W: 'Demanda máxima inyectada (W)',
        positiveReactiveEnergy_Wh: 'Energía reactiva positiva (kWh)',
        negativeReactiveEnergy_Wh: 'Energía reactiva negativa (kWh)',
        forderTotalizer_Wh: 'Energía activa directa T1 (kWh)',
        generatedOffBorderEnergyTotal_Wh: 'Energía activa generada fuera de punta (kWh)',
        generatedIntermediaryEnergyTotal_Wh: 'Energía activa generada intermediaria (kWh)',
        generatedBorderEnergyTotal_Wh: 'Energía activa generada punta (kWh)',
        generatedReservedEnergyTotal_Wh: 'Energía activa generada reservada (kWh)',
      },
      alarms: {
        dateEvent: 'Fecha evento',
        description: 'Descripción',
        serial: 'Serial',
        installation: 'Instalación',
        terminal: 'Terminal',
      },
    },
    meters: {
      title: 'Medidores',
      importMeters: 'Importar Medidores',
      importFromTo: 'Importar De-Para',
      editMeters: 'Editar Medidores',
      linkTags: 'Vincular Tags',
      unlinkTags: 'Desvincular Tags',
      commissioning: 'Comissionamento',
      serial: 'Serial',
      installation: 'Instalación',
      modemSignalQuality: 'Señal',
      updatedAt: 'Actualizado en',
      readingsCount: 'Cantidad de Lecturas',
      totalOfSent: 'Total de Envios',
      successOfSent: 'Envios de éxito',
      accountantStatus: 'Situación',
      failOfSent: 'Envios de fallo',
      deviceEui: 'Device Eui',
      meterPhase: 'Fase',
      manufacturer: 'Fabricante',
      position: 'Posición',
      commands: 'Comandos',
      tags: 'Etiquetas',
      firmware: 'Firmware',
      phase: 'Fase',
      communication: 'Comunicación',
      status: 'Estado',
      fromTo: 'De-Para',
    },
    smcs: {
      title: 'Smcs',
      serial: 'Serial',
      qtyMeters: 'Cantidad',
      firmware: 'Firmware',
      comissioned: 'Comisionado',
      doorStatus: 'Puerta',
      online: 'Estado de comunicación',
      smcModel: 'Marca',
      signalQuality: 'Señal',
      updatedAt: 'Última Actualización',
    },
    alarms: {
      title: 'Alarmas',
      serial: 'Serial',
      description: 'Descripción',
      dateTime: 'Fecha y Hora',
      alarmType: 'Tipo de Alarma',
      selectAlarmType: 'Seleccionar tipo de alarma',
      terminal: 'Terminal',
      updatedAt: 'Última actualización',
      isCritical: 'Alarma Crítica',
      errors: {
        error: 'Error',
        incompleteMeterData: 'Datos del medidor incompletos para exportación',
      },
    },
    smcAlarms: {
      title: 'Alarmes del SMC',
      readDateTime: 'Fecha y Hora de lectura',
      description: 'Descripción',
      updatedAt: 'Última actualización',
    },
    meterAlarms: {
      title: 'Alarmes de los Medidores',
      readDateTime: 'Fecha y Hora de lectura',
      description: 'Descripción',
      updatedAt: 'Última actualización',
      serial: 'Serial',
      terminal: 'Terminal',
    },
    alarmTypesMeter: {
      title: 'Tabla de Eventos SMI/Medidores SMC',
      description: 'Descripción',
      count: 'Cantidad',
      wasRead: 'Lectura',
      read: 'Leído',
      unread: 'No Leído',
      errorSearch: 'Error al buscar tipos de alarmas',
    },
    alarmTypesSmc: {
      title: 'Tabla de Eventos SMC',
      description: 'Descripción',
      count: 'Cantidad',
      wasRead: 'Lectura',
      read: 'Leído',
      unread: 'No Leído',
      errorSearch: 'Error al buscar tipos de alarmas',
    },
    tickets: {
      title: 'Tickets',
      serial: 'Serial',
      commandType: 'Comando',
      ticketStatus: 'Estado del Ticket',
      selectTicketStatus: 'Seleccione el estado del ticket',
      generatedBySystem: 'Generados por el sistema',
      statusCommand: 'Estado del Comando',
      lastUpdate: 'Última actualización',
      initialDate: 'Inicio',
      updatedAt: 'Actualizado en',
      serialMeter: 'Serial del Medidor',
      user: 'Usuario responsable',
      scheduledTickets: 'Tickets Agendados',
      scheduledDate: 'Fecha Programada',
      company: 'Empresa',
      manufacturer: 'Fabricante',
      deadline: 'Deadline',
      startDate: 'Inicio de la Ejecución',
      trackingCode: 'Código',
      serviceType: 'Tipo de Servicio',
      status: 'Status del SAP',
      commandTicket: {
        commandId: 'ID del Comando',
        commandType: 'Tipo de Comando',
        initialDate: 'Inicio',
        finishDate: 'Fin',
        attempt: 'Número de intentos',
        messageSent: 'Mensaje enviado',
        messageReceived: 'Mensaje recibido',
        messageError: 'Mensaje de error',
        messageSuccess: 'Mensaje de éxito',
        noResponse: 'Sin respuesta',
        totalData: 'Total de Datos',
        saved: 'Guardados',
        failedProcesses: 'Procesos con fallas',
        answerColumns: {
          answer: 'Respuesta',
          lineNumber: 'Línea',
          operation: 'Operación',
          success: 'Éxito',
          message: 'Mensaje',
          processedAt: 'Procesado en',
          position: 'Posición',
          totalEnergy: 'Energía total',
          relayStatus: 'Estado del relé',
          accountantStatus: 'Estado del relé',
          serial: 'Serial',
          datetime: 'Fecha/Hora',
          group2VoltageVaH_V: 'Tensión VaH(V)',
          group3CurrentIaH_A: 'Corriente IaH(A)',
          group2VoltageVbH_V: 'Tensión VbH(V)',
          group3CurrentIbH_A: 'Corriente IbH(A)',
          group2VoltageVcH_V: 'Tensión VcH(V)',
          group3CurrentIcH_A: 'Corriente IcH(A)',
          group4AngleUiA_deg: 'Ángulo UiA(º)',
          group4AngleUiB_deg: 'Ángulo UiB(º)',
          group4AngleUiC_deg: 'Ángulo UiC(º)',
          index: 'Índice',
          specialDayDate: 'Fecha especial',
          dayOfWeek: 'Día de la semana',
          dayId: 'ID del día',
          meterId: 'ID del medidor',
          type: 'Tipo',
          name: 'Nombre',
          description: 'Descripción',
          time: 'Hora',
          tariffType: 'Tipo de tarifa',
          dailyTariffs: 'Tarifas diarias',
          hourlyTariffs: 'Tarifas horarias',
          drmcDailyTariffs: 'Tarifas diarias DMCR',
          drmcHourlyTariff: 'Tarifas horarias DMCR',
          dmcrType: 'Tipo DMCR',
          hourlyDMCRs: 'DMCRs horarios',
          meterProfileId: 'ID del perfil del medidor',
          meterDMCRProfileId: 'ID del perfil DMCR del medidor',
          startDate: 'Fecha de inicio',
          endDate: 'Fecha de fin',
          deviation: 'Desviación',
          isEnable: 'Activo',
          enabled: 'Activo',
          saturdayInductive: 'Sábado inductivo',
          saturdayCapacitive: 'Sábado capacitivo',
          sundayInductive: 'Domingo inductivo',
          sundayCapacitive: 'Domingo capacitivo',
          workdayInductive: 'Día hábil inductivo',
          workdayCapacitive: 'Día hábil capacitivo',
          holidayInductive: 'Feriado inductivo',
          holidayCapacitive: 'Feriado capacitivo',
          timeToActivate: 'Tiempo de activación',
          daylightEndDatetime: 'Fecha/Hora de fin del horario de verano',
          daylightBeginDatetime: 'Fecha/Hora de inicio del horario de verano',
        },
      },
    },
    frozenData: {
      title: 'Totalizadores de Energía',
      recoverButton: 'Solicitar Totalizadores de Energía',
      errors: {
        error: 'Error',
        incompleteMeterData: 'Datos del medidor incompletos para exportación',
      },
    },
    massMemory: {
      title: 'Memoria de Masa',
      recoverButton: 'Solicitar Memoria de Masa',
      errors: {
        error: 'Error',
        incompleteMeterData: 'Datos del medidor incompletos para exportación',
      },
    },
    tableFiscalFasional: {
      title: 'Página Fiscal',
    },
    billing: {
      title: 'Histórico de Facturación',
      billing: 'Facturación',
      stageCode: 'Etapa',
      stageDay: 'Dia',
      dateSent: 'Enviado el',
      status: 'Estado',
      type: 'Tipo',
      typeCode: 'Tipo de código',
      readingDate: 'Fecha de lectura',
      readingValue: 'Valor de lectura',
      registers: 'Registradores',
    },
    eventLogs: {
      title: 'Registros de Eventos',
      dateTime: 'Fecha y Hora',
      message: 'Mensaje',
      logLevel: 'Nivel de Log',
      logs: {
        critical: 'Crítico',
        debug: 'Debug',
        error: 'Error',
        trace: 'Detallada ( Apenas Degub )',
        warning: 'Aviso',
        none: 'Sin mensaje',
        information: 'Información',
      },
      errors: {
        getEventLogs: 'Error al obtener los logs de eventos',
        serialRequired: 'El serial es requerido',
      },
    },
    alarmVoltage: {
      titleShortDuration: 'Alarmas de Interrupción de corta duración',
      titleLongDuration: 'Alarmas de de Interrupción larga duración',
      calculateInterruptionIndicators: 'Calcular Indicadores de Interrupción',
      referenceMonth: 'Mes de referencia',
      calculate: 'Calcular',
      fic: 'FIC',
      dic: 'DIC',
      hours: 'Horas',
      hundredthHour: 'Centésimos de horas',
      minutes: 'Minutos',
      ficTooltip: 'Frecuencia de Interrupción Individual por Unidad de Consumo o Punto de Conexión',
      dicTooltip:
        'Duración de Interrupción Individual por Unidad de Consumo o Punto de Conexión expresada en Horas',
      dicHundredthHourTooltip:
        'Duración de Interrupción Individual por Unidad de Consumo o Punto de Conexión expresada en Centésimos de Horas',
      dateTime: 'Fecha de Lectura',
      voltageOut: 'Voltaje',
      createdAt: 'Creado en',
      dateTimeStart: 'Fecha y Hora de Inicio',
      dateTimeEnd: 'Fecha y Hora de Fin',
      timeVariation: 'Variación de Tiempo',
    },
    alarmsMeters: {
      title: 'Alarmes de los Medidores',
    },
    qeeIndicators: {
      title: 'Parámetros de Calidad',
      monthlyAverage: 'Media Mensual',
      recoverQualityParams: 'Recuperar parámetros de calidad',
      calculateMonthlyAverage: 'Calcular media mensual',
      dateAndTimeInitial: 'Fecha y Hora inicial',
      dateAndTimeFinal: 'Fecha y Hora final',
      referenceMonth: 'Mes de Referencia',
      meterStatus: 'Estado del Medidor',
      onlineStatus: 'Estado Online',
      description: 'Descripción',
      commissioned: 'Comissionado',
      dateTime: 'Fecha y hora',
      drp: 'DRP',
      drc: 'DRC',
      dic: 'DIC',
      fic: 'FIC',
      dmic: 'DMIC',
      dmicOccurrenceTime: 'Hora de Ocurrencia DMIC',
      noInformation: 'Sin información',
      dialog: {
        referenceMonth: 'Mes de Referencia',
        quantityOfSamples: 'Cantidad de muestras deseadas',
        initialDate: 'Fecha Inicial del Conjunto',
        endDate: 'Fecha Final del Conjunto',
        drp: 'DRP',
        drc: 'DRC',
        dtt95: 'DTT95',
        fd95: 'FD95',
        drcPhaseA: 'DRC Fase A',
        drpPhaseA: 'DRP Fase A',
        drcPhaseB: 'DRC Fase B',
        drpPhaseB: 'DRP Fase B',
        drcPhaseC: 'DRC Fase C',
        drpPhaseC: 'DRP Fase C',
        calculate: 'Calcular',
        cancel: 'Cancelar',
        request: 'Solicitar',
        requestSentTitle: 'Solicitud Enviada',
        requestSentSuccess: 'Media mensual solicitada con éxito',
        requestSentError: 'No fue posible solicitar la Media Mensual',
        relayOff: 'Relé apagado',
        relayOffDescription: 'No fue posible solicitar la media mensual para este medidor',
        noQualityParametersFound: 'No se encontró ningún parámetro de calidad para el medidor',
      },
      placeholders: {
        referenceMonth: 'Seleccione el mes de referencia',
      },
      errors: {
        incompleteMeterData: 'Datos del medidor incompletos para exportación',
      },
    },
    instantMeasure: {
      title: 'Mediciones Instantáneas',
      requestMeasure: 'Solicitar lecturas',
      readingTime: 'Hora de lectura',
      voltageVa: 'Tensión Va (V)',
      voltageVb: 'Tensión Vb (V)',
      voltageVc: 'Tensión Vc (V)',
      currentIa: 'Corriente Ia (A)',
      currentIb: 'Corriente Ib (A)',
      currentIc: 'Corriente Ic (A)',
      angleUiA: 'Ángulo Ui A (º)',
      angleUiB: 'Ángulo Ui B (º)',
      angleUiC: 'Ángulo Ui C (º)',
    },
    firmware: {
      lastUpdate: 'Última actualización',
      crc: 'CRC',
      name: 'Nombre',
      manufacturer: 'Fabricante',
    },
    keys: {
      lastUpdate: 'Última actualización',
      serial: 'Serial',
      authenticationKey: 'Clave de Autenticación',
      encryptionKey: 'Clave de Cifrado',
      masterKey: 'Clave Maestra',
      lls2: 'LLS2',
    },
    tags: {
      lastUpdate: 'Última Actualización',
      tagId: 'ID de la Etiqueta',
      name: 'Nombre',
      colorCode: 'Color (Código Hexadecimal)',
      colors: 'Colores',
    },
    models: {
      name: 'Nombre',
      manufacturer: 'Fabricante',
      positionsCount: 'Cant. de posiciones',
    },
    clients: {
      title: 'Clientes',
      newClient: 'Nuevo Cliente',
      deleteClients: 'Eliminar Clientes',
      name: 'Nombre',
      location: 'Ubicación',
      statusActive: 'Activo',
      quantityMeterSerials: 'Cantidad de Medidores',
      updatedAt: 'Última actualización',
      weights: 'Pesos',
      prefixUf: 'Prefijo UF',
    },
    process: {
      title: 'Procesos',
      processId: 'ID del Proceso',
      processType: 'Tipo de Proceso',
      user: 'Usuario',
    },
    balanceDevices: {
      title: 'Balance de los Dispositivos',
      trafo: 'Trafo',
      device: 'Dispositivo',
      initialDate: 'Fecha Energía Consumida Inicial',
      initialReading: 'Lectura Inicial Energía Consumida (kWh)',
      finalDate: 'Fecha Energía Consumida Final',
      finalReading: 'Lectura Final Energía Consumida (kWh)',
      consumption: 'Consumo (kWh)',
      energyInjectedConsumers: 'Energía Inyectada (kWh)',
      energyReverseTransformer: 'Energía Reversa (kWh)',
    },
    balanceTransformers: {
      title: 'Balance de los Transformadores',
      date: 'Fecha',
      nameTrafo: 'Nombre del Trafo',
      trafoMeter: 'Medidor del Trafo',
      energyRequired: 'Energía Requerida (kWh)',
      energyConsumed: 'Energía Consumida (kWh)',
      loss: 'Pérdida (kWh)',
      streetLighting: 'Energía IP (kWh)',
      lossPercentage: 'Pérdida %',
    },
    balanceAreasRegions: {
      title: 'Balance de las Áreas',
      data: 'Fecha',
      nameArea: 'Nombre del Área',
      energyRequired: 'Energía Requerida (kWh)',
      energyConsumed: 'Energía Consumida (kWh)',
      loss: 'Pérdida (kWh)',
      streetLighting: 'Energía pública (kWh)',
      lossPercentage: 'Pérdida %',
    },
    transformers: {
      title: 'Transformadores',
      newTransformer: 'Nuevo Transformador',
      deleteTransformers: 'Exclusión de Transformadores',
      name: 'Nombre',
      description: 'Descripción',
      publicLighting: 'Iluminación Pública Mensual (kWh)',
      trafoMeter: 'Medidor Trafo',
      connected: 'Conectados',
      latLong: 'Lat/Long',
      updatedAt: 'Última actualización',
      errorSearch: 'Error al buscar Transformadores',
      noTransformerSelected: 'Ningún transformador seleccionado',
    },
    scheduledCommands: {
      group: 'Grupo',
      command: 'Comando',
      executionTime: 'Tiempo de Ejecución',
      status: 'Estado',
      nextExecution: 'Próxima Ejecución',
      active: 'Activo',
      paused: 'Pausado',
      pausedScheduling: 'Programación Pausada',
      scheduling: 'programación',
      errorSearch: 'Error al buscar programaciones',
      noScheduleSelected: 'Ninguna programación seleccionada',
      noSchedule: 'Ninguna programación registrada',
      deleteSchedule: 'Eliminación de Programación',
      newRoutine: 'Programar Comando',
    },
    lowEffectiveness: {
      title: 'Ubicaciones con Baja Efectividad',
      locationCode: 'Código de Ubicación',
      regionCode: 'Código de Región',
      estado: 'Estado',
      cidade: 'Ciudad',
      totalMeters: 'Total de Medidores',
      lowEffectivenessMeters: 'Medidores con Baja Efectividad',
      lowEffectivenessPercent: 'Porcentaje de Baja Efectividad',
      effectivenessPercent: 'Porcentaje de Efectividad',
      errorSearch: 'Error al buscar ubicaciones con baja efectividad',
      tabs: {
        state: 'Por Estado',
        city: 'Por Ciudad',
      },
    },
    unavailabilityPeak: {
      title: 'Pico de Indisponibilidad',
      meter: 'Medidor',
      consumerUnit: 'Unidad Consumidora',
      locationCode: 'Código de Ubicación',
      regionCode: 'Código de Región',
      manufacturer: 'Fabricante',
      unavailableDays: 'Días Indisponibles',
      totalDays: 'Total de Días',
      unavailabilityPercent: 'Porcentaje de Indisponibilidad',
      availabilityPercent: 'Porcentaje de Disponibilidad',
      errorSearch: 'Error al buscar picos de indisponibilidad',
    },
    areas: {
      title: 'Áreas',
      newArea: 'Nova Área',
      name: 'Nombre',
      description: 'Descripción',
      transformersCount: 'Cantidad de Transformadores',
      updatedAt: 'Última actualización',
      deleteAreas: 'Exclusión de Áreas',
      errors: {
        title: 'Error',
        loadAreaInfo: 'Error al buscar información de la área',
        noAreaSelected: 'Ninguna área seleccionada',
      },
      areasTransformers: {
        title: 'Transformadores de la Área',
        manageTransformers: 'Gestionar transformadores',
        name: 'Nombre',
        serialMeter: 'Serial del Medidor',
        metersCount: 'Cantidad de Medidores',
        publicLighting: 'Iluminación Pública',
        coordinates: 'Coordenadas',
        updatedAt: 'Última actualización',
      },
    },
    regions: {
      title: 'Regiones',
      newRegion: 'Nueva Región',
      deleteRegions: 'Exclusión de Regiones',
      name: 'Nombre',
      description: 'Descripción',
      areasCount: 'Cantidad de Áreas',
      updatedAt: 'Última actualización',
      errors: {
        title: 'Error',
        loadRegions: 'Error al buscar regiones',
        noRegionSelected: 'Ninguna región seleccionada',
      },
    },
    regionsAreas: {
      title: 'Áreas de la Región',
      manageAreas: 'Gestionar áreas',
      name: 'Nombre',
      description: 'Descripción',
      transformersCount: 'Cantidad de Transformadores',
      updatedAt: 'Última actualización',
    },
    transformerMeters: {
      title: 'Medidores del Transformador',
      importMeters: 'Importar medidores por archivo',
      removeMeters: 'Remover medidores por archivo',
      manageMeters: 'Gestionar medidores',
      importNameModal: 'modelo-medidores-por-transformador-registro',
      removeNameModal: 'modelo-medidores-por-transformador-remocao',
      meter: 'medidor(es)',
      success: {
        registerMeters: 'Medidores registrados con éxito',
        removeMeters: 'Medidores removidos con éxito',
      },
      errors: {
        registerMeters: 'Error al registrar medidores',
        removeMeters: 'Error al remover medidores',
        metersNotRegistered: 'medidor(es) no pudieron ser registrados',
        unknownReason: 'Motivo desconocido',
      },
      warnings: {
        partialSuccess: 'Registro parcial de medidores',
        metersNotUpdated: 'medidor(es) no fueron actualizados',
      },
    },
  },
  echarts: {
    noteType: {
      title: 'Tipo de Servicio',
      services: 'Servicios',
      regions: 'Regiones',
      manufactures: 'Fabricantes',
    },
    sapStatus: {
      title: 'Estado SAP',
      services: 'Servicios',
      regions: 'Regiones',
      manufactures: 'Fabricantes',
    },
    requestStatus: {
      title: 'Estado Comando',
      status: 'Estado',
      services: 'Servicios',
      regions: 'Regiones',
      manufactures: 'Fabricantes',
    },
    eqtlIntegrationByCompany: {
      title: 'Integración EQTL por Compañía',
      success: 'Éxito',
      failure: 'Fallo',
      serviceType: 'Tipo de Servicio',
      cleanFilter: 'Limpiar Filtro',
      addFilter: 'Agregar Filtro',
    },
    integrationDaily: {
      title: 'Integración Diaria',
      success: 'Éxito',
      failure: 'Fallo',
      select: 'Seleccione una Distribuidora',
      company: 'Distribuidora',
      serviceType: 'Tipo de Servicio',
    },
    failedNotesByCategory: {
      title: 'Fallo por categoría',
    },
    failedNotesByCategoryDaily: {
      title: 'Notas con fallo por categoría (diario)',
    },
    specificFailedNotes: {
      title: 'Fallo específico',
    },
    table: {
      title: 'Listado de la columna',
      createdAt: 'Creado el',
      updatedAt: 'Actualizado el',
      startDate: 'Inicio de la Ejecución',
      actionType: 'Tipo de acción',
      status: 'Estado',
      company: 'Región',
      manufacturer: 'Fabricante',
      meterSerial: 'Serial',
      trackingCode: 'Seguimiento',
    },
    effectiveness: {
      title: 'Efectividad y Disponibilidad',
      manufacturers: 'Fabricantes',
      manufacturersPlaceholder: 'Seleccione los fabricantes',
      networkTech: 'Tecnología de Red',
      cityOrState: 'Ciudad / Estado',
      cityOrStatePlaceholder: 'Ingrese el nombre de la ciudad/estado',
      state: 'Estado',
      statePlaceholder: 'Seleccione el estado',
      city: 'Ciudad',
      cityPlaceholder: 'Seleccione la ciudad',
      quickOptions: 'Opciones rápidas:',
      quickOptionsHint: 'Máximo de 30 días',
      lastDays: 'Últimos {count} días',
      meterRegion: {
        serial: 'Serial',
        regionCode: 'Código de Región',
        districtCode: 'Código de Distrito',
        sectionCode: 'Código de Sección',
        locationTypeCode: 'Código de Tipo de Ubicación',
        locationCode: 'Código de Ubicación',
        fullAddress: 'Dirección Completa',
        city: 'Ciudad',
        feeder: 'Alimentador',
        districtName: 'Nombre del Distrito',
        neighborhood: 'Barrio',
        regional: 'Regional',
        sectional: 'Seccional',
      },
    },
    process: {
      title: 'Estado',
      success: 'Éxito',
      failed: 'Fallido',
      waiting: 'Esperando',
      executing: 'Ejecutando',
      scheduled: 'Programado',
    },
    status: {
      title: 'Status',
      statusOnline: 'Online',
      statusOffline: 'Offline',
      statusAbsent: 'Ausente',
    },
    commission: {
      title: 'Comissionamento',
      commissionOn: 'Comisionado',
      commissionOff: 'No Comissionado',
      commissionOns: 'Comissionados',
      commissionOffs: 'No Comissionados',
    },
    situation: {
      title: 'Situación',
      disabled: 'Desconectado',
      activated: 'Conectado',
      noRelay: 'Sin Relé',
      noInformation: 'Sin Información',
      titleNoMeters: 'Tabla de Situación - Medidores',
    },
    billing: {
      title: 'Información sobre la facturación',
      status: 'Estado',
      success: 'Éxito',
      noReadings: 'Sin lecturas',
      noReadingsDescription: 'No se encontraron lecturas disponibles para la facturación.',
      withReadings: 'Con lecturas',
      withReadingsDescription:
        'Había lecturas, pero ocurrió un error al enviarlas al sistema comercial.',
      withoutStage: 'Sin etapa',
      withoutStageDescription: 'Aún no hay etapa de facturación asignada a este medidor.',
      scheduled: 'Agendado',
      scheduledDescription:
        'Facturación programada para una fecha futura dentro del período definido.',
      notStarted: 'Facturación no iniciada',
      notStartedDescription: 'La fecha de facturación ya pasó y el proceso no se ejecutó.',
      successDescription: 'Facturación realizada con éxito, sin ocurrencias de errores.',
    },
    signalQuality: {
      signal: 'Señal',
      title: 'Calidad de la señal',
      period: 'Período',
      dateRange: 'Intervalo de fechas',
      fiveBars: '5 Barras',
      fourBars: '4 Barras',
      threeBars: '3 Barras',
      twoBars: '2 Barras',
      oneBar: '1 Barra',
      unregistered: 'Sin registro',
      metersWith: 'Medidores con',
    },
    commandsSent: {
      title: 'Comandos Enviados',
    },
    statusCommand: {
      title: 'Todos los Comandos',
      noData: 'No hay datos',
    },
    alarmStatisticMeter: {
      title: 'Eventos SMI/Medidores del SMC',
      read: 'Leídos',
      unread: 'No leídos',
    },
    alarmStatisticSmc: {
      title: 'Eventos SMC',
      read: 'Leídos',
      unread: 'No leídos',
    },
    fiscalPage: {
      title: 'Página Fiscal',
      noData: 'No hay datos disponibles',
      noDataOnInterval: 'No hay datos para el intervalo seleccionado',
      noDataChart: 'Sin datos',
      requestFiscalPage: 'Solicitar Página Fiscal',
      value: 'Valor',
      phaseA: 'Fase A',
      phaseB: 'Fase B',
      phaseC: 'Fase C',
      packageDate: 'Fecha del paquete',
      frequency: 'Frecuencia (Hz)',
      voltage: 'Tensión (V)',
      angleVI: 'Angulo VI (°)',
      angleVoltage: 'Angulo Tensión (°)',
      anglePhase: 'Angulo Fase (AB/BC/CA °)',
      current: 'Corriente',
      currentAngle: 'Angulo Corrente (°)',
      activePower: 'Potencia Activa (W)',
      reactivePower: 'Potencia Reactiva (VAR)',
      powerFactor: 'Factor de Potencia',
      legend: {
        angVoltageA: 'Angulo Tensión A',
        angVoltageB: 'Angulo Tensión B',
        angVoltageC: 'Angulo Tensión C',
        angVIA: 'Angulo VI A',
        angVIB: 'Angulo VI B',
        angVIC: 'Angulo VI C',
        angPhaseAB: 'Angulo Fase AB',
        angPhaseBC: 'Angulo Fase BC',
        angPhaseCA: 'Angulo Fase CA',
        angPhaseAC: 'Angulo Fase AC',
        currentAngleA: 'Angulo Corrente A',
        currentAngleB: 'Angulo Corrente B',
        currentAngleC: 'Angulo Corrente C',
      },
    },
  },
  notifications: {
    effectiveness: {
      success: {
        updateConfig: '¡Configuración de efectividad actualizada con éxito!',
      },
      error: {
        updateConfig: 'Error al actualizar la configuración de efectividad.',
        getConfig: 'Error al buscar la configuración de efectividad.',
      },
    },
    averageVariation: {
      success: {
        updateConfig: '¡Configuración actualizada con éxito!',
      },
      error: {
        updateConfig: 'Error al actualizar la configuración.',
        getConfig: 'Error al buscar la configuración.',
      },
    },
    tickets: {
      success: {
        getTickets: 'Tickets buscados con éxito',
      },
      error: {
        getTickets: 'Error al buscar Tickets',
      },
    },
    fiscalPage: {
      success: {
        getFiscalPage: 'Página fiscal recuperada con éxito',
      },
      error: {
        getFiscalPage: 'Error al recuperar página fiscal',
      },
    },
    recoverEnergy: {
      success: {
        recoverEnergy: 'Totalizadores de energia recuperados con éxito',
      },
      error: {
        recoverEnergy: 'Error al recuperar totalizadores de energia',
      },
    },
    recoverMassMemory: {
      success: {
        recoverMassMemory: 'Memoria de masa solicitada con éxito',
      },
      error: {
        recoverMassMemory: 'Error al solicitar memoria de masa',
      },
    },
    onlineHistoryInterval: {
      success: {
        updateConfig: 'Intervalo atualizado com sucesso!',
      },
      error: {
        updateConfig: 'Falha ao atualizar o intervalo',
        getConfig: 'Falha ao buscar a configuração de intervalo.',
      },
    },
  },
  dialogs: {
    deleteMass: {
      title: 'Confirmar eliminación en masa',
      message: '¿Está seguro de que desea eliminar los elementos seleccionados?',
      confirmButton: 'Sí, eliminar',
      cancelButton: 'Cancelar',
    },
    recoverByRangeDate: {
      title: 'Enviar comando',
      description: 'Seleccione el intervalo de fechas',
      placeholder: 'Intervalo de fechas',
      confirmButton: 'Requisitar',
      cancelButton: 'Cancelar',
    },
    importModal: {
      downloadModel: 'Descargar Modelo',
      chooseFile: 'Elegir Archivo',
      fileNotSelected: 'Archivo no seleccionado',
      validateFile: 'Validar Archivo',
      importItems: 'Importar Elementos',
      viewValidatedItems: 'Ver Elementos Validados',
      viewIgnoredItems: 'Ver Elementos Ignorados',
      serialWhitespaceError:
        'El serial no puede contener espacios al inicio, en el medio ni al final. Filas inválidas: {rows}.',
    },
    gatewayForm: {
      createTitle: 'Registro de Gateway',
      editTitle: 'Edición de Gateway',
      name: 'Nombre:',
      nameRequired: 'El nombre es obligatorio',
      serial: 'Serial:',
      serialRequired: 'El serial es obligatorio',
      ipAddress: 'Dirección IP:',
      ipInvalid: 'IP inválido',
      port: 'Puerto:',
      description: 'Descripción:',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      successTitle: 'Éxito',
      errorTitle: 'Error',
      createSuccess: 'Gateway agregado',
      createError: 'Error al crear el Gateway: {message}',
      updateSuccess: 'Gateway actualizado',
      updateErrorTitle: 'Error al actualizar el Gateway',
    },
    groupCreateModal: {
      title: 'Crear Grupo',
      name: 'Nombre',
      description: 'Descripción',
      tags: 'Tags',
      tagsPlaceholder: 'Seleccione las tags',
      meters: 'Medidores',
      cancel: 'Cancelar',
      create: 'Crear Grupo',
      position: 'Posición',
      relayStatus: 'Estado del Relé',
      communicationStatus: 'Estado de Comunicación',
      deviceEui: 'Device EUI',
      firmwareVersion: 'Versión del Firmware',
      phase: 'Fase',
      commandStatus: 'Estado de los Comandos',
      installation: 'Instalación',
      manufacturer: 'Fabricante',
      serial: 'Serial',
      commands: 'Comandos',
      updatedAt: 'Última Actualización',
      createdTitle: 'Grupo creado',
      createdDetail: 'Grupo creado con éxito',
    },
    deleteGroupModal: {
      title: 'Eliminar Grupos',
      cancel: 'Cancelar',
      confirm: 'Eliminar Grupos',
      noneSelected: 'Ningún grupo seleccionado',
      confirmQuestion: '¿Está seguro de que desea eliminar los grupos',
      deletedTitle: 'Grupo {name} eliminado',
      deletedDetail: 'Grupo eliminado con éxito',
      deleteErrorTitle: 'Error al eliminar el grupo {name}',
      deleteErrorDetail: 'Error al eliminar el grupo',
    },
    massCommandsToMeters: {
      title: 'Comandos en Masa',
      steps: {
        search: 'Buscar',
        validate: 'Validar',
        commands: 'Comandos',
        parameters: 'Parámetros',
      },
      tabs: {
        search: 'Por Búsqueda',
        import: 'Por Importación',
      },
      searchPlaceholder: 'Búsqueda',
      searchTypePlaceholder: 'Tipo de Búsqueda',
      searchTypes: {
        serial: 'Serial',
        installation: 'Instalación',
        manufacturer: 'Fabricante',
      },
      relayStatusPlaceholder: 'Estado del Relé',
      noSerialFound: 'Ningún Serial Encontrado',
      next: 'Siguiente',
      back: 'Volver',
      actions: 'Acciones',
      startDate: 'Fecha Inicial',
      endDate: 'Fecha Final',
      startDateParam: 'Fecha Inicial (Parámetro)',
      endDateParam: 'Fecha Final (Parámetro)',
      sendingCommand: 'Enviando Comando',
      selectParameters: 'Seleccionar Parámetros',
      sendCommand: 'Enviar Comando',
      intervalPlaceholder: 'Seleccione el intervalo',
      valuesPlaceholder: 'Seleccione los valores',
      minutes: '{count} Minutos',
    },
    massTagsToMeters: {
      linkTitle: 'Vincular Tags',
      unlinkTitle: 'Desvincular Tags',
      steps: {
        tags: 'Tags',
        import: 'Importar',
      },
      tagsPlaceholder: 'Seleccione las tags',
      selectTagsHint: 'Seleccione al menos una tag para continuar.',
      next: 'Siguiente',
      back: 'Volver',
      selectedTagsCount: '{count} tag(s) seleccionada(s).',
      finishLink: 'Finalizar vinculación',
      finishUnlink: 'Finalizar desvinculación',
      noFileSelected: 'Ningún archivo seleccionado.',
      emptySerialError: 'El archivo contiene filas con el campo Serial vacío.',
      fileValidatedSuccess: 'Archivo validado con éxito',
      fileValidatedWithIgnored:
        'Archivo validado con éxito, pero {count} fila(s) inválida(s) fueron ignoradas.',
      fileProcessError: 'Error al procesar el archivo',
      noValidSerials: 'No se encontró ningún serial válido en el archivo.',
      linkError: 'No fue posible vincular las tags a los medidores.',
      unlinkError: 'No fue posible desvincular las tags de los medidores.',
      success: {
        linksCreated: '{affectedLinks} vínculo(s) creado(s) en {processedMeters} medidor(es).',
        linksRemoved: '{affectedLinks} vínculo(s) eliminado(s) de {processedMeters} medidor(es).',
        notFoundSerials: '{count} serial(es) no encontrado(s).',
        notFoundTagIds: '{count} tag(s) no encontrada(s).',
      },
    },
    dialogTransformer: {},
    dialogArea: {
      titleNewArea: 'Nueva Área',
      titleEditArea: 'Editar Área',
      name: 'Nombre',
      fieldRequired: 'Este campo es obligatorio!',
      description: 'Descripción',
      delete: 'Eliminar',
      cancel: 'Cancelar',
      modify: 'Modificar',
      register: 'Registrar',
      success: {
        title: 'Éxito',
        createArea: 'Área creada con éxito!',
        updateArea: 'Área actualizada con éxito!',
      },
      error: {
        title: 'Error',
        createArea: 'Error al crear área',
        updateArea: 'Error al actualizar área',
      },
    },
    dialogRegion: {
      editRegion: 'Editar región',
      createRegion: 'Crear región',
      title: 'Gestionar transformadores de la región',
      name: 'Nombre',
      fieldRequired: 'Este campo es obligatorio!',
      description: 'Descripción',
      deleteRegion: 'Eliminar',
      cancel: 'Cancelar',
      modify: 'Modificar',
      register: 'Registrar',
      success: {
        title: 'Éxito',
        createRegion: 'Región creada con éxito!',
        updateRegion: 'Región actualizada con éxito!',
      },
      error: {
        title: 'Erro',
        createRegion: 'Error al crear región',
        updateRegion: 'Error al actualizar región',
      },
    },
    dialogNewEditAreasInRegion: {
      title: 'Gestionar áreas de la región',
      areasInRegion: 'Áreas en la Región',
      total: 'Total',
      availableAreas: 'Áreas Disponibles',
      available: 'Disponibles',
      selected: 'Seleccionadas',
      removeAreas: 'Remover Áreas',
      addAreas: 'Agregar Áreas',
      exit: 'Salir',
      name: 'Nombre',
      description: 'Descripción',
      transformersCount: 'Transformadores',
      updatedAt: 'Última actualización',
      success: {
        title: 'Éxito',
        addAreas: 'Áreas agregadas con éxito!',
        removeAreas: 'Áreas eliminadas con éxito!',
      },
      errors: {
        title: 'Erro',
        loadAvailableAreas: 'Error al cargar áreas disponibles',
        addAreas: 'Error al agregar áreas a la región',
        removeAreas: 'Error al remover áreas de la región',
      },
    },
    dialogNewEditTransformersInArea: {
      title: 'Gestionar transformadores de la área',
      transformersInArea: 'Transformadores en la Área',
      total: 'Total',
      availableTransformers: 'Transformadores Disponibles',
      available: 'Disponibles',
      selected: 'Seleccionados',
      removeTransformers: 'Remover Transformadores',
      addTransformers: 'Agregar Transformadores',
      exit: 'Salir',
      name: 'Nombre',
      serialMeter: 'Serial del Medidor',
      meters: 'Medidores',
      updatedAt: 'Última actualización',
      success: {
        title: 'Éxito',
        addTransformers: 'Transformadores agregados con éxito!',
        removeTransformers: 'Transformadores removidos con éxito!',
      },
      errors: {
        title: 'Erro',
        loadAvailableTransformers: 'Error al cargar transformadores disponibles',
        addTransformers: 'Error al agregar transformadores a la área',
        removeTransformers: 'Error al remover transformadores de la área',
      },
    },
    dialogNewEditMetersInTransformer: {
      title: 'Gestionar medidores del transformador',
      registeredMeters: 'Medidores Registrados',
      availableMeters: 'Medidores Disponibles',
      total: 'Total',
      available: 'Disponibles',
      selected: 'Seleccionados',
      removeMeters: 'Remover Medidores',
      registerMeters: 'Registrar Medidores',
      exit: 'Salir',
      serialMeter: 'Serial del Medidor',
      manufacturer: 'Fabricante',
      phase: 'Fase',
      signalQuality: 'Calidad de la señal',
      success: {
        title: 'Éxito',
        registerMeters: 'Medidores registrados con éxito',
        removeMeters: 'Medidores removidos con éxito',
      },
      errors: {
        title: 'Erro',
        registerMeters: 'Error al registrar medidores',
        removeMeters: 'Error al remover medidores',
      },
    },
    dialogNewEditTransformer: {
      editTransformer: 'Editar Transformador',
      registerTransformer: 'Registrar Transformador',
      requiredField: 'Este campo es obligatorio!',
      requiredFields: 'Rellene todos los campos obligatorios',
      name: 'Nombre',
      publicLighting: 'Iluminación Pública Mensual (kWh)',
      latitude: 'Latitude',
      longitude: 'Longitude',
      readingMeter: 'Medidor de Leitura',
      searchPlaceholder: 'Buscar por nombre, fabricante o serial',
      description: 'Descripción',
      cancel: 'Cancelar',
      modify: 'Modificar',
      register: 'Registrar',
      success: {
        title: 'Éxito',
        createTransformer: 'Transformador creado con éxito!',
        updateTransformer: 'Transformador actualizado con éxito!',
      },
      errors: {
        title: 'Erro',
        createTransformer: 'Error al crear transformador',
        updateTransformer: 'Error al actualizar transformador',
      },
    },
    dialogCancelTicket: {
      title: 'Cancelar ejecución del ticket',
      message: '¿Desea cancelar la ejecución de este ticket?',
      ticketLabel: 'Ticket',
      commandLabel: 'Comando',
      close: 'Cerrar',
      cancelTicket: 'Cancelar Ticket',
      success: {
        title: 'Éxito',
        message: '¡Cancelación ejecutada con éxito!',
      },
      error: {
        title: 'Error',
        message: 'Error al cancelar ticket',
      },
      notCancellable: {
        title: 'No fue posible cancelar',
        message: 'El ticket ya está en ejecución y no puede ser cancelado.',
        messageWithStatus: 'El ticket ya no puede ser cancelado, su estado actual es "{status}".',
      },
      statusCheckError: {
        title: 'No fue posible cancelar',
        message: 'Error al consultar el estado actual del ticket. Intente nuevamente.',
      },
    },
    dialogReprocessServiceNote: {
      label: 'Reprocesar nota de servicio',
      title: 'Confirmar Reprocesamiento',
      message: '¿Está seguro de que desea reprocesar esta nota de servicio?',
      cancelReprocess: 'Cancelar',
      confirmReprocess: 'Confirmar',
      success: {
        title: 'Éxito',
        message: '¡Reprocesamiento ejecutado con éxito!',
      },
      error: {
        title: 'Error',
        message: 'Error al reprocesar la nota de servicio',
      },
    },
  },
  general: {
    cancel: 'Cancelar',
    save: 'Guardar',
    meter: 'Medidor',
    meters: 'Medidores',
    serial: 'Serial',
    attention: 'Atención',
    noInformation: 'Sin Información',
    notAvailable: 'No disponible',
    noDataFound: 'Ningún dato encontrado',
    itemsFound: 'elementos encontrados',
    actionsFile: 'Acciones desde archivo',
    consumerUnit: 'Unidad Consumidora',
    yes: 'Si',
    no: 'No',
    exit: 'Salir',
    myAccount: 'Mi cuenta',
    editMyAccount: 'Editar mi cuenta',
    edit: 'Editar',
    update: 'Actualizar',
    error: 'Error',
    success: 'Éxito',
    profileUpdated: 'Perfil actualizado con éxito.',
    errorUpdatingProfile: 'Error al actualizar perfil',
    greeting: 'Hola,',
    email: 'Correo electrónico',
    description: 'Descripción',
    receiveEmails: 'Recibir correos electrónicos',
    changingClient: 'Cambiando de cliente...',
    selectClient: 'Seleccione el cliente',
    search: 'Buscar...',
    loading: 'Cargando...',
    maximizeMap: 'Maximizar Mapa',
    minimizeMap: 'Minimizar Mapa',
    veeSeverity: {
      info: 'Informativo',
      issue: 'Atención',
      terminate: 'Crítico',
    },
    validation: {
      requiredFields: 'Verifique los campos obligatorios antes de continuar.',
      meterSerialRequired: 'El serial del medidor es obligatorio.',
      manufacturerRequired: 'El fabricante es obligatorio.',
      phaseRequired: 'La fase es obligatoria.',
      meterModelRequired: 'El modelo es obligatorio.',
      meterTypeRequired: 'El tipo de medidor es obligatorio.',
      rateTypeRequired: 'El tipo de tarifa es obligatorio.',
      installationRequired: 'El código de instalación es obligatorio.',
      connectionPhaseRequired: 'La fase de conexión es obligatoria.',
      serialCannotContainSpaces:
        'El serial no puede contener espacios al inicio, en el medio ni al final.',
      meterSerialCannotContainSpaces:
        'El serial del medidor no puede contener espacios al inicio, en el medio ni al final.',
      smcSerialCannotContainSpaces:
        'El serial del SMC no puede contener espacios al inicio, en el medio ni al final.',
      meterRegistersRequired: 'Los registradores son obligatorios.',
      clientIdRequired: 'El ID del cliente es obligatorio.',
    },
    comissionedType: {
      all: 'Todos',
      comissioned: 'Comissionado',
      notComissioned: 'No Comissionado',
      notRegistered: 'No Registrado',
    },
    meterTypes: {
      all: 'Todos',
      nepen: 'Integración MDX',
      integration: 'Integración',
      integrationDcu: 'Integración Wasion DCU',
    },
    meterActivated: {
      activated: 'Conectado',
      notActivated: 'Desconectado',
      deactivateConfirmation: '¿Desea desconectar este relé?',
      activateConfirmation: '¿Desea conectar este relé?',
      deactivateMessage: 'Comando de Desconexión de Relé Enviado',
      activateMessage: 'Comando de Conexión de Relé Enviado',
    },
    doorStatus: {
      authorized: 'Autorizado',
      unauthorized: 'Desautorizado',
    },
    communicationStatus: {
      noInformation: 'No Información',
      success: 'Éxito',
      busy: 'Ocupado',
      communicationFailed: 'Falla de Comunicación',
      online: 'Online',
      waiting: 'Esperando',
      offline: 'Offline',
      pending: 'Pendiente',
    },
    signalQuality: {
      neverSeen: 'Nunca Visto',
      veryWeak: 'Muy Fraco (1 Barra)',
      weak: 'Fraco (2 Barras)',
      reasonable: 'Razonable (3 Barras)',
      strong: 'Fuerte (4 Barras)',
      excellent: 'Excelente (5 Barras)',
    },
    signalQualityBars: {
      fiveBars: '5 Barras',
      fourBars: '4 Barras',
      threeBars: '3 Barras',
      twoBars: '2 Barras',
      oneBar: '1 Barra',
    },
    signalQualityLabel: {
      neverSeen: 'Nunca Visto',
      veryWeak: 'Muy Fraco',
      weak: 'Fraco',
      reasonable: 'Razonable',
      strong: 'Fuerte',
      excellent: 'Excelente',
    },
    datePickerExecutionFilter: 'Filtro por fecha de inicio de ejecución',
  },
  manufacturerFilter: {
    label: 'Fabricantes',
    placeholder: 'Todos los fabricantes',
    loading: 'Cargando fabricantes...',
  },
  globalFilterComponent: {
    title: 'Filtros',
    period: 'Período',
    command: 'Tipo de comando',
    cleanButton: 'Limpiar',
    applyButton: 'Aplicar',
    datePlaceholder: 'dd/mm/aaaa - dd/mm/aaaa',
    selectPlaceholder: 'Seleccione...',
    allPlaceholder: 'Todos',
    selectCommands: 'Seleccione los comandos',
  },
  alarmsFilter: {
    title: 'Filtros',
    tags: 'Etiquetas',
    tagsPlaceholder: 'Seleccione las etiquetas...',
    period: 'Período',
    datePlaceholder: 'dd/mm/aaaa - dd/mm/aaaa',
    quickOptions: 'Opciones rápidas:',
    quickOptionsHint: 'seleccione un período sugerido',
    quickDays: '{count} días',
    quickMonth: '1 mes',
    longRangeHint:
      'Los períodos libres superiores a 90 días requieren confirmación antes de aplicar.',
    status: 'Estado',
    statusPlaceholder: 'Todos',
    statusRead: 'Leído',
    statusUnread: 'No Leído',
    cleanButton: 'Limpiar',
    applyButton: 'Aplicar',
    longRangeTitle: 'Período extenso',
    longRangeMessage:
      'Los períodos superiores a 90 días pueden tardar un poco más en cargar. ¿Desea continuar?',
    cancelButton: 'Cancelar',
    continueButton: 'Continuar',
  },
  parametrization: {
    parametrization: 'Parametrización',
    manageParams: 'Gestionar Parámetros',
    searchBySerial: 'Buscar por Serial',
    unity: 'Unidad de Consumo',
    manufacturer: 'Fabricante',
    actions: 'Acciones',
    commands: {
      timeParams: 'Parámetros Relacionados con el Tiempo',
      createDataTemplate: 'Crear Plantilla de Fecha',
      requestHolidays: 'Solicitar Feriados',
      createHolidayTemplate: 'Crear Plantilla de Feriado',
      deleteHolidayTemplate: 'Eliminar Plantilla de Feriado',
      activateProfileActivityCalendar: 'Definir Estado del Perfil',
      addActivateTime: 'Agregar Tiempo de Activación',
      sendTarrifPassiveCalendar: 'Enviar Calendario Pasivo de Tarifas',
      requestActivateTimeProfilePassiveActivityCalendar:
        'Solicitar Tiempo de Activación del Calendario Pasivo',
      dmrcParams: 'Parámetros Relacionados con la Electricidad',
      setDmrcActiveStatus: 'Definir Estado del Perfil DMCR',
      setDmrcActivateTime: 'Agregar Tiempo de Activación DMCR',
      requestDmrcDayProfilePassive: 'Solicitar Tiempo de Activación del Calendario Pasivo DMCR',
      addDmrcDayPassiveCalendar: 'Agregar Día al Calendario Pasivo DMCR',
      setDmrcSwitch: 'Configurar Switch DMCR y UFER',
      requestDmrcSwitch: 'Solicitar Switch DMCR y UFER',
      readings: 'Parámetros Relacionados con Demandas',
      recoverRegisters: 'Recuperar Registros',
      getGeneralReadings: 'Recuperar Lecturas Generales',
    },
    daylightSavingTable: 'Horarios Registrados',
    finalDate: 'Fecha Inicial',
    endDate: 'Fecha Final',
    deviation: 'Desviación (minutos)',
    isEnable: 'Activo',
    confirmDelete: 'Confirmar Eliminación',
    deleteConfirmationMessage: '¿Desea realmente eliminar este horario?',
    deleteTarrifConfirmationMessage: '¿Desea realmente eliminar esta tarifa?',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    tarrifsTable: 'Tarifas Diarias',
    createDailyTariff: 'Crear Tarifa Diaria',
    day: 'Día',
    name: 'Nombre',
    description: 'Descripción',
    meterProfile: 'Perfil del Medidor',
    numberOfSchedules: 'Cantidad de Horarios',
    activateProfileActivityCalendar: 'Definir Estado del Perfil',
    serial: 'Serial',
    meter: 'Medidor',
    value: 'Valor',
    addTimeForActivation: 'Agregar Tiempo de Activación',
    activationDateTime: 'Fecha y Hora de Activación',
    save: 'Guardar',
    createDmrcCalendar: 'Crear Calendario DMCR',
    dayId: 'ID del Día',
    annualHoliday: 'Feriado anual',
    time: 'Horario',
    dmcrType: 'Tipo DMCR',
    createHolidayTemplate: 'Crear Plantilla de Feriado',
    deleteHolidayTemplate: 'Eliminar Plantilla de Feriado',
    holidayDate: 'Fecha del Feriado',
    index: 'Índice',
    addHoliday: 'Agregar Feriado',
    addIndex: 'Agregar índice',
    createDailyTariffTemplate: 'Crear Plantilla de Tarifa Diaria',
    hourlyTariffs: 'Tarifas por Horario',
    add: 'Agregar',
    tariffType: 'Tipo de Tarifa',
    createTimePeriodTemplate: 'Crear Plantilla de Período de Tiempo',
    deviationMinutes: 'Desviación (minutos)',
    active: 'Activo',
    dmcrSwitchConfiguration: 'Configuración del Switch DMCR',
    saturday: 'Sábado',
    sunday: 'Domingo',
    holiday: 'Feriado',
    workday: 'Día Laboral',
    capacitive: 'Capacitivo',
    inductive: 'Inductivo',
    send: 'Enviar',
    demandReading: 'Lectura de Demanda',
    demandTypes: 'Tipos de Demanda',
    selectDemands: 'Seleccione las demandas',
    generalReadings: 'Lecturas Generales',
    readings: 'Lecturas',
    selectReadings: 'Seleccione las lecturas',
    sendTariffPassiveCalendar: 'Enviar Calendario Pasivo de Tarifas',
    dailyTariffs: 'Tarifas Diarias',
    confirm: 'Confirmar',
    startDate: 'Fecha de Inicio',
    addDmrcActivateTime: 'Agregar Tiempo de Activación DMCR',
    setDmrcActiveStatus: 'Definir Estado del Perfil DMCR',
    editDailyTariff: 'Editar Tarifa Diaria',
    editTimePeriodTemplate: 'Editar Plantilla de Fecha',
    createTimePeriod: {
      title: 'Reemplazar registro existente',
      message:
        'Este medidor ya tiene un período de tiempo configurado. ¿Desea reemplazar el registro actual con la nueva información?',
    },
  },
  errors: {
    unauthorized: 'No tienes permiso para realizar esta acción.',
    notImplemented:
      'Acción no disponible en este momento. Este método aún no ha sido integrado al sistema.',
    deviceNotIdentified:
      'Dispositivo no identificado. Verifica si el serial está registrado e inténtalo de nuevo.',
    badRequest: 'Solicitud inválida. Verifica los datos informados.',
    notFound: 'Recurso no encontrado o ruta no disponible.',
    conflict: 'Conflicto de datos. Inténtalo de nuevo.',
    validation: 'Hay campos inválidos. Verifica los datos informados.',
    server: 'Error interno del servidor. Inténtalo de nuevo más tarde.',
    network: 'No fue posible conectar con el servidor. Verifica tu conexión e inténtalo de nuevo.',
    generic: 'Ocurrió un error al procesar tu solicitud.',
    noValidClient: {
      title: 'Sin acceso',
      detail: 'Es necesario tener un cliente seleccionado para esta operación.',
    },
  },
  demands: {
    0: 'Energía activa importada total acumulada',
    1: 'Energía activa importada acumulada (tarifa 1)',
    2: 'Energía activa importada acumulada (tarifa 2)',
    3: 'Energía activa importada acumulada (tarifa 3)',
    4: 'Energía activa importada acumulada (tarifa 4)',
    5: 'Energía activa exportada total acumulada',
    6: 'Energía activa exportada acumulada (tarifa 1)',
    7: 'Energía activa exportada acumulada (tarifa 2)',
    8: 'Energía activa exportada acumulada (tarifa 3)',
    9: 'Energía activa exportada acumulada (tarifa 4)',
    10: 'Demanda actual de energía activa importada total',
    11: 'Demanda actual de energía activa importada (tarifa 1)',
    12: 'Demanda actual de energía activa importada (tarifa 2)',
    13: 'Demanda actual de energía activa importada (tarifa 3)',
    14: 'Demanda actual de energía activa importada (tarifa 4)',
    15: 'Demanda actual de energía activa exportada total',
    16: 'Demanda actual de energía activa exportada (tarifa 1)',
    17: 'Demanda actual de energía activa exportada (tarifa 2)',
    18: 'Demanda actual de energía activa exportada (tarifa 3)',
    19: 'Demanda actual de energía activa exportada (tarifa 4)',
    20: 'Demanda máxima de energía activa importada total',
    21: 'Demanda máxima de energía activa importada (tarifa 1)',
    22: 'Demanda máxima de energía activa importada (tarifa 2)',
    23: 'Demanda máxima de energía activa importada (tarifa 3)',
    24: 'Demanda máxima de energía activa importada (tarifa 4)',
    25: 'Demanda máxima de energía activa exportada total',
    26: 'Demanda máxima de energía activa exportada (tarifa 1)',
    27: 'Demanda máxima de energía activa exportada (tarifa 2)',
    28: 'Demanda máxima de energía activa exportada (tarifa 3)',
    29: 'Demanda máxima de energía activa exportada (tarifa 4)',
  },
  generalReadings: {
    0: 'Estado de la batería',
    1: 'Contador de facturación cerrado',
    2: 'Totalizador directo - General',
    3: 'Totalizador directo - Punta',
    4: 'Totalizador directo - Valle',
    5: 'Totalizador directo - Reservado',
    6: 'Totalizador directo - 4º período',
    7: 'Totalizador inverso - General',
    8: 'Totalizador inverso - Punta',
    9: 'Totalizador inverso - Valle',
    10: 'Totalizador inverso - Reservado',
    11: 'Totalizador inverso - Reservado',
    12: 'Reactiva inductiva directa - General',
    13: 'Reactiva inductiva directa - Punta',
    14: 'Reactiva inductiva directa - Valle',
    15: 'Reactiva inductiva directa - Reservado',
    16: 'Reactiva inductiva directa - 4º período',
    17: 'Reactiva capacitiva directa - General',
    18: 'Reactiva capacitiva directa - Punta',
    19: 'Reactiva capacitiva directa - Valle',
    20: 'Reactiva capacitiva directa - Reservado',
    21: 'Reactiva capacitiva directa - 4º período',
    22: 'Reactiva inductiva inversa - General',
    23: 'Reactiva inductiva inversa - Punta',
    24: 'Reactiva inductiva inversa - Valle',
    25: 'Reactiva inductiva inversa - Reservado',
    26: 'Reactiva inductiva inversa - 4º período',
    27: 'Reactiva capacitiva inversa - General',
    28: 'Reactiva capacitiva inversa - Punta',
    29: 'Reactiva capacitiva inversa - Valle',
    30: 'Reactiva capacitiva inversa - Reservado',
    31: 'Reactiva capacitiva inversa - 4º período',
    32: 'Demanda máxima - Directa total',
    33: 'Demanda máxima - Directa punta',
    34: 'Demanda máxima - Directa valle',
    35: 'Demanda máxima - Directa reservado',
    36: 'Demanda máxima - Directa tipo D',
    37: 'Demanda acumulada - Directa total',
    38: 'Demanda acumulada - Directa punta',
    39: 'Demanda acumulada - Directa valle',
    40: 'Demanda acumulada - Directa reservado',
    41: 'Demanda acumulada - Directa tipo D',
    42: 'Demanda máxima - Inversa total (punta)',
    43: 'Demanda máxima - Inversa punta',
    44: 'Demanda máxima - Inversa valle',
    45: 'Demanda máxima - Inversa reservado',
    46: 'Demanda máxima - Inversa tipo D',
    47: 'Demanda acumulada - Inversa total',
    48: 'Demanda acumulada - Inversa punta',
    49: 'Demanda acumulada - Inversa valle',
    50: 'Demanda acumulada - Inversa reservado',
    51: 'Demanda acumulada - Inversa tipo D',
    52: 'Total',
    53: 'Punta',
    54: 'Valle',
    55: 'Reservado',
    56: 'Punta',
    57: 'Valle',
    58: 'Reservado',
    59: 'Punta',
    60: 'Valle',
    61: 'Reservado',
  },
  qualityParameters: {
    drpViolationsChartTitle: 'Medidores por Violación DRP',
    serial: 'Serial',
    installation: 'Instalación',
    selectPeriod: 'Seleccionar Período',
    serialPlaceholder: 'Ingrese serial del medidor',
    installationPlaceholder: 'Buscar por instalación',
    searching: 'Buscando...',
    noResults: 'No se encontraron resultados',
    filters: 'Filtros',
    pendencies: 'Pendientes',
    meterWithoutReadings: 'Medidores sin lecturas',
    noData: 'No hay datos para ser exibidos',
    loading: 'Cargando',
    installationsAboveDicLimit: 'Instalaciones sobre el límite DIC',
    installationsAboveFicLimit: 'Instalaciones sobre el límite FIC',
    averageBaseDic: 'DIC Promedio Base',
    averageBaseFic: 'FIC Promedio Base',
    badInstalations: 'Instalaciones con Peores Indicadores',
    dic: 'DIC',
    fic: 'FIC',
    dicLimit: 'Límite DIC',
    ficLimit: 'Límite FIC',
    ficRegion: 'Región (FIC)',
    status: 'Estado',
    drcViolation: 'Medidores por Violación DRC',
    tensionVariation: 'Variación de Tensión Promedio Mensual',
    readingsByMonth: 'Lecturas por Mes',
    drpDrcAverage: 'Promedio Mensual DRP/DRC',
    drpDrcViolations: 'Violación Promedio DRP/DRC',
    monthlyDicFic: 'Valor Mensual DIC/FIC',
    interruptions: 'Interrupción de Energía',
    installationsAboveDrpLimit: 'Instalaciones por encima del límite de DRP',
    installationsAboveDrcLimit: 'Instalaciones por encima del límite de DRC',
    averageBaseDrp: 'DRP Medio Base',
    averageBaseDrc: 'DRC Medio Base',
    drp: 'DRP Mensual (%)',
    drc: 'DRC Mensual (%)',
    drpLimit: 'Límite de DRP',
    drcLimit: 'Límite de DRC',
    drpViolation: 'Violación DRP Mensual (%)',
    drcViolationT: 'Violación DRC Mensual (%)',
    statusGood: 'Bueno',
    statusAdequate: 'Adecuada',
    statusPrecarious: 'Precaria',
    statusCritical: 'Crítica',
    drpUpTo20: 'DRP hasta 20%',
    drpUpTo40: 'DRP hasta 40%',
    drpUpTo60: 'DRP hasta 60%',
    drpUpTo80: 'DRP hasta 80%',
    drpUpTo100: 'DRP 100%',
    drcUpTo20: 'DRC hasta 20%',
    drcUpTo40: 'DRC hasta 40%',
    drcUpTo60: 'DRC hasta 60%',
    drcUpTo80: 'DRC hasta 80%',
    drcUpTo100: 'DRC 100%',
    noInformation: 'Sin Información',
    categories: 'Categorías',
    selectCategories: 'Seleccionar categorías',
    state: 'Estado',
    city: 'Ciudad',
    selectState: 'Seleccione el estado',
    selectCity: 'Seleccione la ciudad',
    clear: 'Limpiar',
    apply: 'Aplicar',
    averageVoltage: 'Tensión Media',
    readings: 'Lecturas',
    voltage: 'Tensión',
    viewChart: 'Ver Gráfico',
    viewTable: 'Ver Tabla',
    exportMonthlySummary: 'Exportar Resumen Mensual',
    byMonth: 'Por Mes',
    byWeek: 'Por Semana',
    meters: 'Medidores',
    day: 'Día',
    week: 'Semana',
    drpPercent: 'DRP %',
    drcPercent: 'DRC %',
    drcViolationPercent: 'VIOLACIÓN DRC %',
    drpViolationPercent: 'VIOLACIÓN DRP %',
    dicHours: 'DIC (Horas)',
    dmicHours: 'DMIC (Horas)',
    drpBand20: 'DRP hasta 20%',
    drpBand40: 'DRP hasta 40%',
    drpBand60: 'DRP hasta 60%',
    drpBand80: 'DRP hasta 80%',
    drpBand100: 'DRP 100%',
    drcBand20: 'DRC hasta 20%',
    drcBand40: 'DRC hasta 40%',
    drcBand60: 'DRC hasta 60%',
    drcBand80: 'DRC hasta 80%',
    drcBand100: 'DRC 100%',
    averageV: 'Promedio (V)',
    phaseA: 'Fase A (V)',
    phaseB: 'Fase B (V)',
    phaseC: 'Fase C (V)',
    violationDrc: 'Violación DRC',
    violationDrp: 'Violación DRP',
    totalFicEvents: 'Total FIC (Eventos)',
    meterQuantity: 'Cant. Medidores',
    dicHoursCompact: 'DIC (Horas)',
    dmicHoursCompact: 'DMIC (Horas)',
    detailedIndicators: 'Indicadores Detallados',
    detailedDrpDrcViolations: 'Violaciones DRP/DRC Detalladas',
    detailedDicFic: 'Detalle DIC/FIC',
    detailedTensionLevels: 'Niveles de Tensión Detallados',
    averageDrp: 'DRP Promedio',
    averageDrc: 'DRC Promedio',
    createdAt: 'Fecha de Creación',
    manufacturer: 'Fabricante',
    model: 'Modelo',
    dateTime: 'Fecha/Hora',
    voltageReading: 'Lectura de Tensión',
    generalV: 'General (V)',
  },
}
